import _objectWithoutProperties from "J:\\xe6\\Gaub\\gaub_app\\gaub_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "J:\\xe6\\Gaub\\gaub_app\\gaub_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _toConsumableArray from "J:\\xe6\\Gaub\\gaub_app\\gaub_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _assertThisInitialized from "J:\\xe6\\Gaub\\gaub_app\\gaub_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _slicedToArray from "J:\\xe6\\Gaub\\gaub_app\\gaub_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "J:\\xe6\\Gaub\\gaub_app\\gaub_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "J:\\xe6\\Gaub\\gaub_app\\gaub_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "J:\\xe6\\Gaub\\gaub_app\\gaub_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "J:\\xe6\\Gaub\\gaub_app\\gaub_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "J:\\xe6\\Gaub\\gaub_app\\gaub_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

var _ETipoCampo$;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component, Fragment } from 'react';
import { withStyles, ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment';
import $ from 'jquery';
import Linkify from 'react-linkify';
import Typography$1 from '@material-ui/core/Typography';
import 'crypto-js';
import clsx$1 from 'clsx';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import 'moment/locale/it';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import CancelIcon from '@material-ui/icons/Cancel';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import ButtonBase from '@material-ui/core/ButtonBase';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import '@material-ui/core/ListSubheader';
import { CircularProgress as CircularProgress$1 } from '@material-ui/core';
import lightBlue from '@material-ui/core/colors/lightBlue';
import MaskedInput from 'react-text-mask';
import NumberFormat from 'react-number-format';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { Prompt, Switch, Route } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import MaterialTable from 'material-table';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import DoneIcon from '@material-ui/icons/Done';
import AddIcon from '@material-ui/icons/Add';
import SwipeableViews from 'react-swipeable-views';
import teal from '@material-ui/core/colors/teal';
import AsyncCreatable from 'react-select/async-creatable';
var GulpContext = React.createContext();

var GulpApp =
/*#__PURE__*/
function (_Component) {
  _inherits(GulpApp, _Component);

  function GulpApp(props) {
    _classCallCheck(this, GulpApp);

    return _possibleConstructorReturn(this, _getPrototypeOf(GulpApp).call(this, props));
  }

  _createClass(GulpApp, [{
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        React.createElement(GulpContext.Provider, {
          value: this.props.gA
        }, this.props.children)
      );
    }
  }]);

  return GulpApp;
}(Component);

var styles = function styles(theme) {
  return {
    modale: {
      display: 'flex',
      justifyContent: "center",
      alignItems: "center"
    },
    progr: {
      borderWidth: 0,
      borderStyle: 'none',
      outlineWidth: 0,
      outlineStyle: 'none'
    }
  };
};

var Attesa =
/*#__PURE__*/
function (_Component2) {
  _inherits(Attesa, _Component2);

  function Attesa(props) {
    _classCallCheck(this, Attesa);

    return _possibleConstructorReturn(this, _getPrototypeOf(Attesa).call(this, props));
  }

  _createClass(Attesa, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return (
        /*#__PURE__*/
        React.createElement(Modal, {
          className: classes.modale,
          open: this.props.open
        },
        /*#__PURE__*/
        React.createElement(CircularProgress, {
          disableShrink: true,
          className: classes.progr,
          size: 100,
          color: "secondary"
        }))
      );
    }
  }]);

  return Attesa;
}(Component);

var Attesa$1 = withStyles(styles, {
  withTheme: true
})(Attesa);

var styles$1 = function styles$1(theme) {
  return {
    modale: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderWidth: 2
    }
  };
};

var Messaggio =
/*#__PURE__*/
function (_Component3) {
  _inherits(Messaggio, _Component3);

  function Messaggio(props) {
    var _this;

    _classCallCheck(this, Messaggio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Messaggio).call(this, props));
    _this.dBottoni = [];
    return _this;
  }

  _createClass(Messaggio, [{
    key: "handleClose",
    value: function handleClose(key) {
      this.props.onClose(key);
    }
  }, {
    key: "render",
    value: function render() {
      var bottoni = this.props.bottoni;
      this.dBottoni = [];

      if (bottoni === undefined) {
        this.dBottoni.push(
        /*#__PURE__*/
        React.createElement(Button, {
          key: "ok",
          onClick: this.handleClose.bind(this, 'ok'),
          variant: "contained",
          color: "secondary"
        }, "OK"));
      } else {
        for (var key in bottoni) {
          this.dBottoni.push(
          /*#__PURE__*/
          React.createElement(Button, {
            key: key,
            onClick: this.handleClose.bind(this, key),
            variant: "contained",
            color: "secondary"
          }, bottoni[key]));
        }
      }

      return (
        /*#__PURE__*/
        React.createElement(Dialog, {
          open: this.props.open,
          "aria-labelledby": "alert-dialog-title",
          "aria-describedby": "alert-dialog-description"
        },
        /*#__PURE__*/
        React.createElement(DialogTitle, {
          id: "alert-dialog-title"
        }, this.props.titolo),
        /*#__PURE__*/
        React.createElement(DialogContent, null,
        /*#__PURE__*/
        React.createElement(DialogContentText, {
          id: "alert-dialog-description"
        }, this.props.testo)),
        /*#__PURE__*/
        React.createElement(DialogActions, null, this.dBottoni))
      );
    }
  }]);

  return Messaggio;
}(Component);

var Messaggio$1 = withStyles(styles$1, {
  withTheme: true
})(Messaggio);

var StringTokenizerG =
/*#__PURE__*/
function () {
  function StringTokenizerG(stringa, delimitatori) {
    _classCallCheck(this, StringTokenizerG);

    this.mStringa = stringa;
    this.mDelimitatori = delimitatori;
    this.posizione = 0;
  }

  _createClass(StringTokenizerG, [{
    key: "nextToken",
    value: function nextToken(delimitatori) {
      var r = "";
      this.mDelimitatori = delimitatori;
      var inStringa = false;

      while (this.posizione < this.mStringa.length) {
        if (this.mStringa.charAt(this.posizione) === '"') inStringa = !inStringa;

        if (!inStringa && this.mDelimitatori.length > 0 && this.mDelimitatori.indexOf(this.mStringa.substring(this.posizione, this.posizione + 1)) > -1) {
          this.posizione++;
          break;
        }

        r += this.mStringa.charAt(this.posizione++);
      }

      if (r.length > 0 && r.charAt(0) === '"') {
        return r.substring(1, r.length - 1);
      }

      return r;
    }
  }, {
    key: "hasMoreTokens",
    value: function hasMoreTokens() {
      if (this.mStringa == null) return false;
      if (this.posizione < this.mStringa.length) return true;else return false;
    }
  }]);

  return StringTokenizerG;
}();

var _t = {
  it: {
    add: 'Nuovo',
    memorizza: 'Salva',
    annulla: 'Annulla',
    cancella: 'Cancella',
    username: 'Nome utente',
    password: 'Password',
    passwordErrata: 'Utente o Password errata',
    entra: 'Entra',
    select: 'seleziona...',
    noResult: 'Nessun risultato trovato.',
    stoCercando: 'Caricamento...',
    scriviPerCercare: 'Scrivi per cercare...',
    esportacsv: 'Esporta in CSV',
    nodata: 'Non esistono elementi da visualizzare',
    fatto: 'Fatto',
    creaRecord: 'Aggiungi ',
    serverNonDisponibile: 'Server non disponibile, riprovare più tardi.',
    attendere: 'Attendere...',
    vuoto: 'Clicca per caricare una foto',
    oggi: 'Oggi',
    sessioneScaduta: "Sessione scaduta, è necessario rifare il login",
    salvaPassword: "Memorizza la password",
    ricordami: 'Resta connesso',
    cancellazione: "Cancellazione",
    confermaCancellazione: "Vuoi realmente cancellare?",
    modificaParametri: "Impostazioni",
    abbandonoModifiche: "Si desidera realmente abbandonare le modifiche?",
    tokenScaduto: "Tempo di connessione scaduto, è necessario rifare il login",
    galleria: "Seleziona un'immagine",
    uploadImmagine: "Carica una immagine",
    scegliImmagine: "Scegli una immagine da galleria",
    cancellaImmagine: "Cancella l'immagine",
    esci: "Esci",
    impostazioni: "Impostazioni"
  },
  en: {
    add: 'New',
    memorizza: 'Save',
    annulla: 'Cancel',
    cancella: 'Delete',
    username: 'Username',
    password: 'Password',
    passwordErrata: 'Username or Password is wrong',
    entra: 'Login',
    stoCercando: 'Loading...',
    select: 'select...',
    noResult: 'No result found',
    scriviPerCercare: 'Type to search...',
    esportacsv: 'Export in CSV',
    nodata: 'There is no data to display',
    fatto: 'Done',
    creaRecord: 'Add',
    serverNonDisponibile: 'Server not online, retry after.',
    attendere: 'Please Wait...',
    vuoto: 'Click for upload photo...',
    oggi: 'Today',
    sessioneScaduta: "Expired session, you need to login again",
    salvaPassword: "Save the password",
    ricordami: 'Remember me',
    cancellazione: "Delete",
    confermaCancellazione: "Do You want really delete?",
    modificaParametri: "Settings",
    abbandonoModifiche: "Do you really want to abandon the changes?",
    tokenScaduto: "Connection time expired, login is required",
    galleria: "Select a picture",
    uploadImmagine: "Upload a picture",
    scegliImmagine: "Select a picture from gallery",
    cancellaImmagine: "Delete picture",
    esci: "Exit",
    impostazioni: "Settings"
  }
};
var gA = {};
var procUtils = {
  myLog: function myLog(messaggio) {
    console.log(messaggio);
  },
  GetNomeCampo: function GetNomeCampo(nomecampo) {
    var l = nomecampo.toLowerCase().indexOf(" as ");

    if (l > -1) {
      nomecampo = nomecampo.substring(l + 4);
    }

    l = nomecampo.indexOf(".");

    if (l > -1) {
      nomecampo = nomecampo.substring(l + 1);
    }

    return nomecampo;
  },
  Parsing: function Parsing(stringa, delimiter) {
    var elementi = [];
    var t = new StringTokenizerG(stringa, delimiter);

    while (t.hasMoreTokens()) {
      elementi.push(t.nextToken(delimiter));
    }

    if (elementi.length === 0) elementi.push("");
    return elementi;
  },
  SostituisciVariabili: function SostituisciVariabili(espressione, oggetti) {
    var data;
    var giorni;

    if (espressione.length !== 0) {
      var p = 0;

      while (p !== -1) {
        p = espressione.indexOf("%data%+");

        if (p > -1) {
          var i = 0;

          for (i = p + 7; i < espressione.length; i++) {
            if ("0123456789".indexOf(espressione.substring(i, i + 1)) === -1) break;
          }

          giorni = parseInt(espressione.substring(p + 7, i));
          data = new Date();
          data.setDate(data.getDate() + giorni);
          var dd = moment(data);
          espressione = espressione.substring(0, p) + "'" + dd.format(oggetti.db.maskDate) + "'" + espressione.substring(i);
        } else {
          p = espressione.indexOf("%data%-");

          if (p > -1) {
            var _i = 0;

            for (_i = p + 7; _i < espressione.length(); _i++) {
              if ("0123456789".indexOf(espressione.substring(_i, _i + 1)) === -1) break;
            }

            giorni = parseInt(espressione.substring(p + 7, _i));
            data = new Date();
            data.setDate(data.getDate() - giorni);

            var _dd = moment(data);

            espressione = espressione.substring(0, p) + "'" + _dd.format(oggetti.db.maskDate) + "'" + espressione.substring(_i);
          } else {
            p = espressione.indexOf("%data%");

            if (p > -1) {
              data = new Date();

              var _dd2 = moment(data);

              espressione = espressione.substring(0, p) + "'" + _dd2.format(oggetti.db.maskDate) + "'" + espressione.substring(p + 6);
            } else {
              p = espressione.indexOf("%utente%");

              if (p > -1) {
                espressione = espressione.substring(0, p) + gA.parametri.codice_utente + espressione.substring(p + 8);
              } else {
                p = espressione.indexOf("%livello%");

                if (p > -1) {
                  espressione = espressione.substring(0, p) + gA.parametri.livello + espressione.substring(p + 9);
                } else {
                  p = espressione.indexOf("%precodice%");

                  if (p > -1) {
                    espressione = espressione.substring(0, p) + gA.mPrecodice + espressione.substring(p + 11);
                  } else {
                    p = espressione.indexOf(":");

                    if (p > -1) {
                      var f = this.fineVariabile(espressione, p + 1);
                      var variabile = espressione.substring(p + 1, f);
                      espressione = espressione.substring(0, p) + oggetti.variabili.Get(variabile) + espressione.substring(f);
                    } else {
                      p = espressione.indexOf("$");

                      if (p > -1) {
                        var _f = this.fineVariabile(espressione, p + 1);

                        var _variabile = espressione.substring(p + 1, _f);

                        espressione = espressione.substring(0, p) + gA.parametri.Get(_variabile) + espressione.substring(_f);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      return espressione;
    } else {
      return "";
    }
  },
  fineVariabile: function fineVariabile(espressione, inizio) {
    for (var i = inizio; i < espressione.length; i++) {
      if (" ()=+-".indexOf(espressione.substring(i, i + 1)) > -1) return i;
    }

    return espressione.length;
  },
  substring: function substring(stringa, inizio, fine) {
    if (stringa == null) {
      return "";
    }

    if (stringa.length < fine) {
      return stringa;
    }

    return stringa.substring(inizio, fine);
  },
  notNull: function notNull(s) {
    if (s == null) return "";
    return s;
  },
  IsTrue: function IsTrue(valore) {
    if (valore === null || valore.length === 0) return false;
    return valore === "V" || valore == 1;
  },
  syncRequest: function syncRequest(comando, params) {
    if (params == null) params = {};
    params.token = gA.token;
    var rs = {};
    rs.risultato = "NO";
    $.ajax({
      type: 'GET',
      url: gA.baseUrlServer + '/' + comando,
      async: false,
      crossOrigin: false,
      dataType: 'json',
      success: function success(result) {
        rs = result;
      },
      data: params,
      error: function error(x, y, z) {
        if (x.status === 404) {
          alert(_t[gA.lingua].sessioneScaduta);
          window.location = gA.dirUrl;
        } else {
          alert(x.responseText + '\n' + y + '\n' + z);
        }
      }
    });

    if (rs.risultato === 'NO') {
      alert("Errore: " + rs.errore);
    }

    return rs;
  },
  asyncRequest: function asyncRequest(callback, comando, params) {
    if (params == null) params = {};
    params.token = gA.token;
    var url = gA.baseUrlServer;

    if (gA.remotePath.length > 0) {
      if (gA.remotePath.indexOf('d:') > -1 || gA.remotePath.indexOf('ds:') > -1) {
        if (gA.remotePath.indexOf('d:') > -1) url = gA.remotePath.replace('d:', 'http:');else url = gA.remotePath.replace('ds:', 'https:');
      } else params.r = gA.remotePath;
    }

    $.ajax({
      type: 'GET',
      url: url + '/' + comando,
      async: true,
      crossOrigin: true,
      dataType: 'jsonp',
      success: callback,
      data: params,
      error: function error(x, y, z) {
        if (x.status === 404) {
          alert(_t[gA.lingua].sessioneScaduta);
          window.location = gA.dirUrl;
        } else {
          alert(x.responseText + '\n' + y + '\n' + z);
        }
      }
    });
  },
  asyncRequestOnServer: function asyncRequestOnServer(callback, comando, params) {
    if (params == null) params = {};
    params.token = gA.token;
    var url = gA.baseUrlServer;
    $.ajax({
      type: 'GET',
      url: url + '/' + comando,
      async: true,
      crossOrigin: true,
      dataType: 'jsonp',
      success: callback,
      data: params,
      error: function error(x, y, z) {
        if (x.status === 404) {
          alert(_t[gA.lingua].sessioneScaduta);
          window.location = gA.dirUrl;
        } else {
          alert(x.responseText + '\n' + y + '\n' + z);
        }
      }
    });
  },
  alert: function (_alert) {
    function alert(_x) {
      return _alert.apply(this, arguments);
    }

    alert.toString = function () {
      return _alert.toString();
    };

    return alert;
  }(function (msg) {
    if (process.env.NODE_ENV === 'development') {
      alert(msg);
    } else {
      alert(_t[gA.lingua].serverNonDisponibile);
    }
  }),
  avviso: function avviso(msg) {
    alert(msg);
  },
  urlParam: function urlParam(name) {
    return (window.location.search.split(name + '=')[1] || '').split('&')[0];
  },
  urlPath: function urlPath() {
    var url = window.location.pathname;
    return url.replace(gA.dirUrl, '');
  },
  xorString: function xorString(s, key) {
    var r = '';

    for (var i = 0; i < s.length; i++) {
      r += String.fromCharCode(s.charCodeAt(i) ^ key);
    }

    return r;
  },
  getScrollPosition: function getScrollPosition() {
    return {
      x: window.pageXOffset !== undefined ? window.pageXOffset : window.scrollLeft,
      y: window.pageYOffset !== undefined ? window.pageYOffset : window.scrollTop
    };
  },
  createFormDataWithPhoto: function createFormDataWithPhoto(photo, body) {
    var data = new FormData();

    if (photo != null) {
      data.append("file", photo);
    }

    Object.keys(body).forEach(function (key) {
      data.append(key, body[key]);
    });
    return data;
  },
  createFormData: function createFormData(body) {
    var data = new FormData();
    Object.keys(body).forEach(function (key) {
      data.append(key, body[key]);
    });
    return data;
  },
  createUrl: function createUrl(u, params) {
    var url = new URL(u);
    Object.keys(params).forEach(function (key) {
      return url.searchParams.append(key, params[key]);
    });
    return url;
  },
  isPwa: function isPwa() {
    var displayModes = ["fullscreen", "standalone", "minimal-ui"];
    return displayModes.some(function (displayMode) {
      return window.matchMedia('(display-mode: ' + displayMode + ')').matches;
    });
  },
  asyncRequestGet: function asyncRequestGet(comando, params) {
    if (params == null) params = {};
    params.token = gA.token;
    var url2 = gA.baseUrlServer;

    if (gA.remotePath.length > 0) {
      if (gA.remotePath.indexOf('d:') > -1 || gA.remotePath.indexOf('ds:') > -1) {
        if (gA.remotePath.indexOf('d:') > -1) url2 = gA.remotePath.replace('d:', 'http:');else url2 = gA.remotePath.replace('ds:', 'https:');
      } else params.r = gA.remotePath;
    }

    var url = procUtils.createUrl(url2 + '/' + comando, params);
    return fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    });
  },
  asyncRequestPost: function asyncRequestPost(comando, data) {
    if (data == null) data = {};
    return fetch(gA.baseUrlServer + '/' + comando, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'text/plain'
      },
      body: JSON.stringify({
        token: gA.token,
        data: data
      })
    });
  },
  splitInRighe: function splitInRighe(riga, variante, coloreLink) {
    if (riga !== undefined) {
      var righe = riga.split('\n');
      return righe.map(function (e, i) {
        return (
          /*#__PURE__*/
          React.createElement(Typography$1, {
            key: i,
            variant: variante
          },
          /*#__PURE__*/
          React.createElement(Linkify, {
            componentDecorator: function componentDecorator(decoratedHref, decoratedText, key) {
              return (
                /*#__PURE__*/
                React.createElement("a", {
                  target: "blank",
                  href: decoratedHref,
                  key: key,
                  style: {
                    color: coloreLink
                  }
                }, decoratedText)
              );
            }
          }, e))
        );
      });
    }
  }
};

var TAutenticazione =
/*#__PURE__*/
function () {
  function TAutenticazione() {
    _classCallCheck(this, TAutenticazione);

    this.callbackRisposta = null;
  }

  _createClass(TAutenticazione, [{
    key: "callback",
    value: function callback(risultato) {
      var r = {
        autorizzato: false
      };

      if (risultato.error != undefined) {
        if (!gA.isMobile) alert(risultato.error);
      } else {
        r.dataUltimoAccesso = moment(Date.now());

        if (risultato.codice_utente >= 0) {
          r.autorizzato = true;
          r.codice_utente = parseInt(risultato.codice_utente, 10);
          r.utente_supervisore = risultato.utente_supervisore;
          r.livello = parseInt(risultato.livello, 10);
          r.nominativo = risultato.nominativo;
          r.id_anag = parseInt(risultato.id_anag, 10);
          r.pathUrl = risultato.pathUrl;
          if (risultato.opzioni !== undefined) r.opzioni = risultato.opzioni;
          gA.token = risultato.token;
          gA.keyA = risultato.token.substring(0, 32);
          gA.iv = risultato.token.substring(6, 22);
          if (risultato.token2 !== undefined) gA.token2 = risultato.token2;
          var dd = moment(procUtils.notNull(risultato.data_ultimo_accesso), 'YYYY-MM-DD HH:mm:ss');

          if (dd.isValid()) {
            r.dataUltimoAccesso = dd;
          }
        } else {
          r.codice_utente = parseInt(risultato.codice_utente);
        }
      }

      this.callbackRisposta(r);
    }
  }, {
    key: "Autenticazione",
    value: function Autenticazione(callback, username, password, codice) {
      var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      this.callbackRisposta = callback;
      var params = {};
      if (data !== null) params = data;
      params.u = username;
      params.p = password;
      params.c = codice;
      params._ = moment().format('X');
      var url = gA.baseUrlServer;

      if (gA.remotePath.length > 0) {
        if (gA.remotePath.indexOf('d:') > -1 || gA.remotePath.indexOf('ds:') > -1) {
          if (gA.remotePath.indexOf('d:') > -1) url = gA.remotePath.replace('d:', 'http:');else url = gA.remotePath.replace('ds:', 'https:');
        } else params.r = gA.remotePath;
      }

      $.ajax({
        type: 'GET',
        url: url + '/' + gA.pathAuth,
        async: true,
        crossOrigin: true,
        dataType: 'jsonp',
        success: this.callback.bind(this),
        username: gA.token,
        data: params,
        error: function error(x, y, z) {
          if (process.env.NODE_ENV === 'development') {
            procUtils.alert(x.responseText + '\n' + y + '\n' + z);
          } else {
            procUtils.alert(_t[gA.lingua].serverNonDisponibile);
          }
        }
      });
    }
  }, {
    key: "AutenticazioneToken",
    value: function AutenticazioneToken(callback, token, codice) {
      this.callbackRisposta = callback;
      var params = {};
      params.t = token;
      params.c = codice;
      params._ = moment().format('X');
      var url = gA.baseUrlServer;

      if (gA.remotePath.length > 0) {
        if (gA.remotePath.indexOf('d:') > -1 || gA.remotePath.indexOf('ds:') > -1) {
          if (gA.remotePath.indexOf('d:') > -1) url = gA.remotePath.replace('d:', 'http:');else url = gA.remotePath.replace('ds:', 'https:');
        } else params.r = gA.remotePath;
      }

      $.ajax({
        type: 'GET',
        url: url + '/' + gA.pathAuth,
        async: true,
        crossOrigin: true,
        dataType: 'jsonp',
        success: this.callback.bind(this),
        username: gA.token,
        data: params,
        error: function error(x, y, z) {
          if (process.env.NODE_ENV === 'development') {
            procUtils.alert(x.responseText + '\n' + y + '\n' + z);
          } else {
            procUtils.alert(_t[gA.lingua].serverNonDisponibile);
          }
        }
      });
    }
  }]);

  return TAutenticazione;
}();

var DBWrapper =
/*#__PURE__*/
function () {
  function DBWrapper() {
    _classCallCheck(this, DBWrapper);

    this.table = '';
    this.maskDate = "YYYY-MM-DD";
    this.maskDateTime = "YYYY-MM-DD HH:mm:ss";
  }

  _createClass(DBWrapper, [{
    key: "_callback",
    value: function _callback(callback, risposta) {
      if (risposta.nt !== undefined) {
        if (risposta.nt) {
          gA.token = risposta.nt;
          gA.keyA = risposta.nt.substring(0, 32);
          gA.iv = risposta.nt.substring(6, 22);
        }

        callback(risposta.r);
      } else {
        callback(risposta);
      }
    }
  }, {
    key: "setTable",
    value: function setTable(table) {
      this.table = table;
    }
  }, {
    key: "Encode",
    value: function Encode(sql) {
      if (sql.startsWith('@')) {
        alert('errore @ in database');
      } else return sql;
    }
  }, {
    key: "rawQuery",
    value: function rawQuery(callback, sql, params) {
      if (params == null) params = {};
      params.q = this.Encode(sql);
      params.method = 'query';
      params.token = gA.token;
      var url = gA.baseUrlServer;

      if (gA.remotePath.length > 0) {
        if (gA.remotePath.indexOf('d:') > -1 || gA.remotePath.indexOf('ds:') > -1) {
          if (gA.remotePath.indexOf('d:') > -1) url = gA.remotePath.replace('d:', 'http:');else url = gA.remotePath.replace('ds:', 'https:');
        } else params.r = gA.remotePath;
      }

      $.ajax({
        type: 'GET',
        url: url + '/' + gA.pathDatabase,
        async: true,
        crossOrigin: true,
        dataType: 'jsonp',
        success: this._callback.bind(this, callback),
        data: params,
        error: function error(x, y, z) {
          if (x.status === 404) {
            alert(_t[gA.lingua].sessioneScaduta);
            window.location = gA.dirUrl;
          } else {
            alert(x.responseText + '\n' + y + '\n' + z);
          }
        }
      });
    }
  }, {
    key: "execSQL",
    value: function execSQL(callback, sql, params) {
      this.callback = callback;
      if (params == null) params = {};
      params.q = this.Encode(sql);
      params.method = 'exec';
      params.token = gA.token;
      var url = gA.baseUrlServer;

      if (gA.remotePath.length > 0) {
        if (gA.remotePath.indexOf('d:') > -1 || gA.remotePath.indexOf('ds:') > -1) {
          if (gA.remotePath.indexOf('d:') > -1) url = gA.remotePath.replace('d:', 'http:');else url = gA.remotePath.replace('ds:', 'https:');
        } else params.r = gA.remotePath;
      }

      $.ajax({
        type: 'GET',
        url: url + '/' + gA.pathDatabase,
        async: true,
        crossOrigin: true,
        dataType: 'jsonp',
        success: this._callback.bind(this, callback),
        data: params,
        error: function error(x, y, z) {
          if (x.status === 404) {
            alert(_t[gA.lingua].sessioneScaduta);
            window.location = gA.dirUrl;
          } else {
            alert(x.responseText + '\n' + y + '\n' + z);
          }
        }
      });
    }
  }, {
    key: "NuovoID",
    value: function NuovoID(nometavola) {
      return 0;
    }
  }]);

  return DBWrapper;
}();

var TParametri =
/*#__PURE__*/
function () {
  function TParametri() {
    _classCallCheck(this, TParametri);

    this.items = [];
    this.codice_utente = 0;
    this.supervisore = false;
    this.livello = 0;
    this.dataUltimoAccesso = Date();
  }

  _createClass(TParametri, [{
    key: "Add",
    value: function Add(nome, valore) {
      this.items[nome] = valore;
    }
  }, {
    key: "Get",
    value: function Get(nome) {
      var v = this.items[nome];
      if (v == null) return "";else return v;
    }
  }, {
    key: "Assigned",
    value: function Assigned(nome) {
      if (this.items[nome] != null) return true;
      return false;
    }
  }, {
    key: "Set",
    value: function Set(nome, valore) {
      this.items[nome] = valore;
    }
  }, {
    key: "Load",
    value: function Load() {
      var _this2 = this;

      procUtils.asyncRequestGet('api/loadparams.php', null).then(function (risposta) {
        return risposta.json();
      }).then(function (risposta) {
        risposta.forEach(function (e) {
          _this2.Add(e.nome, e.valore);
        });
      }).catch(function (error) {
        console.error("Errore:", error);
      });
    }
  }, {
    key: "LoadClient",
    value: function LoadClient(idAzienda) {
      var _this3 = this;

      procUtils.asyncRequestGet('api/loadparamsclient.php', {
        id: idAzienda
      }).then(function (risposta) {
        return risposta.json();
      }).then(function (risposta) {
        risposta.forEach(function (e) {
          _this3.Add(e.nome, e.valore);
        });
      }).catch(function (error) {
        console.error("Errore:", error);
      });
    }
  }]);

  return TParametri;
}();

var TVariabili =
/*#__PURE__*/
function () {
  function TVariabili() {
    _classCallCheck(this, TVariabili);

    this.items = [];
  }

  _createClass(TVariabili, [{
    key: "Add",
    value: function Add(nome, valore) {
      this.items[nome] = valore;
    }
  }, {
    key: "Get",
    value: function Get(nome) {
      var v = this.items[nome];
      if (v == null) return "";else return v;
    }
  }, {
    key: "Assigned",
    value: function Assigned(nome) {
      if (this.items[nome] != null) return true;
      return false;
    }
  }, {
    key: "Set",
    value: function Set(nome, valore) {
      this.items[nome] = valore;
    }
  }]);

  return TVariabili;
}();

var TCampiOutput =
/*#__PURE__*/
function () {
  function TCampiOutput() {
    _classCallCheck(this, TCampiOutput);

    this.items = [];
  }

  _createClass(TCampiOutput, [{
    key: "Get",
    value: function Get(nome) {
      return this.items[nome];
    }
  }]);

  return TCampiOutput;
}();

var OggettiForm =
/*#__PURE__*/
function () {
  function OggettiForm() {
    _classCallCheck(this, OggettiForm);

    this.variabili = new TVariabili();
    this.filtriPda = [];
    this.filtri = [];
    this.campiOutput = new TCampiOutput();
    this.reports = [];
    this.campi = [];
    this.subforms = [];
    this.filtro = "";
    this.campiSqlSelect = "";
    this.campiSqlSelectBrowser = "";
    this.colonne = [];
    this.nomeform = "";
    this.db = new DBWrapper();
    this.handle = null;
  }

  _createClass(OggettiForm, [{
    key: "findFiltro",
    value: function findFiltro(nome) {
      return this.filtri[nome];
    }
  }, {
    key: "getChiave",
    value: function getChiave() {
      return procUtils.GetNomeCampo(this.variabili.Get("chiave"));
    }
  }, {
    key: "OpenDatabase",
    value: function OpenDatabase(callback) {
      this.db.setTable(this.variabili.Get("tavola"));
    }
  }, {
    key: "GetCampo",
    value: function GetCampo(nomeCampo) {
      return this.campi.find(function (campo) {
        return campo.solocampo === nomeCampo;
      });
    }
  }, {
    key: "findsubform",
    value: function findsubform(nome) {
      for (var i = 0; i < this.subforms.length; i++) {
        if (this.subforms[i].nome === nome) return this.subforms[i];
      }

      return this.subforms[0];
    }
  }]);

  return OggettiForm;
}();

var ETipoCampo = {
  ALFA: 'A',
  NUMERO: 'N',
  INTERO: 'I',
  DATAORA: 'U',
  DATA: 'D',
  TEMPO: 'E',
  BOOLEANO: 'L',
  TABELLA: 'T',
  MEMO: 'M',
  IMMAGINE: 'G',
  BLOB: 'B',
  TELEFONICO: 'X',
  PROCEDURA: 'P',
  CRIPTATO: 'K',
  SUBFORM: 'F',
  TAB: 'S',
  CURRENCY: '$',
  MULTISELECT: 'W',
  TraduciTipo: function TraduciTipo(riga) {
    var tipoCampo = ETipoCampo.ALFA;

    if (riga === "A") {
      tipoCampo = ETipoCampo.ALFA;
    } else if (riga === "C") {
      tipoCampo = ETipoCampo.ALFA;
    } else if (riga === "H") {
      tipoCampo = ETipoCampo.ALFA;
    } else if (riga === "N") {
      tipoCampo = ETipoCampo.NUMERO;
    } else if (riga === "$") {
      tipoCampo = ETipoCampo.CURRENCY;
    } else if (riga === "%") {
      tipoCampo = ETipoCampo.CURRENCY;
    } else if (riga === "+") {
      tipoCampo = ETipoCampo.INTERO;
    } else if (riga === "E") {
      tipoCampo = ETipoCampo.TEMPO;
    } else if (riga === "I") {
      tipoCampo = ETipoCampo.INTERO;
    } else if (riga === "D") {
      tipoCampo = ETipoCampo.DATA;
    } else if (riga === "U") {
      tipoCampo = ETipoCampo.DATAORA;
    } else if (riga === "L") {
      tipoCampo = ETipoCampo.BOOLEANO;
    } else if (riga === "M") {
      tipoCampo = ETipoCampo.MEMO;
    } else if (riga === "G") {
      tipoCampo = ETipoCampo.IMMAGINE;
    } else if (riga === "B") {
      tipoCampo = ETipoCampo.BLOB;
    } else if (riga === "T") {
      tipoCampo = ETipoCampo.TABELLA;
    } else if (riga === "X") {
      tipoCampo = ETipoCampo.TELEFONICO;
    } else if (riga === "P") {
      tipoCampo = ETipoCampo.PROCEDURA;
    } else if (riga === "K") {
      tipoCampo = ETipoCampo.CRIPTATO;
    } else if (riga === "F") {
      tipoCampo = ETipoCampo.SUBFORM;
    } else if (riga === "S") {
      tipoCampo = ETipoCampo.TAB;
    } else if (riga === "W") {
      tipoCampo = ETipoCampo.MULTISELECT;
    }

    return tipoCampo;
  }
};

var TCampo =
/*#__PURE__*/
function () {
  function TCampo(campo) {
    _classCallCheck(this, TCampo);

    this.tipo = "";
    this.etichetta = "";
    this.nomecampo = "";
    this.lunghezza = 0;
    this.flags = 0;
    this.numero = 0;
    this.coordinata = "";
    this.larghezza = 0;
    this.browserPosizione = 0;
    this.solocampo = "";
    this.condizione = "";
    this.aiuto = "";
    this.picture = "";
    this.max_w = 0;
    this.max_h = 0;
    this.crop = 0;
    this.valoreIniziale = null;
    this.tabellaRif = "";
    this.fieldMemo = "";
    this.fieldMemoSoloCampo = "";
    this.tabellaQuery = "";
    this.joinTabellaQuery = "";
    this.fieldKey = "";
    this.fieldResult = "";
    this.ulterioriCampi = "";
    this.macro = "";
    this.addWhere = "";
    this.fileForm = "";
    this.oldValue = "";
    this.procValidate = "";
    this.procEtichetta = "";
    this.lastValue = null;
    this.livelloAccesso = "";
    Object.assign(this, campo);
    this.valore = null;
    this.valoreDescrizione = null;
    this.handle = null;
    this.inShow = false;
  }

  _createClass(TCampo, [{
    key: "hasFlag",
    value: function hasFlag(flag) {
      return (flag & this.flags) !== 0;
    }
  }, {
    key: "IsEmpty",
    value: function IsEmpty(oggetti) {
      if (this.valore != null) {
        if (this.tipo === ETipoCampo.ALFA || this.tipo === ETipoCampo.INTERO || this.tipo === ETipoCampo.NUMERO) {
          if (this.valore === "") return true;
        } else if (this.tipo === ETipoCampo.MEMO) {
          if (this.valore === "") return true;
        } else if (this.tipo === ETipoCampo.DATA || this.tipo === ETipoCampo.DATAORA) {
          if (this.valore === "") return true;
        } else if (this.tipo === ETipoCampo.TABELLA) {
          if (this.valore === "") return true;
        } else if (this.tipo === ETipoCampo.BOOLEANO) {
          if (this.valore === "") return true;
        }

        return false;
      }

      return true;
    }
  }, {
    key: "IsAuthorized",
    value: function IsAuthorized(oggetti) {
      if (gA.parametri.livello === 0) {
        return 2;
      }

      if (this.livelloAccesso) {
        var livello = 0;

        if (this.livelloAccesso.substring(0, 1) === 'R') {
          livello = parseInt(this.livelloAccesso.substring(1));
          if (gA.parametri.livello >= livello) return 1;else return 2;
        } else {
          livello = parseInt(this.livelloAccesso);
          if (gA.parametri.livello >= livello) return 1;else return 0;
        }
      } else {
        return 1;
      }
    }
  }, {
    key: "ValoreSQLHandle",
    value: function ValoreSQLHandle(oggetti) {
      if (this.valore == null) {
        if (this.tipo === ETipoCampo.MULTISELECT) {
          var multi = {
            t: this.tabellaRif,
            c1: this.fieldMemoSoloCampo,
            c2: this.solocampo,
            id: this.get,
            e: []
          };
          return multi;
        } else return null;
      }

      if (this.tipo === ETipoCampo.ALFA || this.tipo === ETipoCampo.CRIPTATO) {
        return this.valore;
      }

      if (this.tipo === ETipoCampo.TELEFONICO) {
        return this.valore;
      } else if (this.tipo === ETipoCampo.NUMERO || this.tipo === ETipoCampo.CURRENCY) {
        if (this.valore != null && this.valore.length !== 0) {
          return this.valore;
        } else {
          return null;
        }
      } else if (this.tipo === ETipoCampo.INTERO) {
        if (this.valore != null && this.valore.length !== 0) {
          return parseInt(this.valore, 10);
        } else {
          return null;
        }
      } else if (this.tipo === ETipoCampo.MEMO) {
        return this.valore;
      } else if (this.tipo === ETipoCampo.DATA || this.tipo === ETipoCampo.DATAORA) {
        if (this.valore == null || this.valore === "") {
          return null;
        } else {
          try {
            if (this.valore.isValid()) return this.valore.format(oggetti.db.maskDateTime);else return null;
          } catch (e) {
            return null;
          }
        }
      } else if (this.tipo === ETipoCampo.TABELLA) {
        if (/[^0-9a-zA-Z]/.test(this.valore)) return parseInt(this.valore, 10);else return this.valore;
      } else if (this.tipo === ETipoCampo.MULTISELECT) {
        if (Array.isArray(this.valore)) {
          var multi = {
            e: this.valore.map(function (e) {
              return e.value;
            })
          };
          return multi;
        } else {
          var multi = {
            e: []
          };
          return multi;
        }
      } else if (this.tipo === ETipoCampo.IMMAGINE) {
        return this.valore;
      } else if (this.tipo === ETipoCampo.BOOLEANO) {
        if (this.valore) {
          return 1;
        } else {
          return 0;
        }
      }

      return null;
    }
  }, {
    key: "getDefault",
    value: function getDefault() {
      if (this.valoreIniziale != null) {
        if (this.valoreIniziale === "today") {
          return moment().hour(0).minute(0).seconds(0);
        } else if (this.valoreIniziale === "now") {
          return moment();
        } else if (this.valoreIniziale === "time") {
          return moment();
        } else if (this.solocampo.toUpperCase === "VALUTA") {
          return gA.valuta.Sigla;
        } else if (this.valoreIniziale.substring(0, 1) === "+") {
          if (this.HasCounter()) if (this.lastValue == null) return this.GetCounter().toString();else return (this.lastValue + this.GetCounter()).toString();
          return "";
        } else if (this.valoreIniziale.substring(0, 1) === "=") {
          return "";
        } else if (this.valoreIniziale.substring(0, 1) === "$") {
          return gA.parametri.Get(this.valoreIniziale.substring(1));
        } else if (this.valoreIniziale.substring(0, 1) === "-") {
          return this.valoreIniziale.substring(1, 2);
        } else if (this.valoreIniziale.substring(0, 1) === "§") {
          return "+";
        } else {
          return this.valoreIniziale;
        }
      }

      return null;
    }
  }, {
    key: "RicavaDefaultPost",
    value: function RicavaDefaultPost(oggetti) {
      return "";
    }
  }, {
    key: "HasCounter",
    value: function HasCounter() {
      if (this.valoreIniziale.length > 1) {
        if (this.valoreIniziale.startsWith("+") && !(this.valoreIniziale.indexOf("(") !== -1 || this.valoreIniziale.indexOf("[") !== -1)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "GetCounter",
    value: function GetCounter() {
      if (this.valoreIniziale.length() > 1) {
        if (this.valoreIniziale.startsWith("+") && !(this.valoreIniziale.indexOf("(") !== -1 || this.valoreIniziale.indexOf("[") !== -1)) {
          return parseInt(this.valoreIniziale.substring(1), 10);
        }
      }

      return 0;
    }
  }, {
    key: "Validate",
    value: function Validate(valore) {
      if (this.valoreIniziale) {
        if (this.valoreIniziale.substring(0, 1) === '-') {
          var p = this.valoreIniziale.indexOf('=');

          if (p > -1) {
            var contenuto = this.valoreIniziale.substring(1, p);
            var aiuto = this.valoreIniziale.substring(p + 1);

            if (contenuto.indexOf(valore) === -1) {
              return aiuto;
            }
          }
        }
      }

      return "";
    }
  }]);

  return TCampo;
}();

var TSubForm =
/*#__PURE__*/
function () {
  function TSubForm(subform) {
    var _this4 = this;

    _classCallCheck(this, TSubForm);

    this.nome = "";
    this.select = "";
    this.nometavola = "";
    this.variabili = null;
    this.colonne = [];
    this.fieldkey = "";
    this.fieldkeysolocampo = "";
    this.order = "";
    this.whereUtente = "";
    this.coloreRighe = "";
    this.chiaveprimaria = "";
    this.join = "";
    this.SolaLettura = false;
    this.campo_modifica = "";
    this.campo_creazione = "";
    this.campo_utente = "";
    this.campo_utente_creazione = "";
    this.campo_timestamp = "";
    Object.assign(this, subform);
    this.colonne = [];
    subform.colonne.forEach(function (e) {
      var c = new TCampo(e);

      _this4.colonne.push(c);
    });
  }

  _createClass(TSubForm, [{
    key: "GetColonna",
    value: function GetColonna(nomeColonna) {
      for (var i = 0; i < this.colonne.length; i++) {
        if (this.colonne[i].solocampo === nomeColonna) {
          if (process.env.NODE_ENV === 'development') procUtils.myLog("GetColonna: " + nomeColonna);
          return this.colonne[i];
        }
      }

      return null;
    }
  }]);

  return TSubForm;
}();

var EFlags = {
  MASK: 131071,
  VISIBILE: 1,
  CHIAVE: 2,
  READONLY: 4,
  QUERY: 8,
  INIZIALE: 16,
  OBBLIGATORIO: 32,
  SUPPLEMENTARE: 64,
  FORZA_NUMERICO: 128,
  FORZA_TELEFONO: 256,
  FORZA_PASSWORD: 512,
  SOMMA: 1024,
  CALCOLO: 2048,
  NOT_UPDATE: 4096,
  BARCODE: 8192,
  NO_DISABLE: 16384,
  UPLOAD: 32768,
  TESTATA: 65536,
  MAIUSCOLO: 131072,
  MINUSCOLO: 262144,
  TraduceFlags: function TraduceFlags(riga) {
    var flags = 0;

    if (riga.toUpperCase().indexOf("V") > -1) {
      flags |= EFlags.VISIBILE;
    }

    if (riga.toUpperCase().indexOf("F") > -1) {
      flags |= EFlags.UPLOAD;
    }

    if (riga.toUpperCase().indexOf("K") > -1) {
      flags |= EFlags.CHIAVE;
    }

    if (riga.toUpperCase().indexOf("R") > -1) {
      flags |= EFlags.READONLY;
    }

    if (riga.toUpperCase().indexOf("Q") > -1) {
      flags |= EFlags.QUERY;
    }

    if (riga.toUpperCase().indexOf("B") > -1) {
      flags |= EFlags.INIZIALE;
    }

    if (riga.toUpperCase().indexOf("O") > -1) {
      flags |= EFlags.OBBLIGATORIO;
    }

    if (riga.toUpperCase().indexOf("N") > -1) {
      flags |= EFlags.SUPPLEMENTARE;
    }

    if (riga.toUpperCase().indexOf("Y") > -1) {
      flags |= EFlags.FORZA_NUMERICO;
    }

    if (riga.toUpperCase().indexOf("T") > -1) {
      flags |= EFlags.FORZA_TELEFONO;
    }

    if (riga.toUpperCase().indexOf("*") > -1) {
      flags |= EFlags.FORZA_PASSWORD;
    }

    if (riga.toUpperCase().indexOf("U") > -1) {
      flags |= EFlags.NOT_UPDATE;
    }

    if (riga.toUpperCase().indexOf("L") > -1) {
      flags |= EFlags.CALCOLO;
    }

    if (riga.toUpperCase().indexOf("+") > -1) {
      flags |= EFlags.SOMMA;
    }

    if (riga.toUpperCase().indexOf("M") > -1) {
      flags |= EFlags.BARCODE;
    }

    if (riga.toUpperCase().indexOf("D") > -1) {
      flags |= EFlags.NO_DISABLE;
    }

    if (riga.toUpperCase().indexOf("T") > -1) {
      flags |= EFlags.TESTATA;
    }

    if (riga.indexOf("<") > -1) {
      flags |= EFlags.MINUSCOLO;
    }

    if (riga.indexOf(">") > -1) {
      flags |= EFlags.MAIUSCOLO;
    }

    return flags;
  }
};

var FileForms =
/*#__PURE__*/
function () {
  function FileForms() {
    _classCallCheck(this, FileForms);

    this.rigaCorrente = 0;
  }

  _createClass(FileForms, [{
    key: "ParsingValore",
    value: function ParsingValore(tok, righe) {
      var i = 0;
      var trovato = 0;
      var valore = "";
      var riga = tok.nextToken("");

      if (riga == null) {
        return "";
      }

      for (i = 0; i < riga.length; i++) {
        if (trovato === 0 && riga.charAt(i) === '=') {
          trovato = 1;
        } else if (trovato > 0 && riga.charAt(i) === '(' && trovato !== 3) {
          trovato = 2;
        } else if (trovato > 0 && (riga.charAt(i) === '"' || riga.charAt(i) !== ' ' && trovato !== 3)) {
          if (trovato === 3) {
            trovato = 1;
          } else {
            trovato = 3;
          }
        }

        if (trovato === 3 & !(riga.charAt(i) === '"')) {
          valore += riga.charAt(i);
        }
      }

      if (trovato !== 2) {
        return valore;
      }

      try {
        while (this.rigaCorrente < righe.length - 1) {
          this.rigaCorrente++;
          riga = righe[this.rigaCorrente];

          if (riga.length > 0) {
            if (riga.charAt(0) !== ')') {
              valore += riga + "\n";
            } else {
              break;
            }
          }
        }
      } catch (err) {}

      return valore;
    }
  }, {
    key: "ParsingValore2",
    value: function ParsingValore2(tok) {
      var i = 0;
      var trovato = 0;
      var valore = "";
      var riga = tok.nextToken("");

      if (riga === null) {
        return "";
      }

      for (i = 0; i < riga.length; i++) {
        if (trovato === 0 && riga.charAt(i) === '=') {
          trovato = 1;
        } else if (trovato > 0 && (riga.charAt(i) === '"' || riga.charAt(i) !== ' ' && trovato !== 3)) {
          if (trovato === 3) {
            trovato = 1;
          } else {
            trovato = 3;
          }
        }

        if (trovato === 3 & !(riga.charAt(i) === '"')) {
          valore += riga.charAt(i);
        }
      }

      return valore;
    }
  }, {
    key: "LoadFile",
    value: function LoadFile(callback, nomeFile, parametri) {
      if (process.env.NODE_ENV === 'development') procUtils.myLog("FileForm(LoadFile): inizio");
      var result = new OggettiForm();
      result.nomeform = nomeFile;
      $.ajax({
        type: 'GET',
        url: gA.baseUrlForms + '/' + gA.pathForms + nomeFile,
        async: true,
        crossOrigin: true,
        dataType: 'json',
        success: function success(risposta) {
          return callback(result, risposta);
        },
        data: {
          token: gA.token,
          p: parametri
        },
        error: function error(x, y, z) {
          if (x.status === 401) {
            alert(_t[gA.lingua].sessioneScaduta);
            window.location = gA.dirUrl;
          } else {
            alert(x.responseText + '\n' + y + '\n' + z);
          }
        }
      });
    }
  }, {
    key: "ElaboraFile",
    value: function ElaboraFile(result, sFile) {
      if (process.env.NODE_ENV === 'development') procUtils.myLog("FileForm(LoadFile): inizio elaborazione");

      try {
        for (var _i2 = 0, _Object$entries = Object.entries(sFile.variabili); _i2 < _Object$entries.length; _i2++) {
          var _ref3 = _Object$entries[_i2];

          var _ref2 = _slicedToArray(_ref3, 2);

          var key = _ref2[0];
          var value = _ref2[1];
          result.variabili.Add(key, value);
        }

        ;
        sFile.campi.forEach(function (e) {
          var c = new TCampo(e);
          result.campi.push(c);
        });
        result.filtriPda = sFile.filtriPda;
        sFile.subforms.forEach(function (e) {
          var c = new TSubForm(e);
          result.subforms.push(c);
        });
        result.filtri = sFile.filtri;
      } catch (err) {
        procUtils.myLog("FileForm(LoadFile) Err: " + err.message);
      }

      if (process.env.NODE_ENV === 'development') procUtils.myLog("FileForm(LoadFile): fine elaborazione");
      return result;
    }
  }]);

  return FileForms;
}();

var ReactUploadFile =
/*#__PURE__*/
function (_Component4) {
  _inherits(ReactUploadFile, _Component4);

  function ReactUploadFile(props) {
    var _this5;

    _classCallCheck(this, ReactUploadFile);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ReactUploadFile).call(this, props));
    _this5.state = {
      xhrList: [],
      currentXHRId: 0
    };

    _this5.componentDidMount = function () {
      _this5.input = ReactDOM.findDOMNode(_assertThisInitialized(_this5)).querySelector('[name=ajax-upload-file-input]');
    };

    _this5.commonChooseFile = function (e) {
      if (e.target.name !== 'ajax-upload-file-input') {
        var jud = _this5.beforeChoose();

        if (jud !== true && jud !== undefined) return;

        _this5.input.click();
      }
    };

    _this5.commonChangeFile = function (e) {
      _this5.files = _this5.input.files;

      _this5.didChoose(_this5.files);

      if (!_this5.props.uploadFileButton) {
        _this5.commonUploadFile(e);
      }
    };

    _this5.commonUploadFile = function (e) {
      if (!_this5.files || !_this5.files.length) return false;

      if (!_this5.baseUrl) {
        throw new Error('baseUrl missed in options');
      }

      var jud = e === true ? true : _this5.beforeUpload(_this5.files);

      if (!jud) {
        return false;
      }

      var formData = new FormData();
      formData = _this5.appendFieldsToFormData(formData);
      var fieldNameType = typeof _this5.fileFieldName;
      var numberLimit = _this5.numberLimit === 0 ? _this5.files.length : Math.min(_this5.files.length, _this5.numberLimit);

      for (var i = numberLimit - 1; i >= 0; i--) {
        if (fieldNameType === 'function') {
          var file = _this5.files[i];

          var fileFieldName = _this5.fileFieldName(file);

          formData.append(fileFieldName, file);
        } else if (fieldNameType === 'string') {
          var _file = _this5.files[i];
          formData.append(_this5.fileFieldName, _file);
        } else {
          var _file2 = _this5.files[i];
          formData.append(_file2.name, _file2);
        }
      }

      if (_this5.idAnag !== "") {
        formData.append('idAnag', _this5.idAnag);
      }

      if (_this5.idCampo.valore != null) {
        formData.append('idCampo', _this5.idCampo.valore);
      }

      var baseUrl = _this5.baseUrl;
      var query = typeof _this5.query === 'function' ? _this5.query(_this5.files) : _this5.query;
      var pos = baseUrl.indexOf('?');
      var queryStr;

      if (pos > -1) {
        queryStr = baseUrl.substring(pos);
        baseUrl = baseUrl.substring(0, pos);
      }

      if (query) {
        if (queryStr) {
          console.warn('Your url contains query string, which will be ignored when options.query is set.');
        }

        var queryArr = [];
        Object.keys(query).forEach(function (key) {
          return queryArr.push("".concat(key, "=").concat(query[key]));
        });
        queryStr = "?".concat(queryArr.join('&'));
      }

      queryStr = queryStr || '';
      var targetUrl = "".concat(baseUrl).concat(queryStr);
      var xhr = new XMLHttpRequest();
      xhr.open('post', targetUrl, true);
      xhr.withCredentials = _this5.withCredentials;
      var rh = _this5.requestHeaders;

      if (rh) {
        Object.keys(rh).forEach(function (key) {
          return xhr.setRequestHeader(key, rh[key]);
        });
      }

      if (_this5.timeout) {
        xhr.timeout = _this5.timeout;
        xhr.addEventListener('timeout', function () {
          _this5.uploadError({
            type: '408',
            message: 'Request Timeout'
          });
        });
        setTimeout(function () {}, _this5.timeout);
      }

      xhr.addEventListener('load', function () {
        _this5.input.value = '';
        var res = _this5.dataType === 'json' ? JSON.parse(xhr.responseText) : xhr.responseText;

        _this5.uploadSuccess(res);
      });
      xhr.addEventListener('error', function () {
        var err = _this5.dataType === 'json' ? JSON.parse(xhr.responseText) : xhr.responseText;

        _this5.uploadError({
          type: err.type,
          message: err.message
        });
      });
      xhr.addEventListener('progress', function (progress) {
        _this5.uploading(progress);
      });
      var curId = _this5.state.xhrList.length - 1;
      xhr.addEventListener('abort', function () {
        _this5.onAbort(curId);
      });
      xhr.send(formData);

      _this5.setState({
        currentXHRId: curId,
        xhrList: [].concat(_toConsumableArray(_this5.state.xhrList), [xhr])
      });

      _this5.didUpload(_this5.files, _this5.state.currentXHRId);

      return true;
    };

    _this5.appendFieldsToFormData = function (formData) {
      var field = typeof _this5.body === 'function' ? _this5.body() : _this5.body;

      if (field) {
        Object.keys(field).forEach(function (index) {
          formData.append(index, field[index]);
        });
      }

      return formData;
    };

    _this5.processFile = function (func) {
      _this5.files = func(_this5.files);
    };

    _this5.manuallyChooseFile = function (e) {
      _this5.commonChooseFile(e);
    };

    _this5.manuallyUploadFile = function (files) {
      _this5.files = files && files.length ? files : _this5.files;

      _this5.commonUploadFile(true);
    };

    _this5.abort = function (id) {
      if (id) {
        _this5.state.xhrList[id].abort();
      } else {
        _this5.state.xhrList[_this5.state.currentXHRId].abort();
      }
    };

    var emptyFunction = function emptyFunction(f) {
      return f;
    };

    var options = _objectSpread({
      dataType: 'json',
      timeout: 0,
      numberLimit: 0,
      userAgent: window ? window.navigator.userAgent : '',
      multiple: false,
      withCredentials: false,
      beforeChoose: emptyFunction,
      didChoose: emptyFunction,
      beforeUpload: emptyFunction,
      didUpload: emptyFunction,
      uploading: emptyFunction,
      uploadSuccess: emptyFunction,
      uploadError: emptyFunction,
      uploadFail: emptyFunction,
      onAbort: emptyFunction
    }, props.options);

    _this5.idAnag = props.idAnag;
    _this5.idCampo = props.idCampo;
    var timeout = parseInt(options.timeout, 10);
    options.timeout = Number.isInteger(timeout) && timeout > 0 ? timeout : 0;
    var dataType = options.dataType && options.dataType.toLowerCase();
    options.dataType = dataType !== 'json' && 'text';
    Object.keys(options).forEach(function (key) {
      _this5[key] = options[key];
    });
    return _this5;
  }

  _createClass(ReactUploadFile, [{
    key: "render",
    value: function render() {
      var inputProps = {
        accept: this.props.options.accept,
        multiple: this.props.options.multiple
      };
      var chooseFileButton = React.cloneElement(this.props.chooseFileButton, {
        onClick: this.commonChooseFile
      }, [].concat(_toConsumableArray(this.props.chooseFileButton.props.children ? [this.props.chooseFileButton.props.children] : []), [
      /*#__PURE__*/
      React.createElement("input", Object.assign({
        type: "file",
        name: "ajax-upload-file-input",
        style: {
          display: 'none'
        },
        onChange: this.commonChangeFile
      }, inputProps, {
        key: "file-button"
      }))]));
      var uploadFileButton = this.props.uploadFileButton && React.cloneElement(this.props.uploadFileButton, {
        onClick: this.commonUploadFile
      });
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            display: 'inline-block'
          }
        }, chooseFileButton, uploadFileButton)
      );
    }
  }]);

  return ReactUploadFile;
}(Component);

ReactUploadFile.propTypes = {
  options: PropTypes.shape({
    baseUrl: PropTypes.string.isRequired,
    query: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    body: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    dataType: PropTypes.string,
    timeout: PropTypes.number,
    numberLimit: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
    fileFieldName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    withCredentials: PropTypes.bool,
    requestHeaders: PropTypes.object,
    accept: PropTypes.string,
    multiple: PropTypes.bool,
    userAgent: PropTypes.string,
    beforeChoose: PropTypes.func,
    didChoose: PropTypes.func,
    beforeUpload: PropTypes.func,
    didUpload: PropTypes.func,
    uploading: PropTypes.func,
    uploadSuccess: PropTypes.func,
    uploadError: PropTypes.func,
    uploadFail: PropTypes.func,
    onAbort: PropTypes.func
  }).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  chooseFileButton: PropTypes.element.isRequired,
  uploadFileButton: PropTypes.element
};
ReactUploadFile.defaultProps = {
  chooseFileButton:
  /*#__PURE__*/
  React.createElement("button", null, "Select File")
};
var maskDate = "YYYY-MM-DD";
var maskDateTime = "YYYY-MM-DDTHH:mm:ss";

var styles$2 = function styles$2(theme) {
  return {
    textField: {
      marginTop: theme.spacing(1),
      width: "100%",
      padding: "0 8px 0 0"
    },
    dateField: {
      marginTop: theme.spacing(0.6),
      width: "100%",
      padding: "0px 8px 0 0"
    },
    label: {
      flexDirection: 'column'
    },
    label2: {
      fontSize: "12px"
    },
    input: {
      display: "flex",
      padding: 0,
      height: "auto"
    },
    valueContainer: {
      display: "flex",
      flexWrap: "wrap",
      flex: 1,
      alignItems: "center",
      overflow: "hidden"
    },
    chip: {
      margin: theme.spacing(0.5, 0.25)
    },
    chipFocused: {
      backgroundColor: emphasize(theme.palette.type === "light" ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
    },
    noOptionsMessage: {
      padding: theme.spacing(1, 2)
    },
    singleValue: {
      fontSize: 16
    },
    placeholder: {
      position: "absolute",
      left: 2,
      bottom: 6,
      fontSize: 16
    },
    paper: {
      position: "absolute",
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0
    },
    divider: {
      height: theme.spacing(2)
    },
    colorInput: {
      color: theme.palette.type === 'dark' ? 'white' : 'black'
    },
    emptyPhoto: {
      backgroundColor: theme.palette.grey[700],
      width: "100%",
      textAlign: 'center'
    },
    gridList: {
      width: '80%',
      height: '80%'
    },
    icon: {
      color: 'rgba(255, 255, 255, 0.54)'
    },
    tile: {
      width: 'auto',
      height: 100
    },
    immagine: {
      marginTop: theme.spacing(1),
      padding: "0 8px 0 0",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  };
};

var materialTheme = function materialTheme(theme) {
  return createMuiTheme({
    palette: {
      type: theme.palette.type,
      primary: lightBlue
    }
  });
};

var GDateTimePure =
/*#__PURE__*/
function (_Component5) {
  _inherits(GDateTimePure, _Component5);

  function GDateTimePure(props) {
    var _this6;

    _classCallCheck(this, GDateTimePure);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(GDateTimePure).call(this, props));
    _this6.state = {
      nomecampo: props.id,
      etichetta: props.label,
      readOnly: props.readOnly,
      onChange: props.onChange,
      onMessage: props.onMessage,
      dateFormat: props.dateFormat,
      timeFormat: props.timeFormat,
      time: props.time,
      value: ""
    };
    if (_this6.state.time === undefined) _this6.mask = maskDate;else _this6.mask = maskDateTime;
    return _this6;
  }

  _createClass(GDateTimePure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));
    }
  }, {
    key: "onMessage",
    value: function onMessage(valore) {
      if (this.state.readOnly) {
        this.setState({
          value: valore
        });
      } else {
        this.setState({
          value: valore
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;

      if (this.state.time !== undefined) {
        return (
          /*#__PURE__*/
          React.createElement(ThemeProvider, {
            theme: materialTheme
          },
          /*#__PURE__*/
          React.createElement(FormControl, {
            className: classes.dateField
          },
          /*#__PURE__*/
          React.createElement(Typography$1, {
            variant: "caption",
            color: "textSecondary"
          }, this.state.etichetta),
          /*#__PURE__*/
          React.createElement(MuiPickersUtilsProvider, {
            utils: MomentUtils
          },
          /*#__PURE__*/
          React.createElement(KeyboardDateTimePicker, {
            style: {
              marginTop: "-1px"
            },
            value: this.state.value,
            disabled: this.state.readOnly,
            locale: gA.lingua,
            clearable: true,
            todayLabel: _t[gA.lingua].oggi,
            onChange: this.state.onChange,
            cancelLabel: _t[gA.lingua].annulla,
            clearLabel: _t[gA.lingua].cancella,
            ampm: false,
            format: gA.formatData + ' ' + gA.formatTempo
          }))))
        );
      } else {
        return (
          /*#__PURE__*/
          React.createElement(ThemeProvider, {
            theme: materialTheme
          },
          /*#__PURE__*/
          React.createElement(FormControl, {
            className: classes.dateField
          },
          /*#__PURE__*/
          React.createElement(Typography$1, {
            variant: "caption",
            color: "textSecondary"
          }, this.state.etichetta),
          /*#__PURE__*/
          React.createElement(MuiPickersUtilsProvider, {
            utils: MomentUtils
          },
          /*#__PURE__*/
          React.createElement(KeyboardDatePicker, {
            style: {
              marginTop: "-1px"
            },
            value: this.state.value,
            disabled: this.state.readOnly,
            locale: gA.lingua,
            clearable: true,
            todayLabel: _t[gA.lingua].oggi,
            cancelLabel: _t[gA.lingua].annulla,
            clearLabel: _t[gA.lingua].cancella,
            onChange: this.state.onChange,
            format: gA.formatData
          }))))
        );
      }
    }
  }]);

  return GDateTimePure;
}(Component);

function TextMaskCustom(props) {
  var inputRef = props.inputRef,
      other = _objectWithoutProperties(props, ["inputRef"]);

  return (
    /*#__PURE__*/
    React.createElement(MaskedInput, Object.assign({}, other, {
      ref: function ref(_ref4) {
        inputRef(_ref4 ? _ref4.inputElement : null);
      },
      mask: props.picture,
      placeholderChar: ' ',
      showMask: true
    }))
  );
}

function NumberFormatCustom(props) {
  var inputRef = props.inputRef,
      onChange = props.onChange,
      other = _objectWithoutProperties(props, ["inputRef", "onChange"]);

  return (
    /*#__PURE__*/
    React.createElement(NumberFormat, Object.assign({}, other, {
      getInputRef: inputRef,
      onValueChange: function onValueChange(values) {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      },
      isNumericString: true,
      decimalSeparator: gA.valuta.separatoreDecimali,
      thousandSeparator: gA.valuta.separatoreMigliaia,
      prefix: gA.valuta.symbol
    }))
  );
}

var GEditPure =
/*#__PURE__*/
function (_Component6) {
  _inherits(GEditPure, _Component6);

  function GEditPure(props) {
    var _this7;

    _classCallCheck(this, GEditPure);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(GEditPure).call(this, props));
    _this7.state = {
      nomecampo: props.id,
      etichetta: props.label,
      onChange: props.onChange,
      onMessage: props.onMessage,
      maxLength: props.maxLength,
      placeholder: props.placeholder,
      readOnly: props.readOnly,
      upload: props.upload,
      help: props.help,
      type: props.type,
      campo: props.campo,
      value: "",
      stato: "",
      idCampo: props.idCampo,
      errore: ""
    };
    _this7.nomeFile = "";
    _this7.myEdit = null;
    _this7.customInput = {
      readOnly: _this7.state.readOnly
    };

    if (_this7.state.campo && _this7.state.campo.picture !== '') {
      var a = _this7.state.campo.picture.split(',');

      var ax = a.map(function (e) {
        return e.startsWith('/') ? new RegExp(e.substring(1)) : e;
      });
      _this7.customInput = {
        inputComponent: TextMaskCustom,
        readOnly: _this7.state.readOnly,
        inputProps: {
          picture: ax
        }
      };
    }

    if (_this7.state.type === 'currency') {
      _this7.state.type = 'text';
      _this7.customInput = {
        inputComponent: NumberFormatCustom,
        readOnly: _this7.state.readOnly
      };
    }

    return _this7;
  }

  _createClass(GEditPure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));
    }
  }, {
    key: "onMessage",
    value: function onMessage(valore) {
      if (this.state.campo && valore) {
        if (this.state.campo.hasFlag(EFlags.MAIUSCOLO)) valore = valore.toUpperCase();else if (this.state.campo.hasFlag(EFlags.MINUSCOLO)) valore = valore.toLowerCase();
        var v = this.state.campo.Validate(valore);

        if (v !== '') {
          this.setState({
            stato: "",
            errore: v
          });
          return false;
        } else {
          if (this.state.campo.tipo === ETipoCampo.CURRENCY) {
            this.setState({
              value: parseFloat(valore).toLocaleString(gA.valuta.locale, {
                style: 'decimal',
                minimumFractionDigits: gA.valuta.minimumFractionDigits
              }),
              stato: "",
              errore: ""
            });
          } else {
            this.setState({
              value: valore,
              stato: "",
              errore: ""
            });
          }

          return true;
        }
      } else {
        this.setState({
          value: valore,
          stato: "",
          errore: ""
        });
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var classes = this.props.classes;

      if (this.state.upload) {
        var opzioni = {
          baseUrl: gA.baseUrlServer + '/' + gA.comandoUpload,
          didChoose: function didChoose(files) {
            if (process.env.NODE_ENV === 'development') console.log('you choose', typeof files === 'string' ? files : files[0].name);

            _this8.setState({
              stato: "Pronto per l'invio di: " + (typeof files === 'string' ? files : files[0].name)
            });
          },
          beforeUpload: function beforeUpload(files) {
            if (typeof files === 'string') return true;

            if (files[0].size < 1024 * 1024 * 2000) {
              return true;
            }

            return false;
          },
          didUpload: function didUpload(files) {
            if (process.env.NODE_ENV === 'development') console.log('you just uploaded', typeof files === 'string' ? files : files[0].name);

            _this8.setState({
              stato: "Invio in corso..."
            });

            _this8.nomeFile = files[0].name;
          },
          uploading: function uploading(progress) {
            if (process.env.NODE_ENV === 'development') console.log('loading...', progress.loaded / progress.total + '%');

            _this8.setState({
              stato: 'caricamento... ' + progress.loaded / progress.total + '%'
            });
          },
          uploadSuccess: function uploadSuccess(resp) {
            if (process.env.NODE_ENV === 'development') console.log('upload success!');

            _this8.state.onChange({
              target: {
                value: _this8.nomeFile
              }
            });

            _this8.setState({
              stato: 'Completato'
            });
          },
          uploadError: function uploadError(err) {
            alert(err.message);
          }
        };
        return (
          /*#__PURE__*/
          React.createElement("div", null,
          /*#__PURE__*/
          React.createElement(TextField, {
            label: this.state.etichetta,
            id: this.state.nomecampo,
            disabled: true,
            inputProps: {
              maxLength: this.state.maxLength
            },
            value: this.state.value || "",
            name: this.state.nomecampo,
            autoComplete: "off",
            type: this.state.type,
            className: classes.textField,
            placeholder: this.state.placeholder,
            onChange: this.state.onChange
          }),
          /*#__PURE__*/
          React.createElement(ReactUploadFile, {
            chooseFileButton:
            /*#__PURE__*/
            React.createElement(Button, null, "Seleziona file"),
            idAnag: gA.parametri.Get("id_anag"),
            idCampo: this.state.idCampo,
            uploadFileButton:
            /*#__PURE__*/
            React.createElement("div", {
              style: {
                display: 'inline-block'
              }
            },
            /*#__PURE__*/
            React.createElement(Button, {
              name: 'bS' + this.state.nomecampo
            }, "Invia"),
            /*#__PURE__*/
            React.createElement(FormLabel, {
              style: {
                marginLeft: "10px"
              }
            }, this.state.stato)),
            options: opzioni
          }))
        );
      } else {
        return (
          /*#__PURE__*/
          React.createElement(TextField, {
            id: this.state.nomecampo,
            autoComplete: "off",
            label: this.state.etichetta,
            className: classes.textField,
            inputProps: {
              maxLength: this.state.maxLength,
              autoComplete: 'off'
            },
            InputProps: this.customInput,
            value: this.state.value || "",
            name: this.state.nomecampo,
            type: this.state.type,
            placeholder: this.state.placeholder,
            onChange: this.state.onChange,
            helperText: this.state.errore,
            error: this.state.errore != '',
            InputLabelProps: {
              shrink: true
            }
          })
        );
      }
    }
  }]);

  return GEditPure;
}(Component);

var GMemoPure =
/*#__PURE__*/
function (_Component7) {
  _inherits(GMemoPure, _Component7);

  function GMemoPure(props) {
    var _this9;

    _classCallCheck(this, GMemoPure);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(GMemoPure).call(this, props));
    _this9.state = {
      nomecampo: props.id,
      etichetta: props.label,
      onChange: props.onChange,
      onMessage: props.onMessage,
      maxLength: props.maxLength,
      placeholder: props.placeholder,
      readOnly: props.readOnly,
      righe: props.righe,
      help: props.help,
      type: props.type,
      value: ""
    };
    return _this9;
  }

  _createClass(GMemoPure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));
    }
  }, {
    key: "onMessage",
    value: function onMessage(valore) {
      this.setState({
        value: valore
      });
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return (
        /*#__PURE__*/
        React.createElement(TextField, {
          id: this.state.nomecampo,
          autoComplete: "off",
          InputProps: {
            readOnly: this.state.readOnly
          },
          label: this.state.etichetta,
          multiline: true,
          rows: this.state.righe,
          className: classes.textField,
          inputProps: {
            maxLength: this.state.maxLength
          },
          value: this.state.value || "",
          name: this.state.nomecampo,
          type: this.state.type,
          placeholder: this.state.placeholder,
          onChange: this.state.onChange
        })
      );
    }
  }]);

  return GMemoPure;
}(Component);

var GCheckboxPure =
/*#__PURE__*/
function (_Component8) {
  _inherits(GCheckboxPure, _Component8);

  function GCheckboxPure(props) {
    var _this10;

    _classCallCheck(this, GCheckboxPure);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(GCheckboxPure).call(this, props));
    _this10.state = {
      nomecampo: props.id,
      etichetta: props.label,
      onChange: props.onChange,
      onMessage: props.onMessage,
      maxLength: props.maxLength,
      readOnly: props.readOnly,
      placeholder: props.placeholder,
      type: props.type,
      help: props.help,
      value: false
    };
    return _this10;
  }

  _createClass(GCheckboxPure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));
    }
  }, {
    key: "onMessage",
    value: function onMessage(valore) {
      this.setState({
        value: valore === 1 || valore ? true : false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return (
        /*#__PURE__*/
        React.createElement(FormControlLabel, {
          className: classes.textField,
          variant: "caption",
          control:
          /*#__PURE__*/
          React.createElement(Checkbox, {
            id: this.state.nomecampo,
            disabled: this.state.readOnly,
            name: this.state.nomecampo,
            checked: this.state.value,
            onChange: this.state.onChange,
            value: "checkedA"
          }),
          classes: {
            label: classes.label2
          },
          label: this.state.etichetta
        })
      );
    }
  }]);

  return GCheckboxPure;
}(Component);

function NoOptionsMessage(props) {
  return (
    /*#__PURE__*/
    React.createElement(Typography$1, Object.assign({
      color: "textSecondary",
      className: props.selectProps.classes.noOptionsMessage
    }, props.innerProps), props.children)
  );
}

function inputComponent(_ref5) {
  var inputRef = _ref5.inputRef,
      props = _objectWithoutProperties(_ref5, ["inputRef"]);

  return (
    /*#__PURE__*/
    React.createElement("div", Object.assign({
      ref: inputRef
    }, props))
  );
}

function Control(props) {
  var children = props.children,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      _props$selectProps = props.selectProps,
      classes = _props$selectProps.classes,
      TextFieldProps = _props$selectProps.TextFieldProps;
  return (
    /*#__PURE__*/
    React.createElement(TextField, Object.assign({
      style: {
        marginTop: "-5px"
      },
      fullWidth: true,
      InputProps: {
        inputComponent: inputComponent,
        inputProps: _objectSpread({
          className: classes.input,
          ref: innerRef,
          children: children
        }, innerProps)
      }
    }, TextFieldProps))
  );
}

function Option(props) {
  return (
    /*#__PURE__*/
    React.createElement(MenuItem, Object.assign({
      ref: props.innerRef,
      selected: props.isFocused,
      component: "div",
      style: {
        fontWeight: props.isSelected ? 500 : 400
      }
    }, props.innerProps), props.children)
  );
}

function Placeholder(props) {
  return (
    /*#__PURE__*/
    React.createElement(Typography$1, Object.assign({
      color: "textSecondary",
      className: props.selectProps.classes.placeholder
    }, props.innerProps), props.children)
  );
}

function SingleValue(props) {
  return (
    /*#__PURE__*/
    React.createElement(Typography$1, Object.assign({
      className: props.selectProps.classes.singleValue
    }, props.innerProps), props.children)
  );
}

function ValueContainer(props) {
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: props.selectProps.classes.valueContainer
    }, props.children)
  );
}

function MultiValue(props) {
  return (
    /*#__PURE__*/
    React.createElement(Chip, {
      tabIndex: -1,
      label: props.children,
      className: clsx$1(props.selectProps.classes.chip, _defineProperty({}, props.selectProps.classes.chipFocused, props.isFocused)),
      onDelete: props.removeProps.onClick,
      deleteIcon:
      /*#__PURE__*/
      React.createElement(CancelIcon, props.removeProps)
    })
  );
}

function SMenu(props) {
  return (
    /*#__PURE__*/
    React.createElement(Paper, Object.assign({
      square: true,
      className: props.selectProps.classes.paper
    }, props.innerProps), props.children)
  );
}

var components = {
  Control: Control,
  Menu: SMenu,
  MultiValue: MultiValue,
  NoOptionsMessage: NoOptionsMessage,
  Option: Option,
  Placeholder: Placeholder,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

var GSelectPure =
/*#__PURE__*/
function (_Component9) {
  _inherits(GSelectPure, _Component9);

  function GSelectPure(props) {
    var _this11;

    _classCallCheck(this, GSelectPure);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(GSelectPure).call(this, props));
    _this11.state = {
      nomecampo: props.id,
      etichetta: props.label,
      onChange: props.onChange,
      onMessage: props.onMessage,
      maxLength: props.maxLength,
      placeholder: props.placeholder,
      readOnly: props.readOnly,
      help: props.help,
      type: props.type,
      isMulti: props.isMulti,
      value: null,
      valueDescr: "",
      options: [],
      campo: props.campo
    };
    _this11.oggetti = props.oggetti;
    _this11.getOptions = _this11.getOptions.bind(_assertThisInitialized(_this11));
    _this11.ricercaElementi = _this11.ricercaElementi.bind(_assertThisInitialized(_this11));
    _this11.risultatoRicerca = _this11.risultatoRicerca.bind(_assertThisInitialized(_this11));
    _this11.callback = null;
    _this11.input = "";
    _this11.idTime = null;
    return _this11;
  }

  _createClass(GSelectPure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));

      if (this.state.campo.hasFlag(EFlags.QUERY)) {
        this.input = "";
        this.callback = this.myCallback;
        this.ricercaElementi();
      }
    }
  }, {
    key: "onMessage",
    value: function onMessage(valore, valoreDescrizione) {
      if (this.state.isMulti) {
        if (Array.isArray(valore)) {
          this.setState({
            value: valore
          });
        } else {
          this.setState({
            value: []
          });
        }
      } else {
        if (this.state.campo.hasFlag(EFlags.QUERY)) {
          if (valore === null) this.setState({
            value: null
          });else this.setState({
            value: {
              value: valore,
              label: valoreDescrizione
            }
          });
        } else {
          if (valore === null) this.setState({
            value: null
          });else this.setState({
            value: {
              value: valore,
              label: valoreDescrizione
            },
            options: [{
              value: valore,
              label: valoreDescrizione
            }]
          });
        }
      }
    }
  }, {
    key: "risultatoRicerca",
    value: function risultatoRicerca(risultato) {
      if (risultato.error != null) alert(risultato.error);else {
        var righe = [];

        for (var i = 0; i < risultato.length; i++) {
          righe.push({
            value: risultato[i][this.state.campo.fieldKey],
            label: risultato[i][this.state.campo.fieldResult]
          });
        }

        this.callback(righe, {
          options: righe,
          complete: true
        });
      }
    }
  }, {
    key: "ricercaElementi",
    value: function ricercaElementi() {
      var valori = {};
      if (this.state.campo.addWhere.length > 0) valori[this.state.campo.addWhere] = this.oggetti.GetCampo(this.state.campo.addWhere).valore;
      valori['input'] = this.input + '%';
      this.oggetti.db.rawQuery(this.risultatoRicerca, this.oggetti.nomeform + '#sT' + this.state.campo.solocampo, valori);
    }
  }, {
    key: "myCallback",
    value: function myCallback(err, data) {
      this.setState({
        options: data.options
      });
    }
  }, {
    key: "getOptions",
    value: function getOptions(input, callback) {
      this.callback = callback;
      this.input = input;

      if (this.idTime != null) {
        clearTimeout(this.idTime);
        this.idTime = null;
      }

      if (input.length > 0) {
        this.idTime = setTimeout(this.ricercaElementi, 500);
      } else {
        callback(null, {
          complete: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      var opzione = {};
      var placeholder = _t[gA.lingua].select;
      var Componente = Select;

      if (!this.state.campo.hasFlag(EFlags.QUERY)) {
        opzione = {
          loadOptions: this.getOptions
        };
        Componente = AsyncSelect;
        placeholder = _t[gA.lingua].scriviPerCercare;
      }

      if (this.state.readOnly) {
        return (
          /*#__PURE__*/
          React.createElement(TextField, {
            id: this.state.nomecampo,
            InputProps: {
              readOnly: this.state.readOnly
            },
            value: this.state.value == null ? '' : this.state.value.label,
            className: classes.textField,
            name: this.state.nomecampo,
            placeholder: this.state.placeholder,
            label: this.state.etichetta,
            InputLabelProps: {
              shrink: true
            }
          })
        );
      } else {
        return (
          /*#__PURE__*/
          React.createElement(FormControl, {
            className: classes.dateField
          },
          /*#__PURE__*/
          React.createElement(Typography$1, {
            variant: "caption",
            color: "textSecondary"
          }, this.state.etichetta),
          /*#__PURE__*/
          React.createElement(Componente, Object.assign({
            id: this.state.nomecampo,
            noOptionsMessage: function noOptionsMessage() {
              return _t[gA.lingua].noResult;
            },
            autoload: false,
            inputProps: {
              autoComplete: "off"
            },
            isClearable: true
          }, opzione, {
            isMulti: this.state.isMulti,
            options: this.state.options,
            classes: classes,
            components: components,
            loadingMessage: function loadingMessage() {
              return _t[gA.lingua].stoCercando;
            },
            value: this.state.value,
            name: this.state.nomecampo,
            placeholder: placeholder,
            onChange: this.state.onChange,
            styles: {
              input: function input() {
                return {
                  color: classes.colorInput
                };
              }
            }
          })))
        );
      }
    }
  }]);

  return GSelectPure;
}(Component);

var GButton =
/*#__PURE__*/
function (_Component10) {
  _inherits(GButton, _Component10);

  function GButton(props) {
    var _this12;

    _classCallCheck(this, GButton);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(GButton).call(this, props));
    _this12.state = {
      nomecampo: props.id,
      etichetta: props.label,
      onClick: props.onClick,
      onMessage: props.onMessage,
      maxLength: props.maxLength,
      readOnly: props.readOnly,
      placeholder: props.placeholder,
      oggetti: props.oggetti,
      type: props.type,
      help: props.help,
      value: false
    };
    _this12.formModal = null;
    return _this12;
  }

  _createClass(GButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));
    }
  }, {
    key: "onMessage",
    value: function onMessage() {
      if (gA.userEvents != null) this.formModal = gA.userEvents.funzione(this.state.oggetti.nomeform, this.state.nomecampo, this, this.state.oggetti);
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        React.createElement("div", null,
        /*#__PURE__*/
        React.createElement("br", null),
        /*#__PURE__*/
        React.createElement(Button, {
          id: this.state.nomecampo,
          disabled: this.state.readOnly,
          name: this.state.nomecampo,
          onClick: this.state.onClick
        }, this.state.etichetta), this.formModal)
      );
    }
  }]);

  return GButton;
}(Component);

var GButtonBarPure =
/*#__PURE__*/
function (_Component11) {
  _inherits(GButtonBarPure, _Component11);

  function GButtonBarPure(props) {
    var _this13;

    _classCallCheck(this, GButtonBarPure);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(GButtonBarPure).call(this, props));
    _this13.state = {
      nomecampo: props.id,
      onClick: props.onClick,
      onMessage: props.onMessage,
      maxLength: props.maxLength,
      readOnly: props.readOnly,
      placeholder: props.placeholder,
      oggetti: props.oggetti,
      type: props.type,
      help: props.help,
      value: false
    };
    _this13.formModal = null;
    return _this13;
  }

  _createClass(GButtonBarPure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));
    }
  }, {
    key: "onMessage",
    value: function onMessage(obj) {
      this.setState(obj);
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return (
        /*#__PURE__*/
        React.createElement(Button, {
          color: this.props.color,
          id: this.state.nomecampo,
          disabled: this.state.readOnly,
          size: this.props.size,
          name: this.state.nomecampo,
          onClick: this.state.onClick,
          classes: {
            label: classes.label
          }
        }, this.props.children, isWidthUp('sm', this.props.width) ? this.props.label : '')
      );
    }
  }]);

  return GButtonBarPure;
}(Component);

var GImagePure =
/*#__PURE__*/
function (_Component12) {
  _inherits(GImagePure, _Component12);

  function GImagePure(props) {
    var _this14;

    _classCallCheck(this, GImagePure);

    _this14 = _possibleConstructorReturn(this, _getPrototypeOf(GImagePure).call(this, props));
    _this14.state = {
      nomecampo: props.id,
      onChange: props.onChange,
      onMessage: props.onMessage,
      maxLength: props.maxLength,
      readOnly: props.readOnly,
      placeholder: props.placeholder,
      oggetti: props.oggetti,
      cartella: props.cartella,
      max_w: props.max_w,
      max_h: props.max_h,
      crop: props.crop,
      type: props.type,
      help: props.help,
      value: '',
      open: false,
      etichetta: props.label,
      anchorEl: null,
      immagini: [],
      attesa: false,
      inserimento: false
    };
    _this14.formModal = null;
    _this14.myRef = React.createRef();
    return _this14;
  }

  _createClass(GImagePure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));
    }
  }, {
    key: "onMessage",
    value: function onMessage(valore, inserimento) {
      this.setState({
        value: valore,
        inserimento: inserimento
      });
    }
  }, {
    key: "inviaImmagine",
    value: function inviaImmagine(immagine, old) {
      var _this15 = this;

      fetch(gA.baseUrlServer + '/' + gA.pathUploadImmagine, {
        method: 'POST',
        body: procUtils.createFormDataWithPhoto(immagine, {
          idAnag: gA.parametri.Get("id_azienda"),
          idCampo: this.state.nomecampo,
          token: gA.token,
          imgDelete: old,
          mw: this.state.max_w,
          mh: this.state.max_h,
          crop: this.state.crop
        })
      }).then(function (risposta) {
        if (gA.DEBUG) console.log("OK invio evento prima di json:", risposta);
        return risposta.json();
      }).then(function (risposta) {
        if (gA.DEBUG) console.log("OK invio evento dopo json:", risposta);

        if (risposta != undefined && risposta.risultato === 'OK') {
          _this15.state.onChange(risposta.path);
        }

        _this15.setState({
          attesa: false
        });
      }).catch(function (error) {
        _this15.setState({
          attesa: false
        });

        console.error("Errore invio evento:", error);
      });
      this.setState({
        attesa: true
      });
    }
  }, {
    key: "handleFileImage",
    value: function handleFileImage(event) {
      if (event.target.files.length > 0) {
        var f = event.target.files[0];

        if (f.size > gA.MAX_UPLOAD_SIZE) {
          alert('Immagine troppo grande, la massima dimensione è di ' + gA.MAX_UPLOAD_SIZE + ' bytes');
        } else {
          this.inviaImmagine(f, this.state.value);
        }
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      this.setState({
        anchorEl: e.target
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        anchorEl: null
      });
    }
  }, {
    key: "handleUpload",
    value: function handleUpload() {
      this.myRef.current.click();
      this.setState({
        anchorEl: null
      });
    }
  }, {
    key: "cancellaImmagine",
    value: function cancellaImmagine(immagine) {
      var _this16 = this;

      procUtils.asyncRequestGet(gA.pathDeleteImmagine, {
        imgDelete: immagine
      }).then(function (risposta) {
        if (gA.DEBUG) console.log("OK invio evento prima di json:", risposta);
        return risposta.json();
      }).then(function (risposta) {
        if (gA.DEBUG) console.log("OK invio evento dopo json:", risposta);

        if (risposta != undefined && risposta.risultato === 'OK') {
          _this16.state.onChange('');
        }
      }).catch(function (error) {
        console.error("Errore invio evento:", error);
      });
    }
  }, {
    key: "handleCancella",
    value: function handleCancella() {
      this.cancellaImmagine(this.state.value);
      this.setState({
        anchorEl: null
      });
    }
  }, {
    key: "getGalleria",
    value: function getGalleria() {
      var _this17 = this;

      procUtils.asyncRequestGet(gA.pathGallery, {
        sub: this.state.cartella
      }).then(function (risposta) {
        if (gA.DEBUG) console.log("OK invio evento prima di json:", risposta);
        return risposta.json();
      }).then(function (risposta) {
        if (gA.DEBUG) console.log("OK invio evento dopo json:", risposta);

        _this17.setState({
          immagini: risposta,
          open: true
        });
      }).catch(function (error) {
        console.error("Errore invio evento:", error);
      });
    }
  }, {
    key: "handleGallery",
    value: function handleGallery() {
      this.getGalleria();
      this.setState({
        anchorEl: null
      });
    }
  }, {
    key: "selectGallery",
    value: function selectGallery(immagine) {
      this.state.onChange(immagine);
      this.setState({
        open: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this18 = this;

      var classes = this.props.classes;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classes.immagine
        },
        /*#__PURE__*/
        React.createElement(Dialog, {
          open: this.state.open,
          "aria-labelledby": "alert-dialog-title",
          "aria-describedby": "alert-dialog-description"
        },
        /*#__PURE__*/
        React.createElement(DialogTitle, {
          id: "alert-dialog-title"
        }, _t[gA.lingua].galleria),
        /*#__PURE__*/
        React.createElement(DialogContent, null,
        /*#__PURE__*/
        React.createElement(GridList, {
          cellHeight: 100,
          className: classes.gridList
        }, this.state.immagini.map(function (tile) {
          return (
            /*#__PURE__*/
            React.createElement(GridListTile, {
              key: tile.img
            },
            /*#__PURE__*/
            React.createElement("img", {
              src: gA.baseUrlServer + '/' + tile.img,
              className: classes.tile,
              alt: tile.title
            }),
            /*#__PURE__*/
            React.createElement(GridListTileBar, {
              title: tile.title,
              actionIcon:
              /*#__PURE__*/
              React.createElement(IconButton, {
                "aria-label": "info about ".concat(tile.title),
                className: classes.icon,
                onClick: function onClick() {
                  return _this18.selectGallery(tile.img);
                }
              },
              /*#__PURE__*/
              React.createElement(Icon, null, "check"))
            }))
          );
        }))),
        /*#__PURE__*/
        React.createElement(DialogActions, null,
        /*#__PURE__*/
        React.createElement(Button, {
          onClick: function onClick() {
            return _this18.setState({
              open: false
            });
          },
          variant: "contained",
          color: "secondary"
        }, _t[gA.lingua].annulla))),
        /*#__PURE__*/
        React.createElement(Typography$1, {
          variant: "caption",
          disabled: true
        }, this.state.etichetta), this.state.readOnly ?
        /*#__PURE__*/
        React.createElement("img", {
          className: classes.immagine,
          alt: this.state.etichetta,
          width: "100%",
          src: gA.baseUrlServer + '/' + this.state.value
        }) : this.state.attesa ?
        /*#__PURE__*/
        React.createElement(CircularProgress$1, null) : this.state.inserimento ?
        /*#__PURE__*/
        React.createElement(Icon, {
          style: {
            fontSize: 60
          }
        }, "add_a_photo") : this.state.value ?
        /*#__PURE__*/
        React.createElement(Fragment, null,
        /*#__PURE__*/
        React.createElement(ButtonBase, {
          onClick: this.handleClick.bind(this)
        },
        /*#__PURE__*/
        React.createElement("img", {
          alt: this.state.etichetta,
          width: this.props.width,
          height: this.props.height,
          src: gA.baseUrlServer + '/' + this.state.value
        })),
        /*#__PURE__*/
        React.createElement("form", {
          action: "#"
        },
        /*#__PURE__*/
        React.createElement("input", {
          hidden: true,
          type: "file",
          id: this.state.nomecampo + "selectImage",
          multiple: true,
          accept: "image/jpeg, image/png",
          ref: this.myRef,
          onChange: this.handleFileImage.bind(this)
        }), " "),
        /*#__PURE__*/
        React.createElement(Menu, {
          id: "menu-immagine",
          variant: "menu",
          anchorEl: this.state.anchorEl,
          open: Boolean(this.state.anchorEl),
          onClose: this.handleClose.bind(this)
        },
        /*#__PURE__*/
        React.createElement(MenuItem, {
          onClick: this.handleCancella.bind(this)
        }, _t[gA.lingua].cancellaImmagine), gA.pathGallery &&
        /*#__PURE__*/
        React.createElement(MenuItem, {
          onClick: this.handleGallery.bind(this)
        }, _t[gA.lingua].scegliImmagine),
        /*#__PURE__*/
        React.createElement(MenuItem, {
          onClick: this.handleUpload.bind(this)
        }, _t[gA.lingua].uploadImmagine))) :
        /*#__PURE__*/
        React.createElement("div", {
          className: classes.emptyPhoto
        },
        /*#__PURE__*/
        React.createElement(IconButton, {
          color: "default",
          component: "span",
          disabled: this.state.readOnly,
          onClick: this.handleClick.bind(this)
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          style: {
            fontSize: 60
          }
        }, "add_a_photo")), !this.state.readOnly &&
        /*#__PURE__*/
        React.createElement(Typography$1, {
          variant: "body1",
          disabled: true
        }, _t[gA.lingua].vuoto),
        /*#__PURE__*/
        React.createElement("form", {
          action: "#"
        },
        /*#__PURE__*/
        React.createElement("input", {
          hidden: true,
          type: "file",
          id: this.state.nomecampo + "selectImage",
          ref: this.myRef,
          multiple: true,
          accept: "image/png,image/jpeg",
          onChange: this.handleFileImage.bind(this)
        }), " "),
        /*#__PURE__*/
        React.createElement(Menu, {
          id: "menu-immagine",
          variant: "menu",
          anchorEl: this.state.anchorEl,
          open: Boolean(this.state.anchorEl),
          onClose: this.handleClose.bind(this)
        }, gA.pathGallery &&
        /*#__PURE__*/
        React.createElement(MenuItem, {
          onClick: this.handleGallery.bind(this)
        }, _t[gA.lingua].scegliImmagine),
        /*#__PURE__*/
        React.createElement(MenuItem, {
          onClick: this.handleUpload.bind(this)
        }, _t[gA.lingua].uploadImmagine))))
      );
    }
  }]);

  return GImagePure;
}(Component);

var GDateTime = withStyles(styles$2)(GDateTimePure);
var GMemo = withStyles(styles$2)(GMemoPure);
var GEdit = withStyles(styles$2)(GEditPure);
var GSelect = withStyles(styles$2)(GSelectPure);
var GButtonBar = withWidth()(withStyles(styles$2)(GButtonBarPure));
var GImage = withWidth()(withStyles(styles$2)(GImagePure));
var GCheckbox = withWidth()(withStyles(styles$2)(GCheckboxPure));

var styles$3 = function styles$3(theme) {
  return {
    hide: {
      display: "none"
    },
    show: {
      display: "block"
    },
    wait: {
      display: 'flex',
      justifyContent: 'center',
      margin: theme.spacing(2)
    },
    root: {
      textAlign: 'left',
      padding: "5px"
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'left',
      color: theme.palette.text.secondary
    },
    rightIcon: {
      marginLeft: theme.spacing()
    },
    colxs: {
      backgroundColor: "green",
      border: "1px",
      borderColor: "white",
      borderStyle: "solid"
    },
    fissi: {
      backgroundColor: "#87c9ec",
      border: "1px",
      borderColor: "white",
      borderStyle: "solid",
      padding: "3px 10px 3px 10px"
    },
    content: {
      width: "95%"
    },
    header: {
      backgroundColor: '#87c9ec',
      color: '#FFF'
    },
    appBar: _defineProperty({
      top: 'auto',
      bottom: 0,
      marginLeft: gA.drawerWidth
    }, theme.breakpoints.up('md'), {
      width: "calc(100% - ".concat(gA.drawerWidth, "px)")
    }),
    toolbar: {
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    tabs: {
      backgroundColor: "#d0d0e1"
    }
  };
};

var GSubForm =
/*#__PURE__*/
function (_Component13) {
  _inherits(GSubForm, _Component13);

  function GSubForm(props) {
    var _this19;

    _classCallCheck(this, GSubForm);

    _this19 = _possibleConstructorReturn(this, _getPrototypeOf(GSubForm).call(this, props));
    _this19.state = {
      nomecampo: props.id,
      onChange: props.onChange,
      onMessage: props.onMessage,
      readOnly: props.readOnly,
      help: props.help,
      modificato: false,
      value: "",
      dati: null,
      rID: 0
    };
    _this19.baseUrl = _this19.props.baseUrl;
    _this19.paginaCorrente = "elenco";
    _this19.sf = props.subform;
    _this19.colonne = [];
    _this19.campo = props.campo;
    _this19.oggetti = props.oggetti;
    _this19.esisteSomma = false;
    _this19.solaLettura = false;
    _this19.onReadDatabase = _this19.onReadDatabase.bind(_assertThisInitialized(_this19));
    _this19.onSubMessage = _this19.onSubMessage.bind(_assertThisInitialized(_this19));
    _this19.handleSubmit = _this19.handleSubmit.bind(_assertThisInitialized(_this19));
    _this19.handleReset = _this19.handleReset.bind(_assertThisInitialized(_this19));
    _this19.cancellaRecord = _this19.cancellaRecord.bind(_assertThisInitialized(_this19));
    _this19.SalvaDati = _this19.SalvaDati.bind(_assertThisInitialized(_this19));
    _this19.fatto = _this19.fatto.bind(_assertThisInitialized(_this19));
    _this19.editaRiga = _this19.editaRiga.bind(_assertThisInitialized(_this19));
    _this19.rispostaMemo = _this19.rispostaMemo.bind(_assertThisInitialized(_this19));
    _this19.onDeletedRecord = _this19.onDeletedRecord.bind(_assertThisInitialized(_this19));
    _this19.elementi = [];
    _this19.rigaCorrente = null;
    _this19.currentID = 0;
    _this19.sf.fieldkey = _this19.campo.fieldMemo;
    _this19.sf.fieldkeysolocampo = procUtils.GetNomeCampo(_this19.campo.fieldMemo);

    for (var n = 0; n < _this19.sf.colonne.length; n++) {
      if (_this19.sf.colonne[n].tipo !== ETipoCampo.PROCEDURA) {
        if (_this19.sf.colonne[n].hasFlag(EFlags.CHIAVE)) _this19.sf.chiaveprimaria = _this19.sf.colonne[n].solocampo;
        if (_this19.sf.colonne[n].hasFlag(EFlags.SOMMA)) _this19.esisteSomma = true;

        if (_this19.sf.colonne[n].procEtichetta.length > 0) {
          var r = gA.userEvents.funzione(_this19.oggetti.nomeform, _this19.sf.colonne[n].procEtichetta, _assertThisInitialized(_this19), _this19.oggetti);

          if (r.length > 0) {
            _this19.sf.colonne[n].etichetta = r;
            _this19.sf.colonne[n].flags |= EFlags.VISIBILE;
          } else {
            _this19.sf.colonne[n].flags &= EFlags.MASK - EFlags.VISIBILE;
          }
        }
      }
    }

    if (gA.userEvents != null) gA.userEvents.funzione(_this19.oggetti.nomeform, "subOnCreate", _assertThisInitialized(_this19), _this19.oggetti);

    _this19.GeneraColonne();

    _this19.GeneraCampi();

    return _this19;
  }

  _createClass(GSubForm, [{
    key: "onReadDatabase",
    value: function onReadDatabase(risultato) {
      if (risultato.error != null) alert(risultato.error);else {
        this.setState({
          dati: risultato
        });

        if (this.paginaCorrente === "dettaglio") {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = risultato[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var riga = _step.value;

              if (riga[this.sf.chiaveprimaria] == this.currentID) {
                this.currentID = 0;
                this.rigaCorrente = riga;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));
    }
  }, {
    key: "onMessage",
    value: function onMessage(comando, valore) {
      if (comando === "O") {
        this.Open(valore);
        this.setState({
          rID: valore
        });
      } else if (comando === 'S') {
        this.handleSubmit(valore);
      } else if (comando === 'D') {
        this.fatto(valore);
      } else if (comando === 'E') {
        this.cancellaRecord(valore);
      } else if (comando === 'I') {
        this.handleInsertButtonClick(valore);
      } else if (comando === 'R') {
        this.handleReset(valore);
      }
    }
  }, {
    key: "onSubMessage",
    value: function onSubMessage(nomecolonna, handle) {
      this.sf.GetColonna(nomecolonna).handle = handle;
    }
  }, {
    key: "rispostaMemo",
    value: function rispostaMemo(risultato) {
      if (risultato.error != null) {
        alert('Errore SQL: ' + risultato.error);
      } else {
        this.inEdit(false);

        if (!this.inserimentoContinuativo) {
          this.attivaCampi();
          this.Open(this.state.rID);
          if (this.rigaCorrente === null) this.currentID = risultato.lastID;
        } else {
          this.inserimentoContinuativo = false;
          this.svuotaForm();
        }
      }
    }
  }, {
    key: "inEdit",
    value: function inEdit(stato) {
      if (stato === true) {
        if (!this.state.modificato) {
          this.state.onChange('E');
          this.setState({
            modificato: true
          });
        }
      } else {
        if (this.state.modificato) {
          this.state.onChange('S');
          this.setState({
            modificato: false
          });
        }
      }
    }
  }, {
    key: "GeneraCampi",
    value: function GeneraCampi() {
      var w;
      var maxW;
      var wCol = 50;
      var wColM = 100;
      var wS = 0;
      var wM = 0;
      var colonna;
      var aCampi = [];
      maxW = gA.MAX_WIDTH;

      for (var i = 0; i < this.sf.colonne.length; i++) {
        colonna = this.sf.colonne[i];
        if ((colonna.hasFlag(EFlags.VISIBILE) || colonna.hasFlag(EFlags.CHIAVE) || colonna.valoreIniziale !== "" || colonna.solocampo.toUpperCase() === this.sf.fieldkeysolocampo.toUpperCase() || colonna.solocampo.toUpperCase() === "VALUTA") && colonna.tipo !== ETipoCampo.PROCEDURA && !colonna.hasFlag(EFlags.NOT_UPDATE)) ;

        if (colonna.hasFlag(EFlags.VISIBILE)) {
          w = colonna.lunghezza * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X;
          if (w > maxW) w = maxW;
          if (colonna.tipo === ETipoCampo.BOOLEANO) w = colonna.etichetta.length * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X + 20;else if (colonna.tipo === ETipoCampo.DATAORA) {
            w = 14 * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X;
          } else if (colonna.tipo === ETipoCampo.TABELLA) {
            w = colonna.lunghezza * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X + 24;
          } else if (colonna.tipo === ETipoCampo.DATA) {
            w = 10 * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X;
          } else if (colonna.tipo === ETipoCampo.TELEFONICO) {
            w += 40;
          }
          wS = Math.floor(w / wCol);
          if (wS < 2) wS = 2;
          if (wS > 12) wS = 12;
          wM = Math.floor(w / wColM);
          if (wM < 1) wM = 1;
          if (wM > 12) wM = 12;

          if (colonna.tipo === ETipoCampo.ALFA || colonna.tipo === ETipoCampo.NUMERO || colonna.tipo === ETipoCampo.INTERO || colonna.tipo === ETipoCampo.MEMO || colonna.tipo === ETipoCampo.CRIPTATO || colonna.tipo === ETipoCampo.CURRENCY) {
            var tipo = "text";
            if (colonna.tipo === ETipoCampo.INTERO) tipo = "number";
            if (colonna.tipo === ETipoCampo.NUMERO) tipo = "number";
            if (colonna.tipo === ETipoCampo.CURRENCY) tipo = "currency";
            if (colonna.hasFlag(EFlags.FORZA_NUMERICO)) tipo = "number";
            if (colonna.hasFlag(EFlags.FORZA_PASSWORD)) tipo = "password";

            if (colonna.tipo === ETipoCampo.MEMO) {
              aCampi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                xs: wS,
                sm: wM
              },
              /*#__PURE__*/
              React.createElement(GMemo, {
                id: colonna.solocampo,
                readOnly: colonna.hasFlag(EFlags.READONLY),
                onMessage: this.onSubMessage,
                label: colonna.etichetta,
                help: colonna.aiuto,
                onChange: this.handleChange.bind(this, colonna)
              })));
            } else {
              aCampi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                xs: wS,
                sm: wM
              },
              /*#__PURE__*/
              React.createElement(GEdit, {
                id: colonna.solocampo,
                campo: colonna,
                onMessage: this.onSubMessage,
                readOnly: colonna.hasFlag(EFlags.READONLY),
                maxLength: colonna.lunghezza,
                name: colonna.solocampo,
                type: tipo,
                label: colonna.etichetta,
                help: colonna.aiuto,
                onChange: this.handleChange.bind(this, colonna)
              })));
            }
          } else if (colonna.tipo === ETipoCampo.TABELLA) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GSelect, {
              id: colonna.solocampo,
              campo: colonna,
              oggetti: this.oggetti,
              readOnly: colonna.hasFlag(EFlags.READONLY),
              onMessage: this.onSubMessage,
              maxLength: colonna.lunghezza,
              name: colonna.solocampo,
              type: "text",
              label: colonna.etichetta,
              help: colonna.aiuto,
              onChange: this.handleChangeSelect.bind(this, colonna)
            })));
          } else if (colonna.tipo === ETipoCampo.MULTISELECT) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GSelect, {
              id: colonna.solocampo,
              isMulti: true,
              campo: colonna,
              oggetti: this.oggetti,
              readOnly: colonna.hasFlag(EFlags.READONLY),
              onMessage: this.onSubMessage,
              maxLength: colonna.lunghezza,
              name: colonna.solocampo,
              type: "text",
              label: colonna.etichetta,
              help: colonna.aiuto,
              onChange: this.handleChangeSelect.bind(this, colonna)
            })));
          } else if (colonna.tipo === ETipoCampo.DATA) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GDateTime, {
              id: colonna.solocampo,
              readOnly: colonna.hasFlag(EFlags.READONLY),
              onMessage: this.onSubMessage,
              dateFormat: gA.formatData,
              timeFormat: "",
              label: colonna.etichetta,
              help: colonna.aiuto,
              onChange: this.handleChangeDate.bind(this, colonna)
            })));
          } else if (colonna.tipo === ETipoCampo.DATAORA) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GDateTime, {
              id: colonna.solocampo,
              readOnly: colonna.hasFlag(EFlags.READONLY),
              onMessage: this.onSubMessage,
              dateFormat: gA.formatData,
              timeFormat: gA.formatTempo,
              label: colonna.etichetta,
              help: colonna.aiuto,
              onChange: this.handleChangeDate.bind(this, colonna)
            })));
          } else if (colonna.tipo === ETipoCampo.BOOLEANO) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GCheckbox, {
              id: colonna.solocampo,
              readOnly: colonna.hasFlag(EFlags.READONLY),
              onMessage: this.onSubMessage,
              help: colonna.aiuto,
              name: colonna.solocampo,
              label: colonna.etichetta,
              onChange: this.handleChangeCheckbox.bind(this, colonna)
            })));
          } else if (colonna.tipo === ETipoCampo.IMMAGINE) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GImage, {
              id: colonna.solocampo,
              readOnly: colonna.hasFlag(EFlags.READONLY) || this.solaLettura,
              label: colonna.etichetta,
              onMessage: this.onSubMessage,
              cartella: colonna.picture,
              max_w: colonna.max_w,
              max_h: colonna.max_h,
              crop: colonna.crop,
              help: colonna.aiuto,
              onChange: this.handleChangeImage.bind(this, colonna)
            })));
          }

          this.elementi.push(
          /*#__PURE__*/
          React.createElement(Grid, {
            key: 'r' + i,
            container: true,
            item: true,
            xs: 12,
            sm: 12
          }, aCampi));
          aCampi = [];
        }
      }
    }
  }, {
    key: "Open",
    value: function Open(id) {
      this.oggetti.db.rawQuery(this.onReadDatabase, this.oggetti.nomeform + '#ssE' + this.campo.nomecampo, {
        id: id
      });
    }
  }, {
    key: "selectFormatter",
    value: function selectFormatter(cell, row) {}
  }, {
    key: "handleChange",
    value: function handleChange(colonna, e) {
      if (colonna.handle(e.target.value)) {
        colonna.valore = e.target.value;
        if (colonna.inShow) colonna.inShow = false;else this.inEdit(true);
      }
    }
  }, {
    key: "handleChangeSelect",
    value: function handleChangeSelect(colonna, e) {
      if (e == null) {
        colonna.valore = null;
        colonna.valoreDescrizione = "";
        colonna.handle(null, "");
      } else {
        if (colonna.tipo === ETipoCampo.MULTISELECT) {
          colonna.valore = e;
          colonna.handle(e, '');
        } else {
          colonna.valore = e.value;
          colonna.valoreDescrizione = e.label;
          colonna.handle(e.value, e.label);
        }
      }

      this.inEdit(true);
    }
  }, {
    key: "handleChangeDate",
    value: function handleChangeDate(colonna, value) {
      colonna.valore = value;
      colonna.handle(value);
      this.inEdit(true);
    }
  }, {
    key: "handleChangeCheckbox",
    value: function handleChangeCheckbox(colonna, e) {
      colonna.valore = e.target.checked;
      colonna.handle(e.target.checked);
      this.inEdit(true);
    }
  }, {
    key: "handleChangeImage",
    value: function handleChangeImage(colonna, value) {
      colonna.valore = value;
      colonna.handle(colonna.valore);
      this.inEdit(true);
    }
  }, {
    key: "SalvaDati",
    value: function SalvaDati(id) {
      var id_corrente = 0;
      var values = {};
      if (gA.userEvents != null) gA.userEvents.funzione(this.oggetti.nomeform, "subCalcFields", this, this.oggetti);
      if (gA.userEvents != null) gA.userEvents.funzione(this.oggetti.nomeform, "subBeforePost", this, this.oggetti);
      var colonna;

      for (var i = 0; i < this.sf.colonne.length; i++) {
        colonna = this.sf.colonne[i];

        if ((colonna.hasFlag(EFlags.VISIBILE) || colonna.hasFlag(EFlags.CHIAVE) || colonna.valoreIniziale != null || colonna.solocampo.toUpperCase() === this.sf.fieldkeysolocampo.toUpperCase() && id === 0 || colonna.solocampo.toUpperCase() === "VALUTA") && colonna.tipo !== ETipoCampo.PROCEDURA && !colonna.hasFlag(EFlags.NOT_UPDATE)) {
          if (colonna.tipo !== ETipoCampo.MULTISELECT) {
            if (id === 0) {
              if (colonna.hasFlag(EFlags.CHIAVE)) {
                id_corrente = this.oggetti.db.NuovoID(this.sf.nometavola);

                if (id_corrente > 0) {
                  values[colonna.solocampo] = id_corrente;
                }
              } else {
                if (colonna.solocampo.toUpperCase() === this.sf.fieldkeysolocampo.toUpperCase() && id === 0) {
                  values[colonna.solocampo] = this.state.rID;
                } else {
                  if (colonna.valore == null) {
                    if (colonna.tipo === ETipoCampo.TABELLA) values[colonna.fieldMemoSoloCampo] = colonna.ValoreSQLHandle(colonna.getDefault());else values[colonna.solocampo] = colonna.ValoreSQLHandle(colonna.getDefault());
                  } else {
                    if (procUtils.substring(colonna.valoreIniziale, 0, 2) === "+(" && colonna.IsEmpty(this.oggetti)) {
                      values[colonna.solocampo] = colonna.RicavaDefaultPost(this.oggetti);
                    } else {
                      if (colonna.tipo === ETipoCampo.CRIPTATO) ;else values[colonna.solocampo] = colonna.ValoreSQLHandle(this.oggetti);
                    }
                  }
                }
              }
            } else {
              if (colonna.hasFlag(EFlags.CHIAVE)) {
                values[colonna.solocampo] = id;
              } else {
                if (colonna.valore != null) {
                  if (procUtils.substring(colonna.valoreIniziale, 0, 2) === "+(" && colonna.IsEmpty(this.oggetti)) {
                    values[colonna.solocampo] = colonna.RicavaDefaultPost(this.oggetti);
                  } else {
                    if (colonna.tipo === ETipoCampo.CRIPTATO) ;else values[colonna.solocampo] = colonna.ValoreSQLHandle(this.oggetti);
                  }
                } else {
                  values[colonna.solocampo] = colonna.ValoreSQLHandle(colonna.getDefault());
                }
              }
            }
          } else {
            values['_W' + colonna.solocampo] = JSON.stringify(_objectSpread({}, colonna.ValoreSQLHandle(this.oggetti)));
          }
        }
      }

      if (id === 0) {
        this.oggetti.db.execSQL(this.rispostaMemo, this.oggetti.nomeform + '#siD' + this.campo.nomecampo, values);
      } else {
        this.oggetti.db.execSQL(this.rispostaMemo, this.oggetti.nomeform + '#suD' + this.campo.nomecampo, values);
      }

      if (gA.userEvents != null) gA.userEvents.funzione(this.oggetti.nomeform, "subAfterPost", this, this.oggetti);
    }
  }, {
    key: "GeneraColonne",
    value: function GeneraColonne() {
      var _this20 = this;

      var colonna = {};
      var w = '';

      for (var i = 0; i < this.sf.colonne.length; i++) {
        colonna = this.sf.colonne[i];
        if (colonna.hasFlag(EFlags.CHIAVE)) ;else if (colonna.hasFlag(EFlags.VISIBILE)) {
          w = colonna.lunghezza * gA.FATTORE_X;

          if (colonna.tipo === ETipoCampo.DATA) {
            (function () {
              var valore = colonna.solocampo;

              _this20.colonne.push({
                headerStyle: {
                  minWidth: w
                },
                field: colonna.solocampo,
                title: colonna.etichetta,
                render: function render(rowData) {
                  return rowData[valore] ?
                  /*#__PURE__*/
                  React.createElement(Typography, null, moment(rowData[valore]).format(gA.formatData)) : '';
                }
              });
            })();
          } else if (colonna.tipo === ETipoCampo.DATAORA) {
            (function () {
              var valore = colonna.solocampo;

              _this20.colonne.push({
                headerStyle: {
                  minWidth: w
                },
                field: colonna.solocampo,
                title: colonna.etichetta,
                render: function render(rowData) {
                  return rowData[valore] ?
                  /*#__PURE__*/
                  React.createElement(Typography, null, moment(rowData[valore]).format(gA.formatData + ' ' + gA.formatTempo)) : '';
                }
              });
            })();
          } else if (colonna.tipo === ETipoCampo.INTERO || colonna.tipo === ETipoCampo.NUMERO) {
            this.colonne.push({
              headerStyle: {
                minWidth: w
              },
              field: colonna.solocampo,
              type: 'numeric',
              title: colonna.etichetta
            });
          } else if (colonna.tipo === ETipoCampo.CURRENCY) {
            this.colonne.push({
              headerStyle: {
                minWidth: w
              },
              field: colonna.solocampo,
              type: 'currency',
              title: colonna.etichetta,
              currencySetting: gA.valuta
            });
          } else if (colonna.tipo === ETipoCampo.BOOLEANO) {
            this.colonne.push({
              headerStyle: {
                minWidth: w
              },
              field: colonna.solocampo,
              type: 'boolean',
              title: colonna.etichetta
            });
          } else if (colonna.tipo === ETipoCampo.IMMAGINE) {
            (function () {
              var valore = colonna.solocampo;
              var etichetta = colonna.etichetta;

              _this20.colonne.push({
                headerStyle: {
                  minWidth: w
                },
                field: colonna.solocampo,
                title: colonna.etichetta,
                render: function render(rowData) {
                  return rowData[valore] ?
                  /*#__PURE__*/
                  React.createElement("img", {
                    alt: etichetta,
                    src: gA.baseUrlServer + '/' + rowData[valore],
                    style: {
                      width: 100
                    }
                  }) :
                  /*#__PURE__*/
                  React.createElement(Icon, {
                    style: {
                      fontSize: 30
                    }
                  }, "photo_camera");
                }
              });
            })();
          } else if (colonna.tipo === ETipoCampo.MULTISELECT) this.colonne.push({
            headerStyle: {
              minWidth: w
            },
            field: colonna.solocampo,
            title: colonna.etichetta
          });else this.colonne.push({
            headerStyle: {
              minWidth: w
            },
            field: colonna.solocampo,
            title: colonna.etichetta
          });
        }
      }
    }
  }, {
    key: "svuotaForm",
    value: function svuotaForm() {
      var colonna;
      this.rigaCorrente = null;

      for (var i = 0; i < this.sf.colonne.length; i++) {
        colonna = this.sf.colonne[i];

        if (colonna.tipo !== ETipoCampo.PROCEDURA) {
          colonna.valore = colonna.getDefault();
          if (colonna.tipo === ETipoCampo.CURRENCY) colonna.inShow = true;

          if (colonna.hasFlag(EFlags.VISIBILE)) {
            if (colonna.tipo === ETipoCampo.DATAORA || colonna.tipo === ETipoCampo.DATA) colonna.handle(colonna.valore);else if (colonna.tipo === ETipoCampo.TABELLA) {
              colonna.valoreDescrizione = "";
              colonna.handle(colonna.valore, colonna.valoreDescrizione);
            } else if (colonna.tipo === ETipoCampo.IMMAGINE) {
              colonna.handle(colonna.valore, true);
            } else colonna.handle(colonna.valore);
          }
        }
      }

      this.inEdit(true);
      window.scrollTo(0, 0);
    }
  }, {
    key: "nuovoElemento",
    value: function nuovoElemento() {
      if (this.state.modificato) {
        this.inserimentoContinuativo = true;
        if (this.rigaCorrente == null) this.SalvaDati(0);else this.SalvaDati(this.rigaCorrente[this.sf.chiaveprimaria]);
      } else {
        this.svuotaForm();
      }

      if (this.paginaCorrente !== "dettaglio") this.props.history.push(this.baseUrl + '/edita');
    }
  }, {
    key: "handleInsertButtonClick",
    value: function handleInsertButtonClick() {
      this.nuovoElemento();
      this.paginaCorrente = "dettaglio";
      this.setState({
        modificato: false
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      if (this.state.modificato) {
        if (this.rigaCorrente == null) this.SalvaDati(0);else this.SalvaDati(this.rigaCorrente[this.sf.chiaveprimaria]);
      }
    }
  }, {
    key: "handleReset",
    value: function handleReset(e) {
      this.paginaCorrente = "elenco";
      this.state.onChange('D');
      this.Open(this.state.rID);

      if (this.state.modificato) {
        this.setState({
          modificato: false
        });
      }
    }
  }, {
    key: "cancellaRecord",
    value: function cancellaRecord() {
      if (this.rigaCorrente != null) {
        this.oggetti.db.execSQL(this.onDeletedRecord, this.oggetti.nomeform + '#sdD' + this.campo.nomecampo, _defineProperty({}, this.sf.chiaveprimaria, this.rigaCorrente[this.sf.chiaveprimaria]));
      }
    }
  }, {
    key: "onDeletedRecord",
    value: function onDeletedRecord() {
      this.state.onChange('R');
      this.Open(this.state.rID);
      this.paginaCorrente = "elenco";
      this.setState({
        modificato: false
      });
    }
  }, {
    key: "riempieCampi",
    value: function riempieCampi(row) {
      var colonna;
      var dd;

      for (var i = 0; i < this.sf.colonne.length; i++) {
        colonna = this.sf.colonne[i];

        if (colonna.tipo !== ETipoCampo.PROCEDURA) {
          colonna.valore = row[colonna.solocampo];
          if (process.env.NODE_ENV === 'development') procUtils.myLog("SubForm: leggo campo:" + colonna.solocampo + '=' + colonna.valore);

          if (colonna.hasFlag(EFlags.VISIBILE)) {
            if (colonna.tipo === ETipoCampo.CURRENCY) colonna.inShow = true;

            if (colonna.valore == null) {
              colonna.handle(null);
            } else {
              if (colonna.tipo === ETipoCampo.DATA) {
                dd = moment(procUtils.notNull(colonna.valore), 'YYYY-MM-DD HH:mm:ss');

                if (dd.isValid()) {
                  colonna.handle(dd);
                  colonna.valore = dd;
                } else {
                  colonna.handle(null);
                  colonna.valore = null;
                }
              } else if (colonna.tipo === ETipoCampo.DATAORA) {
                dd = moment(procUtils.notNull(colonna.valore), 'YYYY-MM-DD HH:mm:ss');

                if (dd.isValid()) {
                  colonna.handle(dd);
                  colonna.valore = dd;
                } else {
                  colonna.handle(null);
                  colonna.valore = null;
                }
              } else if (colonna.tipo === ETipoCampo.BOOLEANO) {
                dd = parseInt(colonna.valore, 10) === 1 ? true : false;
                colonna.handle(dd);
                colonna.valore = dd;
              } else if (colonna.tipo === ETipoCampo.TABELLA) {
                colonna.valoreDescrizione = colonna.valore;
                colonna.valore = row[colonna.fieldMemoSoloCampo];
                colonna.handle(colonna.valore, colonna.valoreDescrizione);
              } else if (colonna.tipo === ETipoCampo.MULTISELECT) {
                this.oggetti.db.rawQuery(this.rispostaMultiSelect.bind(this, colonna), this.oggetti.nomeform + "#sW" + colonna.solocampo, {
                  id: row[this.sf.chiaveprimaria]
                });
              } else if (colonna.tipo === ETipoCampo.IMMAGINE) {
                colonna.handle(procUtils.notNull(colonna.valore, false));
              } else {
                colonna.handle(procUtils.notNull(colonna.valore));
              }
            }
          }
        }
      }

      window.scrollTo(0, 0);
    }
  }, {
    key: "attivaCampi",
    value: function attivaCampi() {
      var colonna = null;

      for (var i = 0; i < this.sf.colonne.length; i++) {
        colonna = this.sf.colonne[i];

        if (colonna.tipo !== ETipoCampo.PROCEDURA) {
          if (colonna.hasFlag(EFlags.VISIBILE)) {
            if (colonna.tipo === ETipoCampo.IMMAGINE) {
              colonna.handle(colonna.valore, false);
            }
          }
        }
      }
    }
  }, {
    key: "rispostaMultiSelect",
    value: function rispostaMultiSelect(colonna, risultato) {
      if (!risultato.error) {
        var valore = risultato.map(function (r) {
          return {
            value: r[colonna.fieldKey],
            label: r[colonna.fieldResult]
          };
        });
        colonna.handle(valore, '');
        colonna.valore = valore;
      } else {
        alert(risultato.error);
      }
    }
  }, {
    key: "editaRiga",
    value: function editaRiga(e, row) {
      if (!this.solaLettura) {
        this.state.onChange('C');
        this.rigaCorrente = row;
        this.riempieCampi(row);
        this.inEdit(false);
        this.paginaCorrente = "dettaglio";
        this.state.onChange('M');
        this.props.history.push(this.baseUrl + '/edita');
      }
    }
  }, {
    key: "fatto",
    value: function fatto() {
      this.paginaCorrente = "elenco";

      if (this.state.modificato) {
        if (this.rigaCorrente == null) this.SalvaDati(0);else this.SalvaDati(this.rigaCorrente[this.sf.chiaveprimaria]);
        this.setState({
          modificato: false
        });
      }

      this.state.onChange('D');
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;

      if (this.state.dati === null) {
        return (
          /*#__PURE__*/
          React.createElement(Grid, {
            className: classes.wait
          },
          /*#__PURE__*/
          React.createElement(CircularProgress, {
            color: "secondary"
          }))
        );
      } else {
        var _clsx$2, _clsx$3;

        if (this.paginaCorrente === "dettaglio" && window.location.pathname.indexOf(this.baseUrl + '/edita') === -1) {
          if (this.state.modificato) {
            this.handleReset();
          } else {
            this.state.onChange('D');
            this.fatto();
          }
        }

        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: classes.content
          },
          /*#__PURE__*/
          React.createElement(Prompt, {
            when: this.state.modificato,
            message: function message(location) {
              return _t[gA.lingua].abbandonoModifiche;
            }
          }),
          /*#__PURE__*/
          React.createElement("div", {
            className: clsx$1((_clsx$2 = {}, _defineProperty(_clsx$2, classes.hide, this.paginaCorrente !== "elenco"), _defineProperty(_clsx$2, classes.show, this.paginaCorrente === "elenco"), _clsx$2))
          },
          /*#__PURE__*/
          React.createElement(MaterialTable, {
            data: this.state.dati,
            columns: this.colonne,
            onRowClick: this.editaRiga,
            keyField: this.oggetti.getChiave(),
            options: {
              filtering: true,
              pageSize: 10,
              pageSizeOptions: [10, 20, 50, 100],
              showTitle: false,
              exportButton: true,
              toolbar: true,
              exportDelimiter: ";",
              tableLayout: 'auto',
              padding: 'dense',
              headerStyle: {
                backgroundColor: gA.stili.testataTabellaSubFormBackground,
                color: gA.stili.testataTabellaSubFormColor
              }
            }
          })),
          /*#__PURE__*/
          React.createElement("div", {
            className: clsx$1((_clsx$3 = {}, _defineProperty(_clsx$3, classes.hide, this.paginaCorrente !== "dettaglio"), _defineProperty(_clsx$3, classes.show, this.paginaCorrente === "dettaglio"), _clsx$3))
          },
          /*#__PURE__*/
          React.createElement(Grid, {
            container: true
          }, this.elementi)))
        );
      }
    }
  }]);

  return GSubForm;
}(Component);

var GSubForm$1 = withStyles(styles$3)(GSubForm);

var styles$4 = function styles$4(theme) {
  return {
    root: {
      textAlign: 'left',
      padding: "5px"
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(0.5)
    },
    rightIcon: {
      marginLeft: theme.spacing()
    },
    colxs: {
      backgroundColor: "green",
      border: "1px",
      borderColor: "white",
      borderStyle: "solid"
    },
    fissi: {
      backgroundColor: gA.stili.testataFissiFormStdBackground,
      color: gA.stili.testataFissiFormStdColor,
      border: '0px',
      borderRight: "1px",
      borderColor: "white",
      borderStyle: "solid",
      padding: "3px 10px 3px 10px"
    },
    content: {
      width: "100%"
    },
    header: {
      backgroundColor: '#87c9ec',
      color: '#FFF'
    },
    appBar: _defineProperty({
      top: 'auto',
      bottom: 0,
      marginLeft: gA.drawerWidth
    }, theme.breakpoints.up('md'), {
      width: "calc(100% - ".concat(gA.drawerWidth, "px)")
    }),
    appBar2: {
      top: 'auto',
      bottom: 0,
      marginLeft: 0,
      width: '100%'
    },
    toolbar: {
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    tabs: {
      backgroundColor: gA.stili.tabFormStdBackground,
      color: gA.stili.tabFormStdColor
    },
    wait: {
      display: 'flex',
      justifyContent: 'center',
      margin: theme.spacing(2)
    }
  };
};

function TabContainer(_ref6) {
  var children = _ref6.children,
      dir = _ref6.dir;
  return (
    /*#__PURE__*/
    React.createElement(Typography$1, {
      component: "div",
      dir: dir
    }, children)
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired
};

var FormStd =
/*#__PURE__*/
function (_Component14) {
  _inherits(FormStd, _Component14);

  function FormStd(props) {
    var _this21;

    _classCallCheck(this, FormStd);

    _this21 = _possibleConstructorReturn(this, _getPrototypeOf(FormStd).call(this, props));

    _this21.handleChangeIndex = function (index) {
      _this21.onTabSelect(null, _this21.indici[index]);

      if (_this21.props.location.pathname === _this21.props.match.url + '/dettaglio/edita') {
        _this21.props.history.goBack();
      }
    };

    _this21.headerStyle = {
      backgroundColor: gA.stili.testataTabellaFormStdBackground,
      color: gA.stili.testataTabellaFormStdColor
    };
    _this21.state = {
      dati: null,
      modificato: false,
      parametri: props.parametri,
      bSalva: false,
      openMsg: false,
      openAttesa: false,
      attesa: false
    };
    _this21.totaleCampiVisibili = 0;
    _this21.pagine = [];
    _this21.tabs = [];
    _this21.indici = [-1];
    _this21.colonne = [];
    _this21.currentID = 0;
    _this21.maxPagine = 1;
    _this21.inserimentoContinuativo = false;
    _this21.campochiave = "";
    _this21.solaLettura = false;
    _this21.handleBottoni = [];
    _this21.modificaSubform = false;
    _this21.subformCorrente = null;
    _this21.testata = [];
    _this21.posCorrente = 0;
    _this21.pagina = 1;
    _this21.indicePagina = 0;
    _this21.dettaglioAttivo = false;
    _this21.baseUrl = _this21.props.match.url;
    _this21.risposta = _this21.risposta.bind(_assertThisInitialized(_this21));
    _this21.rispostaId = _this21.rispostaId.bind(_assertThisInitialized(_this21));
    _this21.rispostaMemo = _this21.rispostaMemo.bind(_assertThisInitialized(_this21));
    _this21.onMessage = _this21.onMessage.bind(_assertThisInitialized(_this21));
    _this21.nuovoElemento = _this21.nuovoElemento.bind(_assertThisInitialized(_this21));
    _this21.onTabSelect = _this21.onTabSelect.bind(_assertThisInitialized(_this21));
    _this21.handleSubmit = _this21.handleSubmit.bind(_assertThisInitialized(_this21));
    _this21.handleReset = _this21.handleReset.bind(_assertThisInitialized(_this21));
    _this21.confermaCancellaRecord = _this21.confermaCancellaRecord.bind(_assertThisInitialized(_this21));
    _this21.cancellaRecord = _this21.cancellaRecord.bind(_assertThisInitialized(_this21));
    _this21.onReadDatabase = _this21.onReadDatabase.bind(_assertThisInitialized(_this21));
    _this21.onDeletedRecord = _this21.onDeletedRecord.bind(_assertThisInitialized(_this21));
    _this21.fatto = _this21.fatto.bind(_assertThisInitialized(_this21));
    _this21.getHandleButton = _this21.getHandleButton.bind(_assertThisInitialized(_this21));
    _this21.handleChangeIndex = _this21.handleChangeIndex.bind(_assertThisInitialized(_this21));
    _this21.ff = new FileForms();
    return _this21;
  }

  _createClass(FormStd, [{
    key: "isSubForm",
    value: function isSubForm(key) {
      return typeof key == "string" && key.startsWith("S");
    }
  }, {
    key: "onBackButtonEvent",
    value: function onBackButtonEvent(e) {
      alert("non puoi usare il back button");
      e.preventDefault();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this22 = this;

      gA.menu.showHideBack(true);
      gA.menu.onBack(function () {
        return _this22.props.history.goBack();
      });
      this.ff.LoadFile(this.onLoadForm.bind(this), this.props.nomeForm, this.state.parametri);
    }
  }, {
    key: "onLoadForm",
    value: function onLoadForm(oggetto, risposta) {
      this.oggetti = oggetto;
      this.ff.ElaboraFile(oggetto, risposta);
      this.OpenForm();
      this.oggetti.handle = this;
      this.fissiDisableLabel = this.oggetti.variabili.Get('fissiDisableLabel') === '1';

      if (this.props.location.pathname.indexOf(this.props.match.url + '/dettaglio') > -1) {
        this.props.history.replace(this.props.match.url);
      }
    }
  }, {
    key: "OpenForm",
    value: function OpenForm() {
      var l;
      var temp = [];
      if (process.env.NODE_ENV === 'development') procUtils.myLog("ElencoActivity(" + this.props.nomeForm + "): richiama funzione user");
      if (gA.userEvents != null) gA.userEvents.funzione(this.props.nomeForm, "onCreate", this, this.oggetti);
      if (process.env.NODE_ENV === 'development') procUtils.myLog("livello: " + this.oggetti.variabili.Get("SolaLettura") + ' -> ' + gA.parametri.livello);

      if (this.oggetti.variabili.Get("SolaLettura") >= gA.parametri.livello) {
        this.solaLettura = true;
      }

      if (this.oggetti.variabili.Get("colonne") == null) {
        this.oggetti.colonne[0] = 250;
        this.oggetti.colonne[1] = 140;
        this.oggetti.colonne[2] = 140;
      } else {
        if (process.env.NODE_ENV === 'development') procUtils.myLog("ElencoActivity(" + this.props.nomeForm + "): legge le colonne");
        l = 0;
        var colonne = this.oggetti.variabili.Get("colonne");

        if (colonne != null) {
          temp = colonne.split(",");

          while (l < temp.length) {
            this.oggetti.colonne[l] = parseInt(temp[l], 10) * gA.FATTORE_X;
            l++;
          }
        }
      }

      if (process.env.NODE_ENV === 'development') procUtils.myLog("ElencoActivity(" + this.props.nomeForm + "): prepara i campi SQL: " + this.oggetti.campi.length);
      this.campochiave = procUtils.GetNomeCampo(this.oggetti.variabili.Get("chiave"));
      this.oggetti.OpenDatabase(null);
      this.GeneraColonne();
      this.GeneraCampi();
      this.leggeTabella();
    }
  }, {
    key: "dataFormatter",
    value: function dataFormatter(cell, row) {
      var dd = moment(procUtils.notNull(cell), 'YYYY-MM-DD HH:mm:ss');

      if (dd.isValid()) {
        return dd.format(gA.formatData + ' ' + gA.formatTempo);
      } else return "";
    }
  }, {
    key: "GeneraColonne",
    value: function GeneraColonne() {
      var _this23 = this;

      var campo = {};
      var w = '';
      var l = this.oggetti.campi.length;

      for (var i = 0; i < l; i++) {
        campo = this.oggetti.campi[i];
        if (campo.hasFlag(EFlags.CHIAVE)) ;else if (campo.hasFlag(EFlags.INIZIALE)) {
          w = campo.lunghezza * gA.FATTORE_X;

          if (campo.tipo === ETipoCampo.DATA) {
            (function () {
              var valore = campo.solocampo;

              _this23.colonne.push({
                headerStyle: {
                  minWidth: w
                },
                field: campo.solocampo,
                title: campo.etichetta,
                render: function render(rowData) {
                  return rowData[valore] ?
                  /*#__PURE__*/
                  React.createElement(Typography$1, null, moment(rowData[valore]).format(gA.formatData)) : '';
                }
              });
            })();
          } else if (campo.tipo === ETipoCampo.DATAORA) {
            (function () {
              var valore = campo.solocampo;

              _this23.colonne.push({
                headerStyle: {
                  minWidth: w
                },
                field: campo.solocampo,
                title: campo.etichetta,
                render: function render(rowData) {
                  return rowData[valore] ?
                  /*#__PURE__*/
                  React.createElement(Typography$1, null, moment(rowData[valore]).format(gA.formatData + ' ' + gA.formatTempo)) : '';
                }
              });
            })();
          } else if (campo.tipo === ETipoCampo.INTERO || campo.tipo === ETipoCampo.NUMERO) {
            this.colonne.push({
              headerStyle: {
                minWidth: w
              },
              field: campo.solocampo,
              type: 'numeric',
              title: campo.etichetta
            });
          } else if (campo.tipo === ETipoCampo.CURRENCY) {
            this.colonne.push({
              headerStyle: {
                minWidth: w
              },
              field: campo.solocampo,
              type: 'currency',
              title: campo.etichetta,
              currencySetting: gA.valuta
            });
          } else if (campo.tipo === ETipoCampo.BOOLEANO) {
            this.colonne.push({
              headerStyle: {
                minWidth: w
              },
              field: campo.solocampo,
              type: 'boolean',
              title: campo.etichetta
            });
          } else if (campo.tipo === ETipoCampo.IMMAGINE) {
            (function () {
              var valore = campo.solocampo;
              var etichetta = campo.etichetta;

              _this23.colonne.push({
                headerStyle: {
                  minWidth: w
                },
                field: campo.solocampo,
                title: campo.etichetta,
                render: function render(rowData) {
                  return rowData[valore] ?
                  /*#__PURE__*/
                  React.createElement("img", {
                    alt: etichetta,
                    src: gA.baseUrlServer + '/' + rowData[valore],
                    style: {
                      width: 100
                    }
                  }) :
                  /*#__PURE__*/
                  React.createElement(Icon, {
                    style: {
                      fontSize: 30
                    }
                  }, "photo_camera");
                }
              });
            })();
          } else {
            this.colonne.push({
              headerStyle: {
                minWidth: w
              },
              field: campo.solocampo,
              title: campo.etichetta
            });
          }
        }
      }
    }
  }, {
    key: "leggeTabella",
    value: function leggeTabella() {
      this.oggetti.db.rawQuery(this.onReadDatabase, this.props.nomeForm + '#sE', null);
    }
  }, {
    key: "getHandleButton",
    value: function getHandleButton(id, handle) {
      this.handleBottoni[id] = handle;
    }
  }, {
    key: "GeneraCampi",
    value: function GeneraCampi() {
      var w = 0;
      var c = -1;
      var maxW,
          currentWm,
          currentWs = 0;
      this.totaleCampiVisibili = 0;
      var numTab = 0;
      this.maxPagine = 0;
      var beforeCR = false;
      var elementi = [];
      var aCampi = [];
      var wCol = 50;
      var wColM = 100;
      var wS = 0;
      var wM = 0;
      maxW = 12;
      var campo;
      var _this$props = this.props,
          classes = _this$props.classes,
          theme = _this$props.theme;

      for (var i = 0; i < this.oggetti.campi.length; i++) {
        campo = this.oggetti.campi[i];
        if ((campo.hasFlag(EFlags.VISIBILE) || campo.hasFlag(EFlags.CHIAVE) || campo.valoreIniziale !== "" || campo.solocampo.toUpperCase() === "VALUTA") && campo.tipo !== ETipoCampo.PROCEDURA && campo.tipo !== ETipoCampo.TAB && campo.tipo !== ETipoCampo.SUBFORM && !campo.hasFlag(EFlags.NOT_UPDATE) && campo.IsAuthorized(this.oggetti) > 0) this.totaleCampiVisibili++;

        if (campo.tipo === ETipoCampo.TAB) {
          numTab++;
          this.maxPagine++;
          if (aCampi.length > 0) elementi.push(
          /*#__PURE__*/
          React.createElement(Grid, {
            key: i,
            container: true,
            item: true,
            xs: 12,
            sm: 12
          }, aCampi));
          elementi = [];
          aCampi = [];
          this.tabs.push(
          /*#__PURE__*/
          React.createElement(Tab, {
            key: i,
            value: numTab,
            label: campo.etichetta.substring(2)
          }));
          this.indici.push(numTab);
          this.pagine.push(
          /*#__PURE__*/
          React.createElement(TabContainer, {
            key: 'c' + i,
            dir: theme.direction
          },
          /*#__PURE__*/
          React.createElement("form", {
            key: 'ff' + i,
            autoComplete: "off",
            onSubmit: this.handleSubmit,
            onReset: this.handleReset
          },
          /*#__PURE__*/
          React.createElement(Grid, {
            key: 'f' + i,
            container: true,
            direction: "row",
            alignItems: "flex-start",
            className: classes.content
          }, elementi))));
          if (process.env.NODE_ENV === 'development') procUtils.myLog("ElencoActivity(" + this.props.nomeForm + "): genera tab:" + campo.etichetta);
          currentWm = 0;
          currentWs = 0;
        }

        if (campo.hasFlag(EFlags.VISIBILE) && campo.IsAuthorized(this.oggetti) > 0) {
          w = campo.lunghezza * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X;
          if (campo.tipo === ETipoCampo.BOOLEANO) w = campo.etichetta.length * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X + 30;else if (campo.tipo === ETipoCampo.DATAORA) {
            w = wColM * 3;
          } else if (campo.tipo === ETipoCampo.TABELLA) {
            w = campo.lunghezza * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X + 24;
          } else if (campo.tipo === ETipoCampo.DATA) {
            w = wColM * 3;
          } else if (campo.tipo === ETipoCampo.TELEFONICO) {
            w += 40;
          }
          beforeCR = campo.coordinata.substring(0, 1) === "+";
          c = campo.coordinata.indexOf(':');

          if (c > -1) {
            if (beforeCR) wM = parseInt(campo.coordinata.substring(1, c));else wM = parseInt(campo.coordinata.substring(0, c));
            wS = parseInt(campo.coordinata.substring(c + 1));
          } else {
            wS = Math.floor(w / wCol);
            if (wS < 1) wS = 2;
            if (wS > 12) wS = 12;
            wM = Math.floor(w / wColM);
            if (wM < 1) wM = 1;
            if (wM > 12) wM = 12;
          }

          if (wM > maxW) {
            wM = maxW;
          }

          if (wS > maxW) {
            wS = maxW;
          }

          if (campo.tipo === ETipoCampo.ALFA || campo.tipo === ETipoCampo.NUMERO || campo.tipo === ETipoCampo.INTERO || campo.tipo === ETipoCampo.MEMO || campo.tipo === ETipoCampo.CRIPTATO || campo.tipo === ETipoCampo.CURRENCY) {
            var tipo = "text";
            if (campo.tipo === ETipoCampo.INTERO) tipo = "number";
            if (campo.tipo === ETipoCampo.NUMERO) tipo = "number";
            if (campo.tipo === ETipoCampo.CURRENCY) tipo = "currency";
            if (campo.hasFlag(EFlags.FORZA_NUMERICO)) tipo = "number";
            if (campo.hasFlag(EFlags.FORZA_PASSWORD)) tipo = "password";

            if (campo.tipo === ETipoCampo.MEMO) {
              aCampi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                xs: wS,
                sm: wM
              },
              /*#__PURE__*/
              React.createElement(GMemo, {
                id: campo.solocampo,
                readOnly: campo.hasFlag(EFlags.READONLY) || this.solaLettura || campo.IsAuthorized(this.oggetti) === 2,
                righe: campo.larghezza,
                onMessage: this.onMessage,
                label: campo.etichetta,
                help: campo.aiuto,
                onChange: this.handleChange.bind(this, campo)
              })));
            } else {
              aCampi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                xs: wS,
                sm: wM
              },
              /*#__PURE__*/
              React.createElement(GEdit, {
                idCampo: this.oggetti.GetCampo(this.campochiave),
                campo: campo,
                id: campo.solocampo,
                onMessage: this.onMessage,
                upload: campo.hasFlag(EFlags.UPLOAD),
                readOnly: campo.hasFlag(EFlags.READONLY) || this.solaLettura || campo.IsAuthorized(this.oggetti) === 2,
                maxLength: campo.lunghezza,
                name: campo.solocampo,
                type: tipo,
                label: campo.etichetta,
                help: campo.aiuto,
                onChange: this.handleChange.bind(this, campo)
              })));
            }
          } else if (campo.tipo === ETipoCampo.TABELLA) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GSelect, {
              id: campo.solocampo,
              campo: campo,
              oggetti: this.oggetti,
              readOnly: campo.hasFlag(EFlags.READONLY) || this.solaLettura || campo.IsAuthorized(this.oggetti) === 2,
              onMessage: this.onMessage,
              maxLength: campo.lunghezza,
              name: campo.solocampo,
              type: "text",
              label: campo.etichetta,
              help: campo.aiuto,
              onChange: this.handleChangeSelect.bind(this, campo)
            })));
          } else if (campo.tipo === ETipoCampo.DATA) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GDateTime, {
              id: campo.solocampo,
              readOnly: campo.hasFlag(EFlags.READONLY) || this.solaLettura || campo.IsAuthorized(this.oggetti) === 2,
              onMessage: this.onMessage,
              dateFormat: gA.formatData,
              timeFormat: "",
              label: campo.etichetta,
              help: campo.aiuto,
              onChange: this.handleChangeDate.bind(this, campo)
            })));
          } else if (campo.tipo === ETipoCampo.DATAORA) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GDateTime, {
              id: campo.solocampo,
              readOnly: campo.hasFlag(EFlags.READONLY) || this.solaLettura || campo.IsAuthorized(this.oggetti) === 2,
              onMessage: this.onMessage,
              dateFormat: gA.formatData,
              time: true,
              timeFormat: gA.formatTempo,
              label: campo.etichetta,
              help: campo.aiuto,
              onChange: this.handleChangeDate.bind(this, campo)
            })));
          } else if (campo.tipo === ETipoCampo.IMMAGINE) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GImage, {
              id: campo.solocampo,
              readOnly: campo.hasFlag(EFlags.READONLY) || this.solaLettura || campo.IsAuthorized(this.oggetti) === 2,
              label: campo.etichetta,
              onMessage: this.onMessage,
              cartella: campo.picture,
              help: campo.aiuto,
              max_w: campo.max_w,
              max_h: campo.max_h,
              crop: campo.crop,
              onChange: this.handleChangeImage.bind(this, campo)
            })));
          } else if (campo.tipo === ETipoCampo.PROCEDURA) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM,
              style: {
                border: '1px',
                display: 'table-cell',
                verticalAlign: 'bottom',
                float: 'none'
              }
            },
            /*#__PURE__*/
            React.createElement(GButton, {
              id: campo.solocampo,
              oggetti: this.oggetti,
              readOnly: campo.hasFlag(EFlags.READONLY) || this.solaLettura || campo.IsAuthorized(this.oggetti) === 2,
              onMessage: this.onMessage,
              help: campo.aiuto,
              name: campo.solocampo,
              label: campo.etichetta,
              onClick: this.handleClickButton.bind(this, campo)
            })));
          } else if (campo.tipo === ETipoCampo.BOOLEANO) {
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: wS,
              sm: wM
            },
            /*#__PURE__*/
            React.createElement(GCheckbox, {
              id: campo.solocampo,
              readOnly: campo.hasFlag(EFlags.READONLY) || this.solaLettura || campo.IsAuthorized(this.oggetti) === 2,
              onMessage: this.onMessage,
              help: campo.aiuto,
              name: campo.solocampo,
              label: campo.etichetta,
              onChange: this.handleChangeCheckbox.bind(this, campo)
            })));
          } else if (campo.tipo === ETipoCampo.TELEFONICO) ;else if (campo.tipo === ETipoCampo.SUBFORM) {
            numTab++;
            this.maxPagine++;

            if (aCampi.length > 0) {
              elementi.push(aCampi);
            }

            elementi = [];
            aCampi = [];
            var nomeTab = "S" + campo.nomecampo;
            this.tabs.push(
            /*#__PURE__*/
            React.createElement(Tab, {
              key: i,
              value: nomeTab,
              label: campo.etichetta
            }));
            this.indici.push(nomeTab);
            this.pagine.push(
            /*#__PURE__*/
            React.createElement(TabContainer, {
              key: 'c' + i,
              dir: theme.direction
            },
            /*#__PURE__*/
            React.createElement(Grid, {
              container: true
            }, elementi)));
            if (process.env.NODE_ENV === 'development') procUtils.myLog("ElencoActivity(" + this.props.nomeForm + "): genera tab:" + campo.etichetta);
            aCampi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: i,
              item: true,
              xs: 12,
              sm: 12
            },
            /*#__PURE__*/
            React.createElement(GSubForm$1, {
              id: campo.solocampo,
              readOnly: campo.hasFlag(EFlags.READONLY) || this.solaLettura || campo.IsAuthorized(this.oggetti) === 2,
              onMessage: this.onMessage,
              help: campo.aiuto,
              subform: this.oggetti.findsubform(campo.nomecampo),
              classes: this.props.classes,
              baseUrl: this.baseUrl + '/dettaglio',
              onChange: this.handleChangeSubForm.bind(this, campo),
              campo: campo,
              oggetti: this.oggetti,
              history: this.props.history,
              location: this.props.location
            })));
            elementi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: 'r' + i,
              container: true,
              item: true,
              xs: 12,
              sm: 12,
              className: classes.content
            }, aCampi));
            w = maxW;
            currentWm = 0;
            currentWs = 0;
            aCampi = [];
          }

          if (wM === maxW) {
            elementi.push(aCampi);
            wM = maxW;
            currentWs = 0;
            currentWm = 0;
            aCampi = [];
          } else if (wM + currentWm > maxW || beforeCR) {
            currentWs = 0;
            currentWm = 0;
            elementi.push(aCampi);

            if (beforeCR) {
              elementi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                xs: 12 - currentWs,
                sm: 12 - currentWm
              }));
            }

            aCampi = [];
          } else {
            currentWm += wM;
            currentWs += wS;
          }
        }
      }

      if (aCampi.length > 0) {
        elementi.push(aCampi);
      }
    }
  }, {
    key: "onMessage",
    value: function onMessage(nomecampo, handle) {
      this.oggetti.GetCampo(nomecampo).handle = handle;
    }
  }, {
    key: "SalvaDati",
    value: function SalvaDati(id) {
      var id_corrente = 0;
      var values = {};
      if (gA.userEvents != null) gA.userEvents.funzione(this.props.nomeForm, "calcFields", this, this.oggetti);
      if (gA.userEvents != null) gA.userEvents.funzione(this.props.nomeForm, "beforePost", this, this.oggetti);
      var campo;

      for (var i = 0; i < this.oggetti.campi.length; i++) {
        campo = this.oggetti.campi[i];

        if ((campo.hasFlag(EFlags.VISIBILE) || campo.hasFlag(EFlags.CHIAVE) || campo.valoreIniziale != null || campo.solocampo.toUpperCase() === "VALUTA") && campo.tipo !== ETipoCampo.PROCEDURA && campo.tipo !== ETipoCampo.SUBFORM && campo.tipo !== ETipoCampo.TAB && !campo.hasFlag(EFlags.NOT_UPDATE) && campo.solocampo !== this.oggetti.variabili.Get("campo_modifica") && campo.solocampo !== this.oggetti.variabili.Get("campo_creazione") && campo.solocampo !== this.oggetti.variabili.Get("campo_utente") && campo.solocampo !== this.oggetti.variabili.Get("campo_utente_creazione") && campo.solocampo !== this.oggetti.variabili.Get("campo_timestamp")) {
          if (id === 0) {
            if (campo.hasFlag(EFlags.CHIAVE)) {
              id_corrente = this.oggetti.db.NuovoID(this.oggetti.variabili.Get("tavola"));

              if (id_corrente > 0) {
                values[campo.solocampo] = id_corrente;
              }
            } else {
              if (campo.valore == null) {
                values[campo.solocampo] = campo.ValoreSQLHandle(campo.getDefault());
              } else {
                if (procUtils.substring(campo.valoreIniziale, 0, 2) === "+(" && campo.IsEmpty(this.oggetti)) {
                  values[campo.solocampo] = campo.RicavaDefaultPost(this.oggetti);
                } else {
                  if (campo.tipo === ETipoCampo.CRIPTATO) ;else values[campo.solocampo] = campo.ValoreSQLHandle(this.oggetti);
                }
              }
            }
          } else {
            if (campo.hasFlag(EFlags.CHIAVE)) {
              values[campo.solocampo] = id;
            } else {
              if (campo.valore != null) {
                if (procUtils.substring(campo.valoreIniziale, 0, 2) === "+(" && campo.IsEmpty(this.oggetti)) {
                  values[campo.solocampo] = campo.RicavaDefaultPost(this.oggetti);
                } else {
                  if (campo.tipo === ETipoCampo.CRIPTATO) ;else values[campo.solocampo] = campo.ValoreSQLHandle(this.oggetti);
                }
              } else {
                campo.valore = campo.getDefault();
                values[campo.solocampo] = campo.ValoreSQLHandle(this.oggetti);
              }
            }
          }
        }
      }

      if (id === 0) {
        this.oggetti.db.execSQL(this.rispostaMemo, this.props.nomeForm + '#iD', values);
      } else {
        this.oggetti.db.execSQL(this.rispostaMemo, this.props.nomeForm + '#uD', values);
      }

      if (gA.userEvents != null) gA.userEvents.funzione(this.props.nomeForm, "afterPost", this, this.oggetti);
    }
  }, {
    key: "inEdit",
    value: function inEdit(stato) {
      if (this.dettaglioAttivo) {
        if (stato === true) {
          if (!this.state.modificato) {
            var el = this.handleBottoni["memo"];

            if (el != null) {
              el({
                readOnly: false
              });
              this.handleBottoni["annulla"]({
                readOnly: false
              });
            }

            this.setState({
              modificato: true,
              bSalva: true
            });
          }
        } else {
          if (this.state.modificato) {
            this.handleBottoni["memo"]({
              readOnly: true
            });
            this.handleBottoni["annulla"]({
              readOnly: true
            });
            this.setState({
              modificato: false
            });
          }
        }
      }
    }
  }, {
    key: "rispostaId",
    value: function rispostaId(risultato) {
      if (risultato.error) {
        alert(risultato.error);
        this.setState({
          openAttesa: false
        });
      } else {
        var campo;
        var dd;
        var elementi = [];
        this.testata = [];

        for (var i = 0; i < this.oggetti.campi.length; i++) {
          campo = this.oggetti.campi[i];

          if (campo.tipo !== ETipoCampo.PROCEDURA && campo.tipo !== ETipoCampo.TAB && campo.tipo !== ETipoCampo.SUBFORM) {
            campo.valore = risultato[0][campo.solocampo];
            if (process.env.NODE_ENV === 'development') procUtils.myLog("ElencoActivity(" + this.props.nomeForm + "): leggo campo:" + campo.solocampo + '=' + campo.valore);

            if (campo.hasFlag(EFlags.VISIBILE) && campo.IsAuthorized(this.oggetti) > 0) {
              if (campo.valore == null) {
                campo.handle(null);
              } else {
                if (campo.tipo === ETipoCampo.DATA) {
                  dd = moment(procUtils.notNull(campo.valore), 'YYYY-MM-DD HH:mm:ss');

                  if (dd.isValid()) {
                    campo.handle(dd);
                    campo.valore = dd;
                  } else {
                    campo.handle(null);
                    campo.valore = null;
                  }
                } else if (campo.tipo === ETipoCampo.DATAORA) {
                  dd = moment(procUtils.notNull(campo.valore), 'YYYY-MM-DD HH:mm:ss');

                  if (dd.isValid()) {
                    campo.handle(dd);
                    campo.valore = dd;
                  } else {
                    campo.handle(null);
                    campo.valore = null;
                  }
                } else if (campo.tipo === ETipoCampo.BOOLEANO) {
                  dd = parseInt(campo.valore) === 1 ? true : false;
                  campo.handle(dd);
                  campo.valore = dd;
                } else if (campo.tipo === ETipoCampo.TABELLA) {
                  campo.valoreDescrizione = campo.valore;
                  campo.valore = risultato[0][campo.fieldMemoSoloCampo];
                  campo.handle(campo.valore, campo.valoreDescrizione);
                } else if (campo.tipo === ETipoCampo.IMMAGINE) {
                  campo.handle(procUtils.notNull(campo.valore), false);
                } else campo.handle(procUtils.notNull(campo.valore));
              }
            }

            if (campo.hasFlag(EFlags.TESTATA)) {
              if (campo.tipo === ETipoCampo.DATA) elementi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                className: this.props.classes.fissi
              },
              /*#__PURE__*/
              React.createElement(Typography$1, {
                variant: "body1"
              }, !this.fissiDisableLabel && campo.etichetta + ': ',
              /*#__PURE__*/
              React.createElement("b", null, campo.valore.format(gA.formatData)))));else if (campo.tipo === ETipoCampo.DATAORA) elementi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                className: this.props.classes.fissi
              },
              /*#__PURE__*/
              React.createElement(Typography$1, {
                variant: "body1"
              }, !this.fissiDisableLabel && campo.etichetta + ': ',
              /*#__PURE__*/
              React.createElement("b", null, campo.valore.format(gA.formatData + ' ' + gA.formatTempo)))));else elementi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                className: this.props.classes.fissi
              },
              /*#__PURE__*/
              React.createElement(Typography$1, {
                variant: "body1"
              }, !this.fissiDisableLabel && campo.etichetta + ': ',
              /*#__PURE__*/
              React.createElement("b", null, campo.valore))));
            }
          }
        }

        this.handleBottoni["fatto"]({
          readOnly: false
        });

        if (!this.solaLettura) {
          this.handleBottoni["cancella"]({
            readOnly: false
          });
        }

        this.testata.push(
        /*#__PURE__*/
        React.createElement(Grid, {
          key: 'testata',
          container: true
        }, elementi));
        this.pagina = 1;
        this.indicePagina = 1;
        this.dettaglioAttivo = true;
        this.setState({
          modificato: false,
          openAttesa: false
        });
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: "rispostaMemo",
    value: function rispostaMemo(risultato) {
      if (risultato.error != null) {
        alert('Errore SQL: ' + risultato.error);
      } else {
        this.inEdit(false);

        if (!this.inserimentoContinuativo) {
          this.attivaCampi();
          this.leggeTabella();

          if (this.currentID === 0) {
            this.currentID = risultato.lastID;
            this.oggetti.GetCampo(this.oggetti.getChiave()).valore = risultato.lastID;
          }
        } else {
          this.inserimentoContinuativo = false;
          this.svuotaForm();
        }
      }
    }
  }, {
    key: "getValues",
    value: function getValues(id) {
      this.currentID = id;
      this.oggetti.db.rawQuery(this.rispostaId, this.props.nomeForm + '#sD', _defineProperty({}, this.campochiave, id));
    }
  }, {
    key: "risposta",
    value: function risposta(e, row) {
      this.posCorrente = procUtils.getScrollPosition().y;
      this.getValues(row[this.campochiave]);
      this.setState({
        openAttesa: true
      });
      this.props.history.push(this.baseUrl + '/dettaglio');
    }
  }, {
    key: "attivaCampi",
    value: function attivaCampi() {
      var campo = '';

      for (var i = 0; i < this.oggetti.campi.length; i++) {
        campo = this.oggetti.campi[i];

        if (campo.tipo !== ETipoCampo.PROCEDURA && campo.tipo !== ETipoCampo.TAB && campo.tipo !== ETipoCampo.SUBFORM) {
          if (campo.hasFlag(EFlags.VISIBILE) && campo.IsAuthorized(this.oggetti) > 0) {
            if (campo.tipo === ETipoCampo.IMMAGINE) {
              campo.handle(campo.valore, false);
            }
          }
        }
      }
    }
  }, {
    key: "svuotaForm",
    value: function svuotaForm() {
      var campo;
      this.currentID = 0;

      for (var i = 0; i < this.oggetti.campi.length; i++) {
        campo = this.oggetti.campi[i];

        if (campo.tipo !== ETipoCampo.PROCEDURA && campo.tipo !== ETipoCampo.TAB && campo.tipo !== ETipoCampo.SUBFORM) {
          campo.valore = campo.getDefault();

          if (campo.hasFlag(EFlags.VISIBILE) && campo.IsAuthorized(this.oggetti) > 0) {
            if (campo.tipo === ETipoCampo.DATAORA || campo.tipo === ETipoCampo.DATA) campo.handle(campo.valore);else if (campo.tipo === ETipoCampo.TABELLA) {
              campo.valoreDescrizione = "";
              campo.handle(campo.valore, campo.valoreDescrizione);
            } else if (campo.tipo === ETipoCampo.IMMAGINE) {
              campo.handle(campo.valore, true);
            } else campo.handle(campo.valore);
          }
        }
      }

      this.handleBottoni["fatto"]({
        readOnly: false
      });
      if (!this.solaLettura) this.handleBottoni["cancella"]({
        readOnly: false
      });
      this.indicePagina = 1;
      this.pagina = 1;
      this.inEdit(false);
      window.scrollTo(0, 0);
    }
  }, {
    key: "nuovoElemento",
    value: function nuovoElemento() {
      if (this.isSubForm(this.pagina)) {
        this.subformCorrente.handle("I", 0);
        this.modificaSubform = true;
        this.posCorrente = procUtils.getScrollPosition().y;
      } else {
        if (this.state.modificato) {
          this.inserimentoContinuativo = true;
          this.SalvaDati(this.currentID);
        } else {
          this.posCorrente = procUtils.getScrollPosition().y;
          this.svuotaForm();
        }

        if (!this.dettaglioAttivo) {
          this.dettaglioAttivo = true;
          this.props.history.push(this.baseUrl + '/dettaglio');
        }
      }
    }
  }, {
    key: "confermaCancellaRecord",
    value: function confermaCancellaRecord() {
      this.setState({
        openMsg: true
      });
    }
  }, {
    key: "cancellaRecord",
    value: function cancellaRecord(key) {
      if (key === 'si') {
        if (this.isSubForm(this.pagina) && this.modificaSubform) {
          this.subformCorrente.handle("E", this.currentID);
        } else {
          if (this.currentID !== 0) {
            this.oggetti.db.execSQL(this.onDeletedRecord, this.props.nomeForm + '#dD', _defineProperty({}, this.campochiave, this.currentID));
          }
        }
      }

      this.setState({
        openMsg: false
      });
    }
  }, {
    key: "onDeletedRecord",
    value: function onDeletedRecord() {
      this.inEdit(false);
      this.leggeTabella();
      this.handleBottoni["fatto"]({
        readOnly: true
      });
      this.handleBottoni["cancella"]({
        readOnly: true
      });
      this.testata = [];
      this.pagina = 1;
      this.indicePagina = 0;
      this.dettaglioAttivo = false;
      this.setState({
        modificato: false
      });

      if (this.props.location.pathname === this.props.match.url + '/dettaglio') {
        this.props.history.goBack();
      }
    }
  }, {
    key: "onReadDatabase",
    value: function onReadDatabase(risultato) {
      if (risultato.error != null) alert(risultato.error);else {
        this.setState({
          dati: risultato
        });
      }
    }
  }, {
    key: "onTabSelect",
    value: function onTabSelect(e, key) {
      if (this.dettaglioAttivo) {
        this.handleBottoni["fatto"]({
          readOnly: false
        });
        if (!this.solaLettura) this.handleBottoni["cancella"]({
          readOnly: false
        });

        if (this.state.modificato) {
          this.SalvaDati(this.currentID);
          this.inEdit(false);
        }

        if (this.modificaSubform) {
          this.subformCorrente.handle("D");
          this.modificaSubform = false;
        }

        if (this.isSubForm(key)) {
          if (this.currentID !== 0) {
            this.indicePagina = this.indici.indexOf(key);
            this.pagina = key;
            this.forceUpdate();
            this.subformCorrente = this.oggetti.GetCampo(key.substring(1));
            this.subformCorrente.handle("O", this.currentID);
          }
        } else {
          this.indicePagina = this.indici.indexOf(key);
          this.pagina = key;
          this.setState({
            modificato: false
          });
        }

        if (this.props.location.pathname === this.props.match.url + '/dettaglio/edita') {
          this.props.history.goBack();
        }
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(campo, e) {
      if (campo.handle(e.target.value)) campo.valore = e.target.value;
      this.inEdit(true);
    }
  }, {
    key: "handleChangeSelect",
    value: function handleChangeSelect(campo, e) {
      if (e == null) {
        campo.valore = null;
        campo.valoreDescrizione = "";
        campo.handle(null, "");
      } else {
        campo.valore = e.value;
        campo.valoreDescrizione = e.label;
        campo.handle(e.value, e.label);
      }

      this.inEdit(true);
    }
  }, {
    key: "handleChangeDate",
    value: function handleChangeDate(campo, value) {
      campo.valore = value;
      campo.handle(campo.valore);
      this.inEdit(true);
    }
  }, {
    key: "handleChangeImage",
    value: function handleChangeImage(campo, value) {
      campo.valore = value;
      campo.handle(campo.valore);
      this.inEdit(true);
    }
  }, {
    key: "handleChangeCheckbox",
    value: function handleChangeCheckbox(campo, e) {
      campo.valore = e.target.checked;
      campo.handle(e.target.checked);
      this.inEdit(true);
    }
  }, {
    key: "handleClickButton",
    value: function handleClickButton(campo, e) {
      campo.handle();
    }
  }, {
    key: "handleChangeSubForm",
    value: function handleChangeSubForm(campo, e) {
      if (e === 'D') {
        this.handleBottoni["memo"]({
          readOnly: true
        });
        this.handleBottoni["annulla"]({
          readOnly: true
        });
        this.modificaSubform = false;
        window.scrollTo(0, this.posCorrente);
      } else if (e === 'S') {
        this.handleBottoni["memo"]({
          readOnly: true
        });
        this.handleBottoni["annulla"]({
          readOnly: true
        });
      } else if (e === 'E') {
        this.handleBottoni["memo"]({
          readOnly: false
        });
        this.handleBottoni["annulla"]({
          readOnly: false
        });
        this.modificaSubform = true;
        window.scrollTo(0, 0);
      } else if (e === 'M') {
        this.handleBottoni["memo"]({
          readOnly: true
        });
        this.handleBottoni["annulla"]({
          readOnly: true
        });
        this.modificaSubform = true;
      } else if (e === 'C') {
        this.posCorrente = procUtils.getScrollPosition().y;
      } else if (e === 'R') {
        this.handleBottoni["memo"]({
          readOnly: true
        });
        this.handleBottoni["annulla"]({
          readOnly: true
        });
        this.modificaSubform = false;

        if (this.props.location.pathname === this.props.match.url + '/dettaglio/edita') {
          this.props.history.goBack();
        }

        window.scrollTo(0, this.posCorrente);
      }

      this.forceUpdate();
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      if (this.isSubForm(this.pagina)) {
        this.subformCorrente.handle("S", this.currentID);
      } else {
        if (this.state.modificato) {
          this.SalvaDati(this.currentID);
        }
      }

      e.preventDefault();
    }
  }, {
    key: "handleReset",
    value: function handleReset(e) {
      if (this.isSubForm(this.pagina)) {
        this.subformCorrente.handle("R", this.currentID);

        if (this.props.location.pathname === this.props.match.url + '/dettaglio/edita') {
          this.props.history.goBack();
        }
      } else {
        if (this.currentID === 0) {
          this.handleBottoni["fatto"]({
            readOnly: true
          });
          this.handleBottoni["cancella"]({
            readOnly: true
          });
          this.indicePagina = 0;
          this.pagina = 1;
          this.leggeTabella();

          if (this.props.location.pathname === this.props.match.url + '/dettaglio/edita') {
            this.props.history.goBack();
          }

          if (this.props.location.pathname === this.props.match.url + '/dettaglio') {
            this.props.history.goBack();
          }

          if (this.state.modificato) {
            this.inEdit(false);
            this.setState({
              modificato: false
            });
          }

          this.dettaglioAttivo = false;
        } else {
          this.getValues(this.currentID);

          if (this.state.modificato) {
            this.inEdit(false);
            this.setState({
              modificato: false
            });
          }
        }
      }

      if (e) e.preventDefault();
    }
  }, {
    key: "fatto",
    value: function fatto() {
      if (this.isSubForm(this.pagina) && this.modificaSubform) {
        this.subformCorrente.handle("D", this.currentID);

        if (this.props.location.pathname === this.props.match.url + '/dettaglio/edita') {
          this.props.history.goBack();
        }

        window.scrollTo(0, this.posCorrente);
      } else {
        if (this.state.modificato) {
          this.SalvaDati(this.currentID);
        }

        this.inEdit(false);
        this.handleBottoni["fatto"]({
          readOnly: true
        });
        this.handleBottoni["cancella"]({
          readOnly: true
        });
        this.testata = [];
        this.indicePagina = 0;
        this.pagina = 1;
        this.dettaglioAttivo = false;
        this.setState({
          modificato: false
        });

        if (this.props.location.pathname === this.props.match.url + '/dettaglio') {
          this.props.history.goBack();
        }

        window.scrollTo(0, this.posCorrente);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          theme = _this$props2.theme;

      if (this.state.dati === null) {
        return (
          /*#__PURE__*/
          React.createElement(Grid, {
            item: true,
            xs: 12,
            className: classes.wait
          },
          /*#__PURE__*/
          React.createElement(CircularProgress, {
            color: "secondary"
          }))
        );
      } else {
        var TabDettaglio =
        /*#__PURE__*/
        React.createElement(Tabs, {
          value: this.pagina,
          className: classes.tabs,
          variant: "scrollable",
          onChange: this.onTabSelect
        }, this.tabs);

        if (this.indicePagina > 0 && this.props.location.pathname.indexOf(this.props.match.url + '/dettaglio') === -1) {
          if (this.state.modificato) this.handleReset();else this.fatto();
        }

        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: classes.root
          },
          /*#__PURE__*/
          React.createElement(Messaggio$1, {
            open: this.state.openMsg,
            onClose: this.cancellaRecord.bind(this),
            bottoni: {
              si: "Si",
              no: "NO"
            },
            titolo: _t[gA.lingua].cancellazione,
            testo: _t[gA.lingua].confermaCancellazione
          }),
          /*#__PURE__*/
          React.createElement(Attesa$1, {
            open: this.state.openAttesa
          }),
          /*#__PURE__*/
          React.createElement(Prompt, {
            when: this.state.modificato,
            message: function message(location) {
              return _t[gA.lingua].abbandonoModifiche;
            }
          }),
          /*#__PURE__*/
          React.createElement(Paper, {
            className: classes.paper,
            elevation: 2
          }, this.testata.length === 0 ?
          /*#__PURE__*/
          React.createElement(Typography$1, {
            variant: "h5",
            component: "h3"
          }, this.oggetti.variabili.Get("titolo")) :
          /*#__PURE__*/
          React.createElement("div", null,
          /*#__PURE__*/
          React.createElement(Typography$1, {
            variant: "h6",
            component: "h5"
          }, this.oggetti.variabili.Get("titolo")), this.testata)),
          /*#__PURE__*/
          React.createElement(Switch, null,
          /*#__PURE__*/
          React.createElement(Route, {
            path: this.props.match.url + '/dettaglio',
            component: function component() {
              return TabDettaglio;
            }
          })),
          /*#__PURE__*/
          React.createElement("div", null,
          /*#__PURE__*/
          React.createElement(SwipeableViews, {
            disabled: true,
            axis: theme.direction === 'rtl' ? 'x-reverse' : 'x',
            index: this.indicePagina,
            onChangeIndex: this.handleChangeIndex
          },
          /*#__PURE__*/
          React.createElement(TabContainer, {
            dir: theme.direction
          },
          /*#__PURE__*/
          React.createElement(MaterialTable, {
            title: "",
            data: this.state.dati,
            columns: this.colonne,
            onRowClick: this.risposta,
            keyField: this.oggetti.getChiave(),
            options: {
              filtering: true,
              pageSize: 10,
              pageSizeOptions: [10, 20, 50, 100],
              showTitle: false,
              exportButton: true,
              toolbar: true,
              exportDelimiter: ";",
              headerStyle: this.headerStyle,
              padding: 'dense',
              tableLayout: 'auto'
            },
            localization: {
              body: {
                emptyDataSourceMessage: _t[gA.lingua].nodata
              }
            }
          })), this.pagine)),
          /*#__PURE__*/
          React.createElement(AppBar, {
            position: "fixed",
            color: "primary",
            className: clsx$1(classes.appBar, _defineProperty({}, classes.appBar2, this.props.openMenu))
          },
          /*#__PURE__*/
          React.createElement(Toolbar, {
            className: classes.toolbar
          }, !this.solaLettura &&
          /*#__PURE__*/
          React.createElement(GButtonBar, {
            color: "inherit",
            id: "add",
            type: "submit",
            size: "small",
            onMessage: this.getHandleButton,
            label: _t[gA.lingua].add,
            readOnly: false,
            onClick: this.nuovoElemento
          },
          /*#__PURE__*/
          React.createElement(AddIcon, {
            className: classes.rightIcon
          })),
          /*#__PURE__*/
          React.createElement(GButtonBar, {
            color: "inherit",
            id: "memo",
            type: "submit",
            size: "small",
            onMessage: this.getHandleButton,
            readOnly: true,
            label: _t[gA.lingua].memorizza,
            onClick: this.handleSubmit
          },
          /*#__PURE__*/
          React.createElement(SaveIcon, {
            className: classes.rightIcon
          })),
          /*#__PURE__*/
          React.createElement(GButtonBar, {
            color: "inherit",
            id: "annulla",
            type: "reset",
            size: "small",
            onMessage: this.getHandleButton,
            readOnly: true,
            label: _t[gA.lingua].annulla,
            onClick: this.handleReset
          },
          /*#__PURE__*/
          React.createElement(CancelIcon, {
            className: classes.rightIcon
          })),
          /*#__PURE__*/
          React.createElement(GButtonBar, {
            color: "inherit",
            id: "cancella",
            type: "fab",
            size: "small",
            onMessage: this.getHandleButton,
            readOnly: true,
            label: _t[gA.lingua].cancella,
            onClick: this.confermaCancellaRecord
          },
          /*#__PURE__*/
          React.createElement(DeleteIcon, {
            className: classes.rightIcon
          })),
          /*#__PURE__*/
          React.createElement(GButtonBar, {
            color: "inherit",
            id: "fatto",
            type: "button",
            size: "small",
            onMessage: this.getHandleButton,
            readOnly: true,
            label: _t[gA.lingua].fatto,
            onClick: this.fatto
          },
          /*#__PURE__*/
          React.createElement(DoneIcon, {
            className: classes.rightIcon
          }), " "))),
          /*#__PURE__*/
          React.createElement(Toolbar, null))
        );
      }
    }
  }]);

  return FormStd;
}(Component);

FormStd.propTypes = {
  classes: PropTypes.object.isRequired
};
var formstd = withStyles(styles$4, {
  withTheme: true
})(FormStd);

var styles$5 = function styles$5(theme) {
  return {
    root: {
      textAlign: 'left',
      padding: "5px"
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'left',
      color: theme.palette.text.secondary
    },
    rightIcon: {
      marginLeft: theme.spacing()
    },
    colxs: {
      backgroundColor: "green",
      border: "1px",
      borderColor: "white",
      borderStyle: "solid"
    },
    content: {
      width: "100%"
    },
    header: {
      backgroundColor: '#87c9ec',
      color: '#FFF'
    },
    appBar: _defineProperty({
      top: 'auto',
      bottom: 0,
      marginLeft: gA.drawerWidth
    }, theme.breakpoints.up('md'), {
      width: "calc(100% - ".concat(gA.drawerWidth, "px)")
    }),
    appBar2: {
      top: 'auto',
      bottom: 0,
      marginLeft: 0,
      width: '100%'
    },
    toolbar: {
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    tabs: {
      backgroundColor: teal[500]
    },
    wait: {
      display: 'flex',
      justifyContent: 'center',
      margin: theme.spacing(2)
    },
    separatore: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(2),
      borderBottom: '3px solid',
      width: "100%",
      padding: "0 8px 0 0"
    },
    pagina: {
      height: "100%",
      minHeight: "400px"
    }
  };
};

function TabContainer$1(_ref7) {
  var children = _ref7.children,
      dir = _ref7.dir;
  return (
    /*#__PURE__*/
    React.createElement(Typography$1, {
      component: "div",
      dir: dir
    }, children)
  );
}

TabContainer$1.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired
};
var ETipoCampo$1 = (_ETipoCampo$ = {
  ALFA: 'A',
  PASSWORD: 'O',
  NUMERO: 'N',
  INTERO: 'I',
  DATA: 'U'
}, _defineProperty(_ETipoCampo$, "DATA", 'D'), _defineProperty(_ETipoCampo$, "TAB", 'E'), _defineProperty(_ETipoCampo$, "BOOLEANO", 'L'), _defineProperty(_ETipoCampo$, "TABELLA", 'T'), _defineProperty(_ETipoCampo$, "TABELLAQUICK", 'Q'), _defineProperty(_ETipoCampo$, "MEMO", 'M'), _defineProperty(_ETipoCampo$, "IMMAGINE", 'G'), _defineProperty(_ETipoCampo$, "BLOB", 'B'), _defineProperty(_ETipoCampo$, "TELEFONICO", 'X'), _defineProperty(_ETipoCampo$, "PROCEDURA", 'P'), _defineProperty(_ETipoCampo$, "CRIPTATO", 'K'), _defineProperty(_ETipoCampo$, "NASCOSTO", 'H'), _defineProperty(_ETipoCampo$, "SEPARATORE", 'S'), _defineProperty(_ETipoCampo$, "CURRENCY", '$'), _defineProperty(_ETipoCampo$, "TABNUMERICA", 'R'), _defineProperty(_ETipoCampo$, "STAMPANTE", 'P'), _ETipoCampo$);

var TCampo$1 =
/*#__PURE__*/
function () {
  function TCampo$1() {
    _classCallCheck(this, TCampo$1);

    this.Etichetta = '';
    this.Campo = '';
    this.solocampo = '';
    this.Aiuto = '';
    this.tabellaRif = '';
    this.Picture = '';
    this.fieldMemo = '';
    this.fieldKey = '';
    this.fieldResult = '';
    this.handle = null;
    this.lhandle = null;
    this.lhandle1 = null;
    this.lhandle2 = null;
    this.handle1 = null;
    this.handle2 = null;
    this.handle3 = null;
    this.Lunghezza = 0;
    this.altezza = 0;
    this.id = 0;
    this.Valore = '';
    this.ValoreDescrizione = '';
    this.addWhere = '';
    this.modificato = false;
  }

  _createClass(TCampo$1, [{
    key: "hasFlag",
    value: function hasFlag(flag) {
      if (this.Tipo === ETipoCampo$1.TABELLAQUICK) return true;else return false;
    }
  }]);

  return TCampo$1;
}();

var FormParametri =
/*#__PURE__*/
function (_Component15) {
  _inherits(FormParametri, _Component15);

  function FormParametri(props) {
    var _this24;

    _classCallCheck(this, FormParametri);

    _this24 = _possibleConstructorReturn(this, _getPrototypeOf(FormParametri).call(this, props));

    _this24.handleChangeIndex = function (index) {
      _this24.onTabSelect(null, _this24.indici[index]);
    };

    _this24.state = {
      formPronta: false,
      pagina: 1,
      indicePagina: 0,
      modificato: false,
      openAttesa: false,
      openMsg: false
    };
    _this24.campi = null;
    _this24.indici = [];
    _this24.pagine = [];
    _this24.tabs = [];
    _this24.maxPagine = 0;
    _this24.handleBottoni = [];
    _this24.maxVisibili = 0;
    _this24.countVisibili = 0;
    _this24.CaricaCampi = _this24.CaricaCampi.bind(_assertThisInitialized(_this24));
    _this24.onMessage = _this24.onMessage.bind(_assertThisInitialized(_this24));
    _this24.getHandleButton = _this24.getHandleButton.bind(_assertThisInitialized(_this24));
    _this24.onTabSelect = _this24.onTabSelect.bind(_assertThisInitialized(_this24));
    _this24.handleChange = _this24.handleChange.bind(_assertThisInitialized(_this24));
    _this24.handleChangeCheckbox = _this24.handleChangeCheckbox.bind(_assertThisInitialized(_this24));
    _this24.handleChangeSelect = _this24.handleChangeSelect.bind(_assertThisInitialized(_this24));
    _this24.handleSubmit = _this24.handleSubmit.bind(_assertThisInitialized(_this24));
    _this24.handleReset = _this24.handleReset.bind(_assertThisInitialized(_this24));
    _this24.oggetti = new OggettiForm();
    _this24.oggetti.handle = _assertThisInitialized(_this24);
    _this24.oggetti.nomeform = 'vars';
    procUtils.asyncRequestGet('api/getallparams.php', {}).then(function (risposta) {
      return risposta.json();
    }).then(function (risposta) {
      _this24.CaricaCampi(risposta);
    }).catch(function (error) {
      console.error("Errore:", error);
    });
    return _this24;
  }

  _createClass(FormParametri, [{
    key: "GetCampo",
    value: function GetCampo(nomecampo) {
      return this.campi.find(function (e) {
        return e.Campo === nomecampo;
      });
    }
  }, {
    key: "CaricaCampi",
    value: function CaricaCampi(righe) {
      var campi = this.campi;
      var campo = null;
      campi = righe.map(function (r) {
        campo = new TCampo$1();
        campo.id = r.ID;
        campo.Etichetta = r.ETICHETTA_VARIABILE;
        campo.Campo = r.NOME_VARIABILE;
        campo.solocampo = r.NOME_VARIABILE;
        campo.Tipo = r.TIPO_VARIABILE;
        campo.Aiuto = r.AIUTO_VARIABILE;
        campo.Lunghezza = r.LUNGHEZZA_VARIABILE;

        if (r.TABELLA_CORRELATA != '') {
          var e = r.TABELLA_CORRELATA.split(',');
          campo.tabellaRif = e[0];
          campo.fieldKey = e[1];
          campo.fieldResult = e[2];
        }

        campo.Valore = r.VALORE_VARIABILE;
        campo.ValoreDescrizione = r.VALORE_DESCRIZIONE;
        campo.handle = null;
        campo.handle1 = null;
        campo.handle2 = null;
        campo.handle3 = null;
        campo.lhandle1 = null;
        campo.lhandle2 = null;
        return campo;
      });
      this.campi = campi;
      this.GeneraCampi();
      this.setState({
        formPronta: true,
        openAttesa: true
      });
    }
  }, {
    key: "GeneraCampi",
    value: function GeneraCampi() {
      var numTab = 0;
      this.maxPagine = 0;
      var elementi = [];
      var aCampi = [];
      var wCol = 50;
      var wColM = 100;
      var wS = 0;
      var wM = 0;
      var maxW = 0;
      var w = 0;
      maxW = gA.MAX_WIDTH;
      var campo;
      var _this$props3 = this.props,
          classes = _this$props3.classes,
          theme = _this$props3.theme;

      for (var i = 0; i < this.campi.length; i++) {
        campo = this.campi[i];

        if (campo.Tipo === ETipoCampo$1.TAB) {
          numTab++;
          this.maxPagine++;
          if (aCampi.length > 0) elementi.push(
          /*#__PURE__*/
          React.createElement(Grid, {
            key: i,
            container: true,
            item: true,
            xs: 12,
            sm: 12
          }, aCampi));
          elementi = [];
          aCampi = [];
          this.tabs.push(
          /*#__PURE__*/
          React.createElement(Tab, {
            key: i,
            value: numTab,
            label: campo.Etichetta
          }));
          this.indici.push(numTab);
          this.pagine.push(
          /*#__PURE__*/
          React.createElement(TabContainer$1, {
            key: 'c' + i,
            dir: theme.direction
          },
          /*#__PURE__*/
          React.createElement(Grid, {
            key: 'f' + i,
            className: classes.pagina,
            container: true
          },
          /*#__PURE__*/
          React.createElement("form", {
            key: 'ff' + i,
            autoComplete: "off",
            onSubmit: this.handleSubmit,
            onReset: this.handleReset,
            className: classes.content
          }, elementi))));
          if (process.env.NODE_ENV === 'development') procUtils.myLog("ElencoActivity(parametri): genera tab:" + campo.Etichetta);
        } else {
          w = campo.Lunghezza * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X;
          if (w > maxW) w = maxW;
          if (campo.Tipo === ETipoCampo$1.BOOLEANO) w = campo.Etichetta.length * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X + 20;else if (campo.Tipo === ETipoCampo$1.DATAORA) {
            w = wColM * 3;
          } else if (campo.Tipo === ETipoCampo$1.TABELLA) {
            w = campo.Lunghezza * gA.FATTORE_X_DETTAGLIO + gA.BORDER_X + 24;
          } else if (campo.Tipo === ETipoCampo$1.DATA) {
            w = wColM * 3;
          }
          wS = Math.floor(w / wCol);
          if (wS < 1) wS = 2;
          if (wS > 12) wS = 12;
          wM = Math.floor(w / wColM);
          if (wM < 1) wM = 1;
          if (wM > 12) wM = 12;

          if (campo.Tipo != ETipoCampo$1.NASCOSTO) {
            if (campo.Tipo === ETipoCampo$1.ALFA || campo.Tipo === ETipoCampo$1.NUMERO || campo.Tipo === ETipoCampo$1.INTERO || campo.Tipo === ETipoCampo$1.PASSWORD || campo.Tipo === ETipoCampo$1.CURRENCY) {
              var tipo = "text";
              if (campo.Tipo === ETipoCampo$1.INTERO) tipo = "number";
              if (campo.Tipo === ETipoCampo$1.CURRENCY) tipo = "currency";
              if (campo.Tipo === ETipoCampo$1.NUMERO) tipo = "number";
              if (campo.Tipo === ETipoCampo$1.PASSWORD) tipo = "password";
              aCampi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                xs: wS,
                sm: wM
              },
              /*#__PURE__*/
              React.createElement(GEdit, {
                id: campo.Campo,
                onMessage: this.onMessage,
                maxLength: campo.Lunghezza,
                name: campo.Campo,
                type: tipo,
                label: campo.Etichetta,
                help: campo.Aiuto,
                onChange: this.handleChange.bind(this, campo)
              })));
              this.maxVisibili++;
            } else if (campo.Tipo === ETipoCampo$1.DATA) {
              aCampi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                xs: wS,
                sm: wM
              },
              /*#__PURE__*/
              React.createElement(GDateTime, {
                id: campo.Campo,
                onMessage: this.onMessage,
                dateFormat: gA.formatData,
                timeFormat: "",
                label: campo.Etichetta,
                help: campo.Aiuto,
                onChange: this.handleChangeDate.bind(this, campo)
              })));
              this.maxVisibili++;
            } else if (campo.Tipo === ETipoCampo$1.TABELLA || campo.Tipo === ETipoCampo$1.TABELLAQUICK) {
              aCampi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                xs: wS,
                sm: wM
              },
              /*#__PURE__*/
              React.createElement(GSelect, {
                id: campo.Campo,
                campo: campo,
                oggetti: this.oggetti,
                onMessage: this.onMessage,
                maxLength: campo.Lunghezza,
                name: campo.Campo,
                type: "text",
                label: campo.Etichetta,
                help: campo.Aiuto,
                onChange: this.handleChangeSelect.bind(this, campo)
              })));
              this.maxVisibili++;
            } else if (campo.Tipo === ETipoCampo$1.IMMAGINE) {
              aCampi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                xs: wS,
                sm: wM
              },
              /*#__PURE__*/
              React.createElement(GImage, {
                id: campo.Campo,
                label: campo.Etichetta,
                onMessage: this.onMessage,
                help: campo.Aiuto,
                onChange: this.handleChangeImage.bind(this, campo)
              })));
              this.maxVisibili++;
            } else if (campo.Tipo === ETipoCampo$1.BOOLEANO) {
              aCampi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                xs: wS,
                sm: wM
              },
              /*#__PURE__*/
              React.createElement(GCheckbox, {
                id: campo.Campo,
                onMessage: this.onMessage,
                help: campo.Aiuto,
                name: campo.Campo,
                label: campo.Etichetta,
                onChange: this.handleChangeCheckbox.bind(this, campo)
              })));
              this.maxVisibili++;
            } else if (campo.Tipo === ETipoCampo$1.SEPARATORE) {
              aCampi.push(
              /*#__PURE__*/
              React.createElement(Grid, {
                key: i,
                item: true,
                xs: 12,
                sm: 12
              },
              /*#__PURE__*/
              React.createElement(Typography$1, {
                className: classes.separatore,
                variant: "body1",
                disabled: true,
                color: "secondary"
              }, campo.Etichetta)));
            }

            elementi.push(
            /*#__PURE__*/
            React.createElement(Grid, {
              key: 'r1' + i,
              container: true,
              item: true,
              xs: 12,
              sm: 12
            }, aCampi));
            aCampi = [];
          }
        }
      }

      if (aCampi.length > 0) elementi.push(
      /*#__PURE__*/
      React.createElement(Grid, {
        key: "max",
        container: true,
        item: true,
        xs: 12,
        sm: 12
      }, aCampi));
    }
  }, {
    key: "onMessage",
    value: function onMessage(nomecampo, handle) {
      this.GetCampo(nomecampo).handle = handle;
      this.countVisibili++;
      if (this.countVisibili === this.maxVisibili) this.InserisceValori();
    }
  }, {
    key: "getHandleButton",
    value: function getHandleButton(id, handle) {
      this.handleBottoni[id] = handle;
    }
  }, {
    key: "SalvaDati",
    value: function SalvaDati(id) {
      var _this25 = this;

      var datiCambiati = [];
      this.campi.forEach(function (campo) {
        if (campo.modificato) datiCambiati.push({
          campo: campo.Campo,
          valore: campo.Valore,
          tipo: campo.Tipo,
          id: campo.id
        });
      });
      procUtils.asyncRequestPost('api/saveparams.php', datiCambiati).then(function (risposta) {
        return risposta.json();
      }).then(function (risposta) {
        if (risposta.stato !== 'OK') {
          alert(risposta.msg);
        }

        gA.parametri.Load();

        _this25.setState({
          openAttesa: false,
          modificato: false
        });

        _this25.props.clickMenu("/");
      }).catch(function (error) {
        _this25.setState({
          openAttesa: false
        });

        console.error("Errore:", error);
      });
      this.setState({
        openAttesa: true
      });
    }
  }, {
    key: "inEdit",
    value: function inEdit(stato) {
      if (process.env.NODE_ENV === 'development') procUtils.myLog('Stato:', stato);

      if (stato === true) {
        if (!this.state.modificato) {
          this.handleBottoni["memo"]({
            readOnly: false
          });
          this.setState({
            modificato: true,
            bSalva: true
          });
        }
      } else {
        if (this.state.modificato) {
          this.handleBottoni["memo"]({
            readOnly: true
          });
          this.setState({
            modificato: false
          });
        }
      }
    }
  }, {
    key: "InserisceValori",
    value: function InserisceValori() {
      if (process.env.NODE_ENV === 'development') procUtils.myLog('Inserisce valori');
      this.campi.forEach(function (campo) {
        var dd;

        if (campo.Tipo !== ETipoCampo$1.NASCOSTO && campo.Tipo !== ETipoCampo$1.TAB && campo.Tipo !== ETipoCampo$1.SEPARATORE && campo.Tipo !== ETipoCampo$1.STAMPANTE) {
          if (campo.Valore == null) {
            campo.handle(null);
          } else {
            if (campo.Tipo === ETipoCampo$1.DATA) {
              dd = moment(procUtils.notNull(campo.Valore), 'YYYY-MM-DD HH:mm:ss');

              if (dd.isValid()) {
                campo.handle(dd);
                campo.Valore = dd;
              } else {
                campo.handle(null);
                campo.Valore = null;
              }
            } else if (campo.Tipo === ETipoCampo$1.BOOLEANO) {
              dd = parseInt(campo.Valore) === 1 ? true : false;
              campo.handle(dd);
              campo.Valore = dd;
            } else if (campo.Tipo === ETipoCampo$1.TABELLA || campo.Tipo === ETipoCampo$1.TABELLAQUICK) {
              campo.handle(campo.Valore, campo.ValoreDescrizione);
            } else campo.handle(procUtils.notNull(campo.Valore));
          }
        }
      });
      this.setState({
        openAttesa: false
      });
    }
  }, {
    key: "onTabSelect",
    value: function onTabSelect(e, key) {
      this.setState({
        pagina: key,
        indicePagina: this.indici.indexOf(key)
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(campo, e) {
      campo.Valore = e.target.value;
      campo.modificato = true;
      campo.handle(e.target.value);
      this.inEdit(true);
    }
  }, {
    key: "handleChangeSelect",
    value: function handleChangeSelect(campo, e) {
      campo.modificato = true;

      if (e == null) {
        campo.Valore = null;
        campo.valoreDescrizione = "";
        campo.handle(null, "");
      } else {
        campo.Valore = e.value;
        campo.ValoreDescrizione = e.label;
        campo.handle(e.value, e.label);
      }

      this.inEdit(true);
    }
  }, {
    key: "handleChangeDate",
    value: function handleChangeDate(campo, value) {
      campo.Valore = value;
      campo.modificato = true;
      campo.handle(campo.Valore);
      this.inEdit(true);
    }
  }, {
    key: "handleChangeImage",
    value: function handleChangeImage(campo, value) {
      campo.Valore = moment(value.target.valueAsDate);
      campo.modificato = true;
      campo.handle(campo.valore);
      this.inEdit(true);
    }
  }, {
    key: "handleChangeCheckbox",
    value: function handleChangeCheckbox(campo, e) {
      campo.Valore = e.target.checked;
      campo.modificato = true;
      campo.handle(e.target.checked);
      this.inEdit(true);
    }
  }, {
    key: "handleClickButton",
    value: function handleClickButton(campo, e) {
      campo.handle();
      campo.modificato = true;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      if (this.state.modificato) {
        this.SalvaDati(this.currentID);
      }

      e.preventDefault();
    }
  }, {
    key: "handleReset",
    value: function handleReset(e) {
      e.preventDefault();
      this.props.clickMenu("/");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          classes = _this$props4.classes,
          theme = _this$props4.theme;

      if (this.state.formPronta === false) {
        return (
          /*#__PURE__*/
          React.createElement(Grid, {
            item: true,
            xs: 12,
            className: classes.wait
          },
          /*#__PURE__*/
          React.createElement(CircularProgress, {
            color: "secondary"
          }))
        );
      } else {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: classes.root
          },
          /*#__PURE__*/
          React.createElement(Messaggio$1, {
            open: this.state.openMsg,
            onClose: null,
            bottoni: {
              si: "Si",
              no: "NO"
            },
            titolo: _t[gA.lingua].cancellazione,
            testo: _t[gA.lingua].confermaCancellazione
          }),
          /*#__PURE__*/
          React.createElement(Attesa$1, {
            open: this.state.openAttesa
          }),
          /*#__PURE__*/
          React.createElement(Prompt, {
            when: this.state.modificato,
            message: function message(location) {
              return _t[gA.lingua].abbandonoModifiche;
            }
          }),
          /*#__PURE__*/
          React.createElement(Paper, {
            className: classes.paper,
            elevation: 2
          },
          /*#__PURE__*/
          React.createElement(Typography$1, {
            variant: "h5",
            component: "h3"
          }, _t[gA.lingua].modificaParametri)),
          /*#__PURE__*/
          React.createElement(Tabs, {
            value: this.state.pagina,
            className: classes.tabs,
            variant: "scrollable",
            onChange: this.onTabSelect
          }, this.tabs),
          /*#__PURE__*/
          React.createElement("div", {
            className: classes.content
          },
          /*#__PURE__*/
          React.createElement(SwipeableViews, {
            disabled: true,
            axis: theme.direction === 'rtl' ? 'x-reverse' : 'x',
            index: this.state.indicePagina,
            onChangeIndex: this.handleChangeIndex
          }, this.pagine)),
          /*#__PURE__*/
          React.createElement(Toolbar, null),
          /*#__PURE__*/
          React.createElement(AppBar, {
            position: "fixed",
            color: "primary",
            className: clsx$1(classes.appBar, _defineProperty({}, classes.appBar2, this.props.openMenu))
          },
          /*#__PURE__*/
          React.createElement(Toolbar, {
            className: classes.toolbar
          },
          /*#__PURE__*/
          React.createElement(GButtonBar, {
            color: "inherit",
            id: "memo",
            type: "submit",
            size: "small",
            onMessage: this.getHandleButton,
            readOnly: true,
            label: _t[gA.lingua].memorizza,
            onClick: this.handleSubmit
          },
          /*#__PURE__*/
          React.createElement(SaveIcon, {
            className: classes.rightIcon
          })),
          /*#__PURE__*/
          React.createElement(GButtonBar, {
            color: "inherit",
            id: "annulla",
            type: "reset",
            size: "small",
            onMessage: this.getHandleButton,
            readOnly: false,
            label: _t[gA.lingua].annulla,
            onClick: this.handleReset
          },
          /*#__PURE__*/
          React.createElement(CancelIcon, {
            className: classes.rightIcon
          })))))
        );
      }
    }
  }]);

  return FormParametri;
}(Component);

FormParametri.propTypes = {
  classes: PropTypes.object.isRequired
};
var formparametri = withStyles(styles$5, {
  withTheme: true
})(FormParametri);
var maskDate$1 = "YYYY-MM-DD";
var maskDateTime$1 = "YYYY-MM-DDTHH:mm:ss";

var materialTheme$1 = function materialTheme$1(theme) {
  return createMuiTheme({
    palette: {
      type: theme.palette.type,
      primary: lightBlue
    }
  });
};

var styles$6 = function styles$6(theme) {
  return {
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(1),
      padding: "0 8px 0 0"
    },
    dateField: {
      marginTop: theme.spacing(0.6),
      width: "100%",
      padding: "0px 8px 0 0"
    },
    label: {
      flexDirection: 'column'
    },
    label2: {
      fontSize: "12px"
    },
    colorInput: {
      color: theme.palette.type === 'dark' ? 'white' : 'black'
    },
    input: {
      display: "flex",
      padding: 0,
      height: "auto"
    },
    valueContainer: {
      display: "flex",
      flexWrap: "wrap",
      flex: 1,
      alignItems: "center",
      overflow: "hidden"
    },
    chip: {
      margin: theme.spacing(0.5, 0.25)
    },
    chipFocused: {
      backgroundColor: emphasize(theme.palette.type === "light" ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
    },
    noOptionsMessage: {
      padding: theme.spacing(1, 2)
    },
    singleValue: {
      fontSize: 16
    },
    placeholder: {
      position: "absolute",
      left: 2,
      bottom: 6,
      fontSize: 16
    },
    paper: {
      position: "absolute",
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0
    },
    divider: {
      height: theme.spacing(2)
    }
  };
};

function NoOptionsMessage$1(props) {
  return (
    /*#__PURE__*/
    React.createElement(Typography$1, Object.assign({
      color: "textSecondary",
      className: props.selectProps.classes.noOptionsMessage
    }, props.innerProps), props.children)
  );
}

function inputComponent$1(_ref8) {
  var inputRef = _ref8.inputRef,
      props = _objectWithoutProperties(_ref8, ["inputRef"]);

  return (
    /*#__PURE__*/
    React.createElement("div", Object.assign({
      ref: inputRef
    }, props))
  );
}

function Control$1(props) {
  var children = props.children,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      _props$selectProps2 = props.selectProps,
      classes = _props$selectProps2.classes,
      TextFieldProps = _props$selectProps2.TextFieldProps;
  return (
    /*#__PURE__*/
    React.createElement(TextField, Object.assign({
      fullWidth: true,
      InputProps: {
        inputComponent: inputComponent$1,
        inputProps: _objectSpread({
          className: classes.input,
          ref: innerRef,
          children: children
        }, innerProps)
      }
    }, TextFieldProps))
  );
}

function Option$1(props) {
  return (
    /*#__PURE__*/
    React.createElement(MenuItem, Object.assign({
      ref: props.innerRef,
      selected: props.isFocused,
      component: "div",
      style: {
        fontWeight: props.isSelected ? 500 : 400
      }
    }, props.innerProps), props.children)
  );
}

function Placeholder$1(props) {
  return (
    /*#__PURE__*/
    React.createElement(Typography$1, Object.assign({
      color: "textSecondary",
      className: props.selectProps.classes.placeholder
    }, props.innerProps), props.children)
  );
}

function SingleValue$1(props) {
  return (
    /*#__PURE__*/
    React.createElement(Typography$1, Object.assign({
      className: props.selectProps.classes.singleValue
    }, props.innerProps), props.children)
  );
}

function ValueContainer$1(props) {
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: props.selectProps.classes.valueContainer
    }, props.children)
  );
}

function MultiValue$1(props) {
  return (
    /*#__PURE__*/
    React.createElement(Chip, {
      tabIndex: -1,
      label: props.children,
      className: clsx(props.selectProps.classes.chip, _defineProperty({}, props.selectProps.classes.chipFocused, props.isFocused)),
      onDelete: props.removeProps.onClick,
      deleteIcon:
      /*#__PURE__*/
      React.createElement(CancelIcon, props.removeProps)
    })
  );
}

function SMenu$1(props) {
  return (
    /*#__PURE__*/
    React.createElement(Paper, Object.assign({
      square: true,
      className: props.selectProps.classes.paper
    }, props.innerProps), props.children)
  );
}

var components$1 = {
  Control: Control$1,
  Menu: SMenu$1,
  MultiValue: MultiValue$1,
  NoOptionsMessage: NoOptionsMessage$1,
  Option: Option$1,
  Placeholder: Placeholder$1,
  SingleValue: SingleValue$1,
  ValueContainer: ValueContainer$1
};

var FSelectPure =
/*#__PURE__*/
function (_Component16) {
  _inherits(FSelectPure, _Component16);

  function FSelectPure(props) {
    var _this26;

    _classCallCheck(this, FSelectPure);

    _this26 = _possibleConstructorReturn(this, _getPrototypeOf(FSelectPure).call(this, props));
    _this26.state = {
      nomecampo: props.id,
      etichetta: props.label,
      onChange: props.onChange,
      onMessage: props.onMessage,
      maxLength: props.maxLength,
      placeholder: props.placeholder,
      readOnly: props.readOnly,
      help: props.help,
      type: props.type,
      value: "",
      valueDescr: null,
      options: []
    };
    _this26.campo = props.campo;
    _this26.sql = props.sql;
    _this26.params = props.parameters;
    _this26.db = new DBWrapper();
    _this26.chiave = props.chiave;
    _this26.risultato = props.risultato;
    _this26.getOptions = _this26.getOptions.bind(_assertThisInitialized(_this26));
    _this26.ricercaElementi = _this26.ricercaElementi.bind(_assertThisInitialized(_this26));
    _this26.risultatoRicerca = _this26.risultatoRicerca.bind(_assertThisInitialized(_this26));
    _this26.callback = null;
    _this26.input = "";
    _this26.idTime = null;
    _this26.startQuery = props.startQuery == undefined ? false : true;
    _this26.addRecord = props.addRecord == undefined ? false : true;
    _this26.onAddRecord = props.onAddRecord;
    _this26.refSelect = React.createRef();
    return _this26;
  }

  _createClass(FSelectPure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));

      if (this.startQuery) {
        this.input = "";
        this.callback = this.myCallback;
        this.ricercaElementi();
      }
    }
  }, {
    key: "onMessage",
    value: function onMessage(valore, valoreDescrizione) {
      if (this.startQuery) {
        this.setState({
          value: valore,
          valueDescr: valoreDescrizione
        });
      } else {
        if (valore == null) this.setState({
          value: null
        });else this.setState({
          value: {
            value: valore,
            label: valoreDescrizione
          },
          options: [{
            value: valore,
            label: valoreDescrizione
          }]
        });
      }
    }
  }, {
    key: "risultatoRicerca",
    value: function risultatoRicerca(risultato) {
      if (risultato.error != null) alert(risultato.error);else {
        var righe = [];

        for (var i = 0; i < risultato.length; i++) {
          righe.push({
            value: risultato[i][this.chiave],
            label: risultato[i][this.risultato]
          });
        }

        this.callback(righe, {
          options: righe,
          complete: true
        });
      }
    }
  }, {
    key: "ricercaElementi",
    value: function ricercaElementi() {
      var valore = this.params;
      valore.chiave = this.input + '%';
      this.db.rawQuery(this.risultatoRicerca, this.sql, valore);
    }
  }, {
    key: "myCallback",
    value: function myCallback(err, data) {
      this.setState({
        options: data.options
      });
    }
  }, {
    key: "getOptions",
    value: function getOptions(input, callback) {
      this.callback = callback;
      this.input = input;

      if (this.idTime != null) {
        clearTimeout(this.idTime);
        this.idTime = null;
      }

      if (input.length > 0) {
        this.idTime = setTimeout(this.ricercaElementi, 500);
      } else {
        callback(null, {
          complete: true
        });
      }
    }
  }, {
    key: "onAddRecordInternal",
    value: function onAddRecordInternal(valore) {
      this.onAddRecord(valore);
      this.refSelect.select.selectValue(valore);
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      var opzione = {};
      var placeholder = _t[gA.lingua].select;
      var Componente = Select;

      if (this.startQuery) {
        opzione = {
          loadOptions: this.getOptions
        };
        Componente = AsyncSelect;
        placeholder = _t[gA.lingua].scriviPerCercare;
      }

      if (!this.startQuery) {
        if (this.addRecord) {
          Componente = AsyncCreatable;
          opzione = {
            loadOptions: this.getOptions,
            promptTextCreator: function promptTextCreator(label) {
              return _t[gA.lingua].creaRecord + '"' + label + '"';
            },
            onNewOptionClick: this.onAddRecordInternal.bind(this)
          };
        } else {
          opzione = {
            loadOptions: this.getOptions
          };
          Componente = AsyncSelect;
          placeholder = _t[gA.lingua].scriviPerCercare;
        }
      }

      if (this.state.readOnly) {
        return (
          /*#__PURE__*/
          React.createElement(TextField, {
            id: this.state.nomecampo,
            InputProps: {
              readOnly: this.state.readOnly
            },
            value: this.state.value == null ? '' : this.state.value.label,
            className: classes.textField,
            name: this.state.nomecampo,
            placeholder: this.state.placeholder,
            label: this.state.etichetta,
            InputLabelProps: {
              shrink: true
            }
          })
        );
      } else {
        return (
          /*#__PURE__*/
          React.createElement(FormControl, {
            className: classes.textField
          },
          /*#__PURE__*/
          React.createElement(Typography$1, {
            variant: "caption",
            disabled: true
          }, this.state.etichetta),
          /*#__PURE__*/
          React.createElement(Componente, Object.assign({
            ref: this.refSelect,
            id: this.state.nomecampo,
            noOptionsMessage: function noOptionsMessage() {
              return _t[gA.lingua].noResult;
            },
            autoload: false,
            inputProps: {
              autoComplete: "off"
            },
            isClearable: true
          }, opzione, {
            options: this.state.options,
            classes: classes,
            components: components$1,
            loadingMessage: function loadingMessage() {
              return _t[gA.lingua].stoCercando;
            },
            value: this.state.value || "",
            name: this.state.nomecampo,
            placeholder: placeholder,
            onChange: this.state.onChange,
            styles: {
              input: function input() {
                return {
                  color: classes.colorInput
                };
              }
            }
          })))
        );
      }
    }
  }]);

  return FSelectPure;
}(Component);

var FCheckboxPure =
/*#__PURE__*/
function (_Component17) {
  _inherits(FCheckboxPure, _Component17);

  function FCheckboxPure(props) {
    var _this27;

    _classCallCheck(this, FCheckboxPure);

    _this27 = _possibleConstructorReturn(this, _getPrototypeOf(FCheckboxPure).call(this, props));
    _this27.state = {
      nomecampo: props.id,
      etichetta: props.label,
      onChange: props.onChange,
      readOnly: props.readOnly,
      type: props.type,
      help: props.help
    };
    return _this27;
  }

  _createClass(FCheckboxPure, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return (
        /*#__PURE__*/
        React.createElement(FormControlLabel, {
          className: classes.textField,
          variant: "caption",
          control:
          /*#__PURE__*/
          React.createElement(Checkbox, {
            id: this.state.nomecampo,
            disabled: this.state.readOnly,
            name: this.state.nomecampo,
            checked: this.props.checked,
            onChange: this.state.onChange,
            value: "checkedA"
          }),
          classes: {
            label: classes.label2
          },
          label: this.state.etichetta
        })
      );
    }
  }]);

  return FCheckboxPure;
}(Component);

var FDateTimePure =
/*#__PURE__*/
function (_Component18) {
  _inherits(FDateTimePure, _Component18);

  function FDateTimePure(props) {
    var _this28;

    _classCallCheck(this, FDateTimePure);

    _this28 = _possibleConstructorReturn(this, _getPrototypeOf(FDateTimePure).call(this, props));
    _this28.state = {
      nomecampo: props.id,
      etichetta: props.label,
      readOnly: props.readOnly,
      onChange: props.onChange,
      onMessage: props.onMessage,
      dateFormat: props.dateFormat,
      timeFormat: props.timeFormat,
      time: props.time,
      value: ""
    };
    if (_this28.state.time === undefined) _this28.mask = maskDate$1;else _this28.mask = maskDateTime$1;
    return _this28;
  }

  _createClass(FDateTimePure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.onMessage(this.state.nomecampo, this.onMessage.bind(this));
    }
  }, {
    key: "onMessage",
    value: function onMessage(valore) {
      if (this.state.readOnly) {
        this.setState({
          value: valore
        });
      } else {
        this.setState({
          value: valore
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.time !== undefined) {
        var _React$createElement;

        return (
          /*#__PURE__*/
          React.createElement(ThemeProvider, {
            theme: materialTheme$1
          },
          /*#__PURE__*/
          React.createElement(FormControl, {
            className: this.props.className
          },
          /*#__PURE__*/
          React.createElement(Typography$1, {
            variant: "caption",
            color: "textSecondary"
          }, this.state.etichetta),
          /*#__PURE__*/
          React.createElement(MuiPickersUtilsProvider, {
            utils: MomentUtils
          },
          /*#__PURE__*/
          React.createElement(KeyboardDateTimePicker, (_React$createElement = {
            value: this.state.value,
            disabled: this.state.readOnly,
            locale: gA.lingua,
            clearable: true,
            todayLabel: _t[gA.lingua].oggi,
            onChange: this.state.onChange,
            cancelLabel: _t[gA.lingua].annulla,
            clearLabel: _t[gA.lingua].cancella,
            ampm: false
          }, _defineProperty(_React$createElement, "value", this.state.value), _defineProperty(_React$createElement, "format", gA.formatData + ' ' + gA.formatTempo), _React$createElement)))))
        );
      } else {
        return (
          /*#__PURE__*/
          React.createElement(ThemeProvider, {
            theme: materialTheme$1
          },
          /*#__PURE__*/
          React.createElement(FormControl, {
            className: this.props.className
          },
          /*#__PURE__*/
          React.createElement(Typography$1, {
            variant: "caption",
            color: "textSecondary"
          }, this.state.etichetta),
          /*#__PURE__*/
          React.createElement(MuiPickersUtilsProvider, {
            utils: MomentUtils
          },
          /*#__PURE__*/
          React.createElement(KeyboardDatePicker, {
            disabled: this.state.readOnly,
            locale: gA.lingua,
            clearable: true,
            todayLabel: _t[gA.lingua].oggi,
            cancelLabel: _t[gA.lingua].annulla,
            clearLabel: _t[gA.lingua].cancella,
            value: this.state.value,
            onChange: this.state.onChange,
            format: gA.formatData
          }))))
        );
      }
    }
  }]);

  return FDateTimePure;
}(Component);

var FSelect = withStyles(styles$6)(FSelectPure);
var FCheckbox = withWidth()(withStyles(styles$6)(FCheckboxPure));
var FDateTime = withStyles(styles$6)(FDateTimePure);
export { Attesa$1 as Attesa, DBWrapper, FCheckbox, FDateTime, FSelect, formparametri as FormParametri, formstd as FormStd, GImage, GulpApp, GulpContext, Messaggio$1 as Messaggio, TAutenticazione, TParametri, _t, gA, procUtils };